<template>
  <div @mousedown="mouseDownMovie">
    <div
      v-bind:class="{ 'd-none': !editRightMouseMovieBlock.show }"
      :style="{
        'z-index': 100,
        position: 'absolute',
        left: editRightMouseMovieBlock.X,
        top: editRightMouseMovieBlock.Y,
      }"
    ></div>
    <div
      class="white-wrapper mb-4"
      @click="hideSection"
      :style="'zoom:' + zoomIndex"
    >
      <div class="row">
        <div class="col-9">
          <div class="row">
            <div class="col-lg-6 col-xl-3 d-flex">
              <div class="dropdown-curve-container">
                <multiselect
                  class="selectCinemaDandD"
                  v-model="cinemasSelected"
                  :placeholder="''"
                  :options="Cinemas"
                  :disabled="isRoleID"
                  @select="onSelectCinemaFromMultiSelect($event)"
                  label="cine_name"
                  track-by="cine_id"
                  selectLabel="Select"
                  deselectLabel="✖"
                  :multiple="false"
                ></multiselect>
                <label :class="cinemasSelected ? 'shift-up' : ''">
                  {{ $tc("cinema", 2) }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3">
              <div class="row">
                <span
                  class="date-arrow date-arrow-left"
                  @click="dateHandler('pre')"
                >
                  <img
                    src="@/assets/img/icons/left-caret.svg"
                    height="20"
                    width="20"
                  />
                </span>
                <div class="col-10">
                  <div class="input-material">
                    <div class="add-datepicker selectDandDDate">
                      <Datepicker
                        :monday-first="true"
                        typeable
                        ref="programaticOpen"
                        v-model="scheduleObject.sch_start_date"
                        name="uniquename"
                        @selected="doSomethingInParentComponentFunction"
                      ></Datepicker>
                      <label
                        :class="scheduleObject.sch_start_date ? 'active' : ''"
                        >Show Date</label
                      >
                    </div>
                    <span
                      style="
                        display: flex;
                        align-content: center;
                        justify-content: center;
                        align-items: center;
                        padding-inline: 5px;
                      "
                    >
                      ({{
                        moment(
                          scheduleObject.sch_start_date || moment()
                        ).format("dddd")
                      }}, Week
                      {{
                        moment(
                          scheduleObject.sch_start_date || moment()
                        ).format("ww")
                      }})
                    </span>
                  </div>
                </div>
                <span
                  class="date-arrow date-arrow-right"
                  @click="dateHandler('next')"
                >
                  <img
                    src="@/assets/img/icons/right-caret.svg"
                    height="20"
                    width="20"
                  />
                </span>

                <!-- <div class="col-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <Datepicker :monday-first="true"
                    ref="programaticOpen"
                    v-model="scheduleObject.sch_end_date"
                    name="uniquename"
                    @selected="doSomethingInParentComponentFunction"
                    :disabledDates="{ to: scheduleObject.sch_start_date}"
                  ></Datepicker>
                  <label
                    :class="scheduleObject.sch_end_date && typeof scheduleObject.sch_end_date === 'object' ? 'active': ''"
                  >End Date</label>
                </div>
              </div>
            </div>-->
                <div
                  v-if="isMovieSelected && isChanged && false"
                  class="px-3 d-flex align-items-center"
                >
                  <button
                    class="btn-blue mw-auto mr-3"
                    @click="submitSchedule()"
                    style="white-space: nowrap"
                  >
                    Save {{ getStatusId == 19 ? "Planned" : "" }} Schedule
                  </button>
                  <!-- <button
                class="btn-blue mw-auto mr-3"
                @click="submitScheduleAndGoBack()"
              >
                Save {{ getStatusId == 19 ? "Planned" : "" }} Schedule &amp; Go
                Back
              </button> -->
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 d-flex">
              <div class="dropdown-curve-container">
                <multiselect
                  class=""
                  :allow-empty="false"
                  v-model="showTypeFilter"
                  placeholder="Select Show Type"
                  :options="statusArrayNew"
                  @select="onSelectShowType($event)"
                  label="type"
                  track-by="type"
                  :multiple="false"
                ></multiselect>
                <label :class="showTypeFilter ? 'shift-up' : ''">
                  {{ $t("Type") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 d-flex">
              <div
                v-if="
                  isMovieSelected &&
                  isChanged &&
                  ($can('create', 'Schedule') || $can('update', 'Schedule'))
                "
                class="px-3 d-flex align-items-center"
              >
                <button
                  class="btn-blue mw-auto mr-3"
                  @click="submitSchedule()"
                  style="white-space: nowrap"
                >
                  Save {{ getStatusId == 19 ? "Planned" : "" }} Schedule
                </button>
                <!-- <button
              class="btn-blue mw-auto mr-3"
              @click="submitScheduleAndGoBack()"
            >
              Save {{ getStatusId == 19 ? "Planned" : "" }} Schedule &amp; Go
              Back
            </button> -->
              </div>
            </div>
            <b-collapse :id="'colorCodes'" class="">
              <div class="col-lg-12 col-xl-12 mt-5">
                <div class="d-flex">
                  <div
                    class="color-coding d-flex flex-wrap w-100"
                    v-if="typeList.length > 0"
                  >
                    <div
                      class="pr-3 mb-2"
                      v-for="(type, typeIndex) in typeList"
                      :key="typeIndex"
                    >
                      <div
                        class="d-flex justify-content-center align-items-center"
                      >
                        <div class="">
                          <div
                            class="color-box-2"
                            :style="'background-color:' + type.color"
                          ></div>
                        </div>
                        <div class="color-combination ml-1">
                          {{ type.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <div
                class="icon-collapse-up blue-icon mx-1 btn float-right"
                v-if="colorCollapse"
                @click="collapseColorCodes()"
                v-b-toggle="'colorCodes'"
                :title="'Schedule Overview'"
              ></div>
              <div
                class="icon-collapse blue-icon mx-1 btn float-right"
                v-if="!colorCollapse"
                @click="collapseColorCodes()"
                v-b-toggle="'colorCodes'"
                :title="'Schedule Overview'"
              ></div>
              <!-- <div
            class="icon-multischedule blue-icon mx-1 btn float-right"
            @click="duplicateSchedule()"
            :title="'Duplicate Schedule'"
          ></div> -->
              <div
                v-if="false"
                class="icon-duplicate blue-icon mx-1 btn float-right"
                @click="
                  $router.push({
                    path: 'addMultiSchedule',
                  })
                "
                :title="'Multi Schedule'"
              ></div>
              <div class="float-right p-0" v-if="false">
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="p-0 text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <span
                      class="icon-duplicate blue-icon mx-1 float-right"
                      :title="'Multi Schedule'"
                    ></span>
                  </template>
                  <b-dropdown-item
                    @click="
                      $router.push({
                        path: `${
                          $can('create', 'Schedule')
                            ? 'addMultiSchedule'
                            : '/access-denied'
                        }`,
                      })
                    "
                    :title="'Duplicate Screen Schedule'"
                  >
                    Multi Schedule
                  </b-dropdown-item>
                  <b-dropdown-item
                    :title="'Duplicate Schedule To Other Cinema'"
                    @click="
                      $router.push({
                        path: `${
                          $can('create', 'Schedule')
                            ? 'addMultiSchedule-v3'
                            : '/access-denied'
                        }`,
                      })
                    "
                  >
                    Week Wise Multi Schedule
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div
                class="icon-overview blue-icon mx-1 btn float-right"
                @click="
                  $router.push({
                    path: `${
                      $can('create', 'Schedule')
                        ? 'view-schedule-overview'
                        : '/access-denied'
                    }`,
                  })
                "
                :title="'Schedule Overview'"
              ></div>
              <div class="float-right p-0" v-if="$can('create', 'Schedule')">
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="p-0 text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <span
                      class="icon-duplicate-screen blue-icon mx-1 float-right"
                      :title="'Duplicate'"
                    ></span>
                  </template>
                  <b-dropdown-item
                    @click="onClickDuplicateScreen()"
                    :title="'Duplicate Screen Schedule'"
                  >
                    Duplicate Screen
                  </b-dropdown-item>
                  <template #button-content-day>
                    <span
                      class="icon-duplicate-screen blue-icon mx-1 float-right"
                      :title="'Duplicate Day'"
                    ></span>
                  </template>
                  <b-dropdown-item
                    @click="onClickDuplicateDay()"
                    :title="'Duplicate Screen Schedule'"
                  >
                    Duplicate Day
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="onClickDuplicateCinemaSchedule()"
                    :title="'Duplicate Schedule To Other Cinema'"
                    v-if="false"
                  >
                    Duplicate Cinema Schedule
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <!-- <div
                class="icon-duplicate-screen blue-icon mx-1 btn float-right"
                @click="onClickDuplicateScreen()"
                :title="'Duplicate Screen'"
              ></div> -->
              <template v-if="$can('create', 'Schedule')">
                <div
                  class="icon-settings blue-icon mx-1 btn float-right"
                  @click="openSettingsModal()"
                  :title="'Settings'"
                ></div>
              </template>
            </div>
            <div class="col-12" style="top: 21px">
              <div class="d-flex justify-content-end align-items-center">
                <div
                  class="zoomInBtn"
                  :class="zoomLevel == 1 ? 'disable' : ''"
                  @click="zoomIn('minus')"
                >
                  <span>-</span>
                </div>
                <div
                  class="zoomInBtn"
                  :class="zoomLevel == 3 ? 'disable' : ''"
                  @click="zoomIn('add')"
                >
                  <span>+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showScheduleCard"
      class="schedule-wrapper dnd_schedule position-relative"
      :style="'zoom:' + zoomIndex"
      @click="hideSection"
    >
      <div class="d-flex w-100">
        <div
          class="left-nav dragMovie"
          :class="!movietoggleOn ? 'movietoggleOff' : 'movietoggleOn'"
        >
          <div class="sch-header">
            <span class="mr-2" v-if="movietoggleOn">Movies</span>
            <input
              v-if="movietoggleOn"
              type="text"
              @input="onSearchScreen()"
              v-model="searchScreen"
              class="form-control form-control-sm pr-4"
              aria-label="Search"
              placeholder="Search Screen Title"
            />
          </div>
          <!-- <div>
             <b-pagination
                v-if="movieListObj.rows > 0 && movietoggleOn"
                v-model="movieListObj.currentPage"
                :total-rows="movieListObj.rows"
                :limit="3"
                @change="onChangeMovieListPagination($event)"
                :per-page="movieListObj.perPage"
                aria-controls="my-table"
                class="p-0 m-0 zoom9"
                size="sm"
              ></b-pagination>
            </div> -->
          <div class="px-3 py-2 position-relative" v-if="movietoggleOn">
            <input
              type="search"
              @keyup="onSearch()"
              @keydown="onSearch()"
              v-model="filmTitle"
              class="form-control form-control-sm pr-4"
              aria-label="Search"
              placeholder="Type a film title"
            />
            <button
              @click="getAllActiveMovies()"
              class="position-absolute btn-transparent"
              style="top: 11px; right: 15px"
            >
              <img
                src="@/assets/img/icons/search-global.svg"
                width="17"
                height="17"
              />
            </button>
          </div>
          <b-tabs
            v-if="movietoggleOn"
            content-class="pt-2"
            nav-wrapper-class="nav-underline"
          >
            <b-tab @click.prevent.stop="changeTab('Films')" title="Films">
              <div
                v-if="MoviesList && MoviesList.length > 0"
                class="oy-auto"
                style="height: calc(100vh - 225px)"
              >
                <drag
                  :class="`px-3 py-1 border-bottom ${
                    !movie.mrrdr_runtime || movie.mrrdr_runtime == 0
                      ? 'ssmv-red-color cursor-no-drop'
                      : ''
                  }`"
                  v-for="(movie, movieIndex) in MoviesList"
                  :key="movieIndex"
                  :draggable="getStatusId !== 19"
                  :transfer-data="{
                    type: 'newMovie',
                    movie: movie,
                    movieIndex: movieIndex,
                    isNoRuntime: !(
                      movie.mrrdr_runtime && movie.mrrdr_runtime != 0
                    ),
                  }"
                  :id="'movie' + (movieIndex + 1)"
                >
                  <div slot="image" class="drag-image">
                    <p
                      class="fs-14 text-truncate mb-0"
                      :title="movie.movie_name"
                    >
                      <span class="font-weight-semi-bold">{{
                        movie.movie_name
                      }}</span>
                    </p>
                    <p class="text-truncate fs-13 font-weight-bold mb-0">
                      <span
                        style="color: #7cacd3"
                        class="fs-13"
                        v-if="movie.lang_version"
                        >{{ movie.lang_version }}</span
                      >
                      <span v-if="movie.mf_name" style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span v-if="movie.mf_name" style="color: #b68bc1">{{
                        movie.mf_name
                      }}</span>
                      <span v-if="movie.movie_experience" style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span
                        v-if="movie.movie_experience"
                        style="color: #8aaf99"
                        >{{ movie.movie_experience }}</span
                      >
                      <span
                        v-if="movie.sound_format_name"
                        style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span
                        v-if="movie.sound_format_name"
                        style="color: #8aaf99"
                        >{{ movie.sound_format_name }}</span
                      >
                    </p>
                    <span class="fs-12 text-muted"
                      >R:
                      {{
                        moment(movie.original_release_date).format("DD MMM YY")
                      }}
                      |{{ movie.mrrdr_runtime }} mins</span
                    >
                  </div>
                  <p class="fs-14 text-truncate mb-0" :title="movie.movie_name">
                    <span class="font-weight-semi-bold">{{
                      movie.movie_name
                    }}</span>
                  </p>
                  <p class="text-truncate fs-13 font-weight-bold mb-0">
                    <span
                      style="color: #7cacd3"
                      class="fs-13"
                      v-if="movie.lang_version"
                      >{{ movie.lang_version }}</span
                    >
                    <span v-if="movie.mf_name" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span v-if="movie.mf_name" style="color: #b68bc1">{{
                      movie.mf_name
                    }}</span>
                    <span v-if="movie.movie_experience" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span
                      v-if="movie.movie_experience"
                      style="color: #8aaf99"
                      >{{ movie.movie_experience }}</span
                    >
                    <span v-if="movie.sound_format_name" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span
                      v-if="movie.sound_format_name"
                      style="color: #8aaf99"
                      >{{ movie.sound_format_name }}</span
                    >
                  </p>
                  <span class="fs-12 text-muted"
                    >R :
                    {{
                      moment(movie.original_release_date).format("DD MMM YY")
                    }}
                    | {{ movie.mrrdr_runtime }} mins</span
                  >
                </drag>
              </div>
              <div v-else class="text-center py-3">
                <p>No movies found.</p>
              </div>
            </b-tab>

            <b-tab
              @click.prevent.stop="changeTab('Recent')"
              active
              title="Recent"
            >
              <div
                v-if="MoviesList && MoviesList.length > 0"
                class="oy-auto"
                style="height: calc(100vh - 225px)"
              >
                <drag
                  :class="`px-3 py-1 border-bottom ${
                    !movie.mrrdr_runtime || movie.mrrdr_runtime == 0
                      ? 'ssmv-red-color cursor-no-drop'
                      : ''
                  }`"
                  v-for="(movie, movieIndex) in MoviesList"
                  :key="movieIndex"
                  :draggable="getStatusId !== 19"
                  :transfer-data="{
                    type: 'newMovie',
                    movie: movie,
                    movieIndex: movieIndex,
                    isNoRuntime: !(
                      movie.mrrdr_runtime && movie.mrrdr_runtime != 0
                    ),
                  }"
                >
                  <div slot="image" class="drag-image">
                    <p
                      class="fs-14 text-truncate mb-0"
                      :title="movie.movie_name"
                    >
                      <span class="font-weight-semi-bold">{{
                        movie.movie_name
                      }}</span>
                    </p>
                    <p class="text-truncate fs-13 font-weight-bold mb-0">
                      <span
                        style="color: #7cacd3"
                        class="fs-13"
                        v-if="movie.lang_version"
                        >{{ movie.lang_version }}</span
                      >
                      <span v-if="movie.mf_name" style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span v-if="movie.mf_name" style="color: #b68bc1">{{
                        movie.mf_name
                      }}</span>
                      <span v-if="movie.movie_experience" style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span
                        v-if="movie.movie_experience"
                        style="color: #8aaf99"
                        >{{ movie.movie_experience }}</span
                      >
                      <span
                        v-if="movie.sound_format_name"
                        style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span
                        v-if="movie.sound_format_name"
                        style="color: #8aaf99"
                        >{{ movie.sound_format_name }}</span
                      >
                    </p>
                    <span class="fs-12 text-muted"
                      >R:
                      {{
                        moment(movie.original_release_date).format("DD MMM YY")
                      }}
                      |{{ movie.mrrdr_runtime }} mins</span
                    >
                  </div>
                  <p class="fs-14 text-truncate mb-0" :title="movie.movie_name">
                    <span class="font-weight-semi-bold">{{
                      movie.movie_name
                    }}</span>
                  </p>
                  <p class="text-truncate fs-13 font-weight-bold mb-0">
                    <span
                      style="color: #7cacd3"
                      class="fs-13"
                      v-if="movie.lang_version"
                      >{{ movie.lang_version }}</span
                    >
                    <span v-if="movie.mf_name" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span v-if="movie.mf_name" style="color: #b68bc1">{{
                      movie.mf_name
                    }}</span>
                    <span v-if="movie.movie_experience" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span
                      v-if="movie.movie_experience"
                      style="color: #8aaf99"
                      >{{ movie.movie_experience }}</span
                    >
                    <span v-if="movie.sound_format_name" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span
                      v-if="movie.sound_format_name"
                      style="color: #8aaf99"
                      >{{ movie.sound_format_name }}</span
                    >
                  </p>
                  <span class="fs-12 text-muted"
                    >R :
                    {{
                      moment(movie.original_release_date).format("DD MMM YY")
                    }}
                    | {{ movie.mrrdr_runtime }} mins</span
                  >
                </drag>
              </div>
              <div v-else>
                <p>No recent movies found.</p>
              </div>
            </b-tab>
            <b-tab
              @click.prevent.stop="changeTab('Scheduled')"
              title="Scheduled"
            >
              <div
                v-if="MoviesList && MoviesList.length > 0"
                class="oy-auto"
                style="height: calc(100vh - 225px)"
              >
                <drag
                  :class="`px-3 py-1 border-bottom ${
                    !movie.mrrdr_runtime || movie.mrrdr_runtime == 0
                      ? 'ssmv-red-color cursor-no-drop'
                      : ''
                  }`"
                  v-for="(movie, movieIndex) in MoviesList"
                  :key="movieIndex"
                  :draggable="getStatusId !== 19"
                  :transfer-data="{
                    type: 'newMovie',
                    movie: movie,
                    movieIndex: movieIndex,
                    isNoRuntime: !(
                      movie.mrrdr_runtime && movie.mrrdr_runtime != 0
                    ),
                  }"
                >
                  <div slot="image" class="drag-image">
                    <p
                      class="fs-14 text-truncate mb-0"
                      :title="movie.movie_name"
                    >
                      <span class="font-weight-semi-bold">{{
                        movie.movie_name
                      }}</span>
                    </p>
                    <p class="text-truncate fs-13 font-weight-bold mb-0">
                      <span
                        style="color: #7cacd3"
                        class="fs-13"
                        v-if="movie.lang_version"
                        >{{ movie.lang_version }}</span
                      >
                      <span v-if="movie.mf_name" style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span v-if="movie.mf_name" style="color: #b68bc1">{{
                        movie.mf_name
                      }}</span>
                      <span v-if="movie.movie_experience" style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span
                        v-if="movie.movie_experience"
                        style="color: #8aaf99"
                        >{{ movie.movie_experience }}</span
                      >
                      <span
                        v-if="movie.sound_format_name"
                        style="color: #3876d2"
                        >&nbsp;|&nbsp;</span
                      >
                      <span
                        v-if="movie.sound_format_name"
                        style="color: #8aaf99"
                        >{{ movie.sound_format_name }}</span
                      >
                    </p>
                    <span class="fs-12 text-muted"
                      >R:
                      {{
                        moment(movie.original_release_date).format("DD MMM YY")
                      }}
                      |{{ movie.mrrdr_runtime }} mins</span
                    >
                  </div>
                  <p class="fs-14 text-truncate mb-0" :title="movie.movie_name">
                    <span class="font-weight-semi-bold">{{
                      movie.movie_name
                    }}</span>
                  </p>
                  <p class="text-truncate fs-13 font-weight-bold mb-0">
                    <span
                      style="color: #7cacd3"
                      class="fs-13"
                      v-if="movie.lang_version"
                      >{{ movie.lang_version }}</span
                    >
                    <span v-if="movie.mf_name" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span v-if="movie.mf_name" style="color: #b68bc1">{{
                      movie.mf_name
                    }}</span>
                    <span v-if="movie.movie_experience" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span
                      v-if="movie.movie_experience"
                      style="color: #8aaf99"
                      >{{ movie.movie_experience }}</span
                    >
                    <span v-if="movie.sound_format_name" style="color: #3876d2"
                      >&nbsp;|&nbsp;</span
                    >
                    <span
                      v-if="movie.sound_format_name"
                      style="color: #8aaf99"
                      >{{ movie.sound_format_name }}</span
                    >
                  </p>
                  <span class="fs-12 text-muted"
                    >R :
                    {{
                      moment(movie.original_release_date).format("DD MMM YY")
                    }}
                    | {{ movie.mrrdr_runtime }} mins</span
                  >
                </drag>
              </div>
              <div v-else>
                <p>No scheduled movies found.</p>
              </div>
            </b-tab>
          </b-tabs>
          <div class="py-2">
            <b-pagination
              v-if="movieListObj.rows > 0 && movietoggleOn"
              v-model="movieListObj.currentPage"
              :total-rows="movieListObj.rows"
              :limit="3"
              @change="onChangeMovieListPagination($event)"
              :per-page="movieListObj.perPage"
              aria-controls="my-table"
              class="p-0 m-0 zoom9"
              size="sm"
            ></b-pagination>
          </div>
        </div>

        <!-- TIME SCHEDULER     -->
        <div class="right-nav d-flex" @scroll="scrolfun">
          <!-- <div class="schedule-screen-list-wrapper"> -->
          <div class="outerWrapperToogle" v-if="$can('create', 'Schedule')">
            <button
              class="movie-sidebar-toggler inner"
              v-on:click="toggleSidebar()"
              v-if="!movietoggleOn"
            >
              <span>+</span>
            </button>
            <button
              class="movie-sidebar-toggler inner"
              v-on:click="toggleSidebar()"
              v-if="movietoggleOn"
            >
              <span>-</span>
            </button>
          </div>
          <div
            v-on:dragenter="dragEnd()"
            class="schedule-screen-list-wrapper pr-1"
          >
            <!---:style="'z-index: 100'"-->
            <div
              v-on:dragenter="dragEnd()"
              class="schedule-screen-name-new screenName"
              :style="
                screen.totalSeatLayout <= 0
                  ? 'background-color:red;color:white'
                  : ''
              "
              v-for="(screen, screenIndex) in ScreenList"
              :key="screenIndex"
              v-if="screen.view && checkScreenValidity(screen)"
            >
              <div
                class="screen_name_inner_wrapper"
                :style="
                  screen.totalSeatLayout <= 0
                    ? 'background-color:red;color:white; z-index: 360'
                    : 'z-index: 360'
                "
              >
                <span
                  :style="'white-space: nowrap;'"
                  class="font-weight-bold"
                  v-b-tooltip.hover
                  :title="screen.screen_name"
                  >{{ screen.screen_name }}</span
                >
                <br />
                <span class="">
                  {{ screen.screen_type_name || "" }}
                </span>
                <br />
                <span
                  :style="'white-space: nowrap;'"
                  class="fs-12"
                  v-b-tooltip.hover
                  :title="
                    screen.soundFormats
                      .map((z) => z.sound_format_name)
                      .join(', ')
                  "
                  >{{
                    screen.soundFormats.length > 0
                      ? screen.soundFormats
                          .map((z) => z.sound_format_name)
                          .join(", ")
                      : ""
                  }}</span
                >
                <br />
                <span
                  :style="'white-space: nowrap;'"
                  class="fs-12"
                  v-b-tooltip.hover
                  :title="screen.videoFormats.map((z) => z.mf_name).join(', ')"
                  >{{
                    screen.videoFormats.length > 0
                      ? screen.videoFormats.map((z) => z.mf_name).join(", ")
                      : ""
                  }}</span
                >
              </div>
            </div>
          </div>

          <div class="screen-time-wrapper">
            <div
              class="drag-line"
              v-bind:class="{ 'd-none': String(dropLocation.screen) == '-1' }"
              :style="
                'left :' +
                dropLocation.positionLeft +
                'px;top:' +
                (topValue + 40) +
                'px'
              "
            >
              <span>{{ dropLocation.time }}</span>
            </div>
            <div
              v-if="checkExist()"
              class="drag-line"
              v-b-tooltip.hover
              :title="`Current Time ${getCurrentTimeBar().currentTime}`"
              :style="
                'left :' +
                getCurrentTimeBar().positionLeft +
                'px;height:' +
                111 * ScreenList.length +
                'px;z-index: 36 !important;'
              "
            >
              <!-- <span
                v-b-tooltip.hover
                :style="
                  'font-weight: 500;position: absolute;color:red;' +
                    'top:' +
                    (topValue - 20) +
                    'px'
                "
                :title="`Current Time ${getCurrentTimeBar().currentTime}`"
              >
                {{ getCurrentTimeBar().currentTime }}</span
              > -->
            </div>
            <div
              class="drag-line"
              v-bind:class="{ 'd-none': String(dropLocation.screen) == '-1' }"
              :style="
                'left :' +
                dropLocation.positionLeftEndTime +
                'px;top:' +
                (topValue + 40) +
                'px'
              "
            >
              <span>{{ dropLocation.time }}</span>
            </div>
            <div class="screen-timing-header" v-on:dragenter="dragEnd()">
              <!-- :style="'top:' + topValue + 'px;'" -->
              <!-- <button
                class="movie-sidebar-toggler inner"
                v-on:click="toggleSidebar()"
                v-if="!movietoggleOn"
              >
                <span></span>
                <span></span>
                <span></span>
              </button> -->

              <span
                v-b-tooltip.hover
                :style="
                  'font-weight: 500;position: absolute;color:red;top: 20px;' +
                  'left:' +
                  getCurrentTimeBar().positionLeft +
                  'px;'
                "
                :title="`Current Time ${getCurrentTimeBar().currentTime}`"
              >
                {{ getCurrentTimeBar().currentTime }}</span
              >

              <div
                class="hour-box-header-dd"
                v-for="(timeHeader, timeHeaderIndex) in intervalsArray"
                :key="timeHeaderIndex"
              >
                <strong>{{ timeHeader.split(" ")[1] }}</strong>
                <div class="minutes-bar-dd"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar h-75"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar"></div>
                <div class="minutes-bar border-0"></div>
              </div>
            </div>

            <div
              class="schedule-screen-row"
              v-for="(screen, screenIndex) in ScreenList"
              v-if="screen.view && checkScreenValidity(screen)"
              v-bind:class="
                dropLocation.screen == screenIndex ? 'selectedScreen' : ''
              "
              :key="screenIndex"
              :id="'movieCardWrapper' + screenIndex"
            >
              <div
                v-if="
                  selectedMoviesInScreens.length > 0 &&
                  selectedMoviesInScreens[screenIndex].hasOwnProperty(
                    'movies'
                  ) &&
                  selectedMoviesInScreens[screenIndex].movies.length
                "
              >
                <drag
                  v-for="(
                    screenMovie, screenMovieIndex
                  ) in selectedMoviesInScreens[screenIndex].movies"
                  :key="'index' + screenIndex + screenMovieIndex"
                  :transfer-data="{
                    type: 'presentMovie',
                    movie: screenMovie,
                    screenMovieIndex,
                    screenIndex,
                  }"
                  @dragstart="startDrag(screenIndex, screenMovieIndex)"
                  v-bind:style="{
                    width: getWidth(screenMovie) + 'px',
                    left: screenMovie.start + 'px',
                    'z-index': 35,
                  }"
                  :class="[
                    'movie-horizontal-card',
                    screenMovie.selected == true ? 'selected-movie-card' : '',
                  ]"
                >
                  <div slot="image" class="drag-image" width="150px">
                    <div class="schedule-content">
                      <!-- <strong class="fs-12 d-block">10:00AM - 3:00AM</strong> -->
                      <strong class="fs-18 d-block text-truncate my-3">{{
                        screenMovie.movie || screenMovie.movie_title
                      }}</strong>
                      <div>
                        <small class="d-block">
                          <span>{{ screenMovie.mf_name }}</span>
                          {{ screenMovie.lang_name }}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div
                    @mousedown="mouseDownMovie"
                    v-on-clickaway="away"
                    v-on:click="
                      onSelectMovie($event, screenIndex, screenMovieIndex)
                    "
                    :id="`schedule-card${screenIndex}${screenMovieIndex}`"
                    v-if="screenMovie.ss_show_status != 17"
                    :class="[
                      'schedule-card ',
                      'new-schedule-card ',
                      screenMovie.mycinema_booking_type_id == 3
                        ? 'status-private'
                        : screenMovie.ss_show_status == 19
                        ? ' status-yellow-2'
                        : screenMovie.ss_show_status == 13
                        ? 'status-grey-2'
                        : !screenMovie.isNewSchedule
                        ? ' status-green-2'
                        : !screenMovie.isReady
                        ? ' status-red-2'
                        : ' status-lightgreen-2 dsadsa',
                      screenMovie.is_sch_disable == 'Y' ? 'status-grey-2' : '',
                      checkIndicator(screenMovie) ? 'indicator-border-sch' : '',
                    ]"
                    :style="
                      'width:' +
                      getWidth(screenMovie) +
                      ';background:' +
                      getCardColor(screenMovie) +
                      '!important;'
                    "
                  >
                    <!-- ADD CLASS 'border-left-green, border-left-orange, border-left-blue, border-left-grey, border-left-red' -->
                    <div
                      class="d-flex align-items-center"
                      v-b-popover.hover.leftbottom="{
                        title: `<div class='fs-14'> ${
                          screenMovie.movie || screenMovie.movie_title
                        }</div>`,
                        customClass: `my-popover-class ${getPopOverClassName(
                          screenMovie
                        )}`,
                        container: `movieCardWrapper${screenIndex}`,
                        content: `
                          <div class='row fs-13'>
                          <div class='col-4 mr-0 pr-0'><b>Show Time<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            screenMovie.ss_start_show_time ||
                            screenMovie.start_time
                          }-${
                          screenMovie.ss_end_show_time || screenMovie.end_time
                        }</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${getShowDateForNewSchedule(
                            screenMovie
                          )}</div>
                          <div class='col-4 mr-0 pr-0'><b>Duration<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            screenMovie.mrrdr_runtime || '-'
                          } mins</div>
                          <div class='col-4 mr-0 pr-0'><b>Sound Format<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            screenMovie.sound_format_name || '-'
                          }</div>
                          ${
                            screenMovie.isNewSchedule
                              ? ``
                              : `
                          <div class='col-4 mr-0 pr-0'><b>Occupancy<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${screenMovie.booked_seats} Booked/ ${screenMovie.unpaid_count} Unpaid/ ${screenMovie.screen_total_seats} Seats</div>
                          `
                          }
                          ${
                            screenMovie.ss_comment
                              ? `
                          <div class='col-4 mr-0 pr-0'><b>Comment<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${screenMovie.ss_comment}</div>
                          `
                              : ``
                          }
                          ${
                            screenMovie.sales_channel &&
                            screenMovie.sales_channel.length > 0
                              ? `
                          <div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0 mt-3'>${screenMovie.sales_channel
                            .map((x) => x.username)
                            .join(', ')}</div>
                          `
                              : `<div class='col-4 mr-0 pr-0 mt-3'><b>Sales Channel<span class='float-right mr-2'>:</span></b></div>
                              <div class='col-8 ml-0 pl-0 mt-3 text-danger'>Not Selected</div>`
                          }
                           ${
                             screenMovie.AddonsName &&
                             screenMovie.AddonsName.length > 0
                               ? `
                          <div class='col-4 mr-0 pr-0'><b>Addon Charges <span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${screenMovie.AddonsName.join(
                            ', '
                          )}</div>
                          `
                               : ``
                           }
                           ${
                             screenMovie.scheduleShowPrice &&
                             screenMovie.scheduleShowPrice.length > 0
                               ? `
                          <div class='col-4 mr-0 pr-0'><b>Rate Cards <span class='float-right mr-2'>:</span></b></div>
                          <div class='col-8 ml-0 pl-0'>${getAllRateCardName(
                            screenMovie.scheduleShowPrice
                          )}</div>
                          `
                               : ``
                           }
                          </div>
                          `,
                        html: true,
                      }"
                    >
                      <!-- :title="`
                      ${screenMovie.start_time}-${screenMovie.end_time}

                      `" -->
                      <div class="w-100">
                        <!-- //TODO - make AM/PM -->

                        <span class="fs-12 d-block text-truncate-2 movieTitle"
                          >{{ screenMovie.start_time }}-{{
                            screenMovie.end_time
                          }}</span
                        >
                        <p
                          class="fs-12 d-block text-truncate-2 movieTitle my-1"
                        >
                          {{ screenMovie.movie || screenMovie.movie_title }}
                        </p>

                        <small class="text-truncate-2 my-1 d-block ws-nowarp">
                          <span>{{ screenMovie.mf_name }}</span>
                          {{ screenMovie.lang_name }}
                        </small>
                        <small
                          class="text-truncate-2 my-1 d-block ws-nowarp"
                          v-if="
                            !screenMovie.isCrowdSource &&
                            screenMovie.mycinema_booking_type_id != 3 &&
                            !screenMovie.isNewSchedule
                          "
                        >
                          <span
                            >({{ screenMovie.booked_seats }} /
                            {{ screenMovie.unpaid_count }} /
                            {{ screenMovie.screen_total_seats }} Seats)</span
                          >
                        </small>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="screenMovie.ss_show_status == 17"
                    class="schedule-card"
                    :style="'width:' + getWidth(screenMovie) + '!important;'"
                    @click="onClickViewDeletedScheduleDetails(screenMovie)"
                  >
                    <div class="d-flex align-items-center">
                      <div
                        class="w-100"
                        v-b-popover.hover.leftbottom="{
                          title: `<div class='fs-14'> ${screenMovie.movie}</div>`,
                          customClass: 'my-popover-class',
                          container: `movieCardWrapper${screenIndex}`,
                          content: `
                          <div class='row fs-13'>
                            <div class='col-4 mr-0 pr-0'><b>Status:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${'Deleted'}</div>
                          <div class='col-4 mr-0 pr-0'><b>Show Time:</b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            screenMovie.ss_start_show_time ||
                            screenMovie.start_time
                          }-${
                            screenMovie.ss_end_show_time || screenMovie.end_time
                          }</div>
                          <div class='col-4 mr-0 pr-0'><b>Show Day/Date:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${getShowDateForNewSchedule(
                            screenMovie
                          )}</div>
                          <div class='col-4 mr-0 pr-0'><b>Reason:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${
                            screenMovie.scd_reason
                          }</div>
                          <div class='col-4 mr-0 pr-0'><b>Deleted By:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${
                            screenMovie.scd_created_by
                          }</div>
                          <div class='col-4 mr-0 pr-0'><b>Deleted At:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${
                            screenMovie.deleted_at
                          }</div>
                          `,
                          html: true,
                        }"
                      >
                        <span
                          class="fs-12 d-block font-weight-bold"
                          v-b-tooltip.hover
                          :title="`${screenMovie.start_time}-${screenMovie.end_time}
                          `"
                          ><del
                            >{{ screenMovie.start_time }}-{{
                              screenMovie.end_time
                            }}</del
                          ></span
                        >

                        <p
                          class="fs-12 d-block text-truncate-2 movieTitle my-1"
                          v-b-tooltip.hover
                          :title="screenMovie.movie"
                        >
                          <del>{{
                            screenMovie.movie || screenMovie.movie_title
                          }}</del>
                        </p>
                        <small class="text-truncate-2 my-1 d-block ws-nowarp">
                          <del
                            ><span>{{ screenMovie.mf_name }}</span>
                            {{ screenMovie.lang_name }}</del
                          >
                        </small>
                        <p
                          class="fs-12 d-block text-truncate-2 movieTitle my-1"
                          v-b-tooltip.hover
                          :title="`Reason: ${screenMovie.scd_reason}`"
                          v-if="screenMovie.scd_reason && false"
                        >
                          Reason : {{ screenMovie.scd_reason }}
                        </p>
                        <p
                          class="fs-12 d-block text-truncate-2 movieTitle my-1"
                          v-b-tooltip.hover
                          :title="`Deleted By: ${screenMovie.scd_created_by}`"
                          v-if="screenMovie.scd_created_by && false"
                        >
                          Deleted By : {{ screenMovie.scd_created_by }}
                        </p>
                      </div>
                    </div>
                  </div>
                </drag>
              </div>
              <div
                class="hour-box-dd"
                v-for="(hourofDay, hourofDayIndex) in intervalsArray"
                :key="hourofDayIndex"
              >
                <drop
                  class="minutes-bar drop"
                  v-for="(minutes, minutesIndex) in 12"
                  :key="'index' + screenIndex + minutesIndex"
                  @drop="handleDrop"
                  @dragenter="
                    (transferData) =>
                      dragEnter(
                        screenIndex,
                        hourofDay.split(' ')[1],
                        minutes,
                        hourofDayIndex,
                        hourofDay,
                        transferData
                      )
                  "
                ></drop>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PRICE CARD FOOTER -->
    <div
      v-if="isMovieCardSelected && showFooterDetails"
      class="schedule-info-sticky"
      :id="`Sticky-${movieSelected.start_time}${movieSelected.screen}`"
      v-b-popover.manual.top="{
        customClass: `my-popover-class no_rc_popover`,
        disabled: checkNoRateCard(movieSelected),
        variant: 'danger',
        id: `Popover-${movieSelected.start_time}${movieSelected.screen}`,
        container: `Sticky-${movieSelected.start_time}${movieSelected.screen}`,
        content: `
                          <div class='fs-18 text-center w-100 mx-auto'>
                            <div class='text-danger w-100 font-weight-bold'>
                              Warning!
                            </div>
                            <div class='w-100 text-danger'>
                              <p>Please Select Rate Card</p>
                            </div>
                          </div>
                          `,
        html: true,
      }"
    >
      <div class="row flex-nowrap align-items-center">
        <div class="col-3 align-self-center">
          <p class="mb-0 text-truncate" :title="movieSelected.movie">
            {{ movieSelected.movie || movieSelected.movie_title }}
          </p>
          <span class="fs-14"
            >Duration: {{ movieSelected.start_time }} -
            {{ movieSelected.end_time }}</span
          >
        </div>
        <div
          v-if="movieSelected.mycinema_booking_type_id !== 3"
          v-for="(screenType, screenTypeIndex) in selectedScreenSeatTypes"
          :key="screenTypeIndex"
          class="col border-left"
        >
          <div
            @click="!isPastShow && onSelectScreenType(screenTypeIndex)"
            class="custom-caret position-relative"
            :class="{ 'disabled-dropdown': isPastShow }"
            :style="
              isPastShow
                ? 'pointer-events: none; opacity: 0.6; cursor: not-allowed;'
                : ''
            "
          >
            <span class="fs-14 font-weight-semi-bold">{{
              screenType.sst_seat_type
            }}</span>
            <p
              class="mb-0 lh-1 text-truncate"
              :title="getRateCardNameonHover(screenTypeIndex)"
              :style="'max-width:100px'"
            >
              <span
                v-if="
                  selectedScreenIndex != null &&
                  selectedScreenIndex != -1 &&
                  selectedMovieIndex != null &&
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ] &&
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ].scheduleShowPrice.length > 0 &&
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ].scheduleShowPrice[screenTypeIndex] &&
                  (selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ].scheduleShowPrice[screenTypeIndex].rate_card_name ||
                    selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ].scheduleShowPrice[screenTypeIndex].rc_name)
                "
                :class="
                  checkDefaultRateCard(
                    selectedMoviesInScreens[selectedScreenIndex].movies[
                      selectedMovieIndex
                    ].scheduleShowPrice[screenTypeIndex]
                  )
                    ? 'defaultRateCardSelecttext'
                    : ''
                "
                >({{
                  selectedMoviesInScreens[selectedScreenIndex].movies[
                    selectedMovieIndex
                  ].scheduleShowPrice[screenTypeIndex].rate_card_name
                    ? selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[screenTypeIndex].rate_card_name
                    : selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[screenTypeIndex].rc_name
                    ? selectedMoviesInScreens[selectedScreenIndex].movies[
                        selectedMovieIndex
                      ].scheduleShowPrice[screenTypeIndex].rc_name
                    : ""
                }})</span
              >
              <span v-else class="text-danger">No Rate Card Attached</span>
            </p>
          </div>
          <div
            v-if="screenTypeIndex == selectedScreenTypeIndex"
            class="schedule-price-dropdown"
            tabindex="100"
          >
            <div
              v-if="
                movieSelected &&
                movieSelected['scheduleShowPrice'] &&
                movieSelected['scheduleShowPrice'].length > 0
              "
              class="px-2 pt-2 pb-2"
            >
              <input
                required
                autofocus
                type="search"
                placeholder="Search Rate Card Group"
                class="form-control form-control-sm"
                v-on:keyup="
                  onSearchRateCard(screenTypeIndex, $event.target.value)
                "
                v-on:keydown="
                  onSearchRateCard(screenTypeIndex, $event.target.value)
                "
                v-model="
                  movieSelected.scheduleShowPrice[screenTypeIndex]
                    .searchRateCard
                "
              />
            </div>
            <div
              class="p-2 cursor-pointer hover-card-list"
              v-for="(Ratecard, RatecardIndex) in filteredRateCardList(
                selectedScreen,
                screenType,
                RatecardsList
              )"
              :key="RatecardIndex"
              @click="
                onSelectRateCard(screenTypeIndex, screenType, Ratecard);
                onChangeRateCardSticky(screenTypeIndex, screenType, Ratecard);
              "
              :class="
                Ratecard.rc_name ===
                  selectedMoviesInScreens[selectedScreenIndex] &&
                selectedMoviesInScreens[selectedScreenIndex].movies[
                  selectedMovieIndex
                ] &&
                selectedMoviesInScreens[selectedScreenIndex].movies[
                  selectedMovieIndex
                ].scheduleShowPrice[screenTypeIndex].rc_name &&
                'hover-card-list'
              "
            >
              {{ Ratecard.rc_g_name }}
            </div>
          </div>
        </div>
        <div
          class="col-2 border-left"
          v-if="movieSelected.mycinema_booking_type_id !== 3"
          @click="checkStartTimeChageAllowed(movieSelected)"
        >
          <b-dropdown
            size="sm"
            variant="transparent text-left"
            class="w-100 custom-caret"
            no-caret
            :disabled="
              checkStartTimeChageAllowed(movieSelected, false) || isPastShow
            "
          >
            <template v-slot:button-content>
              <div>
                <span class="fs-12 text-muted">Schedule Type</span>
                <p class="mb-0 lh-1">{{ selectedStatus }}</p>
              </div>
            </template>
            <b-dropdown-item
              v-for="(status, statusIndex) in scheduleStatusArray"
              :key="statusIndex"
              v-on:click="onSelectStatus($event, status)"
              >{{ status.type }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <div
          v-if="
            !movieSelected.isNewSchedule &&
            movieSelected.mycinema_booking_type_id !== 3 &&
            false
          "
          class="col-2 border-left"
        >
          <button
            class="btn btn-white mw-auto btn-sm"
            @click="onClickupdateRateCard()"
          >
            Update Price
          </button>
        </div>

        <div
          v-if="movieSelected.mycinema_booking_type_id === 3"
          class="d-flex justify-content-center align-items-center flex-grow-1"
        >
          Private Show
        </div>

        <div
          v-if="movieSelected.mycinema_booking_type_id === 3"
          class="d-flex justify-content-center align-items-center flex-grow-1"
        >
          <button
            class="btn btn-white mw-auto btn-sm"
            @click="showAdmitModal(movieSelected)"
          >
            Update Admits
          </button>
        </div>

        <div
          class="col-1 border-left"
          v-if="$can('delete', 'Schedule') && !isPastShow"
        >
          <button
            v-on:click="
              onDeleteMovieModal(
                selectedScreen,
                movieSelected,
                selectedScreenIndex,
                selectedMovieIndex
              )
            "
            class="btn-schedule-delete"
          >
            <img
              src="@/assets/img/icons/delete-red.svg"
              height="25"
              width="25"
              alt
            />
          </button>
        </div>
        <b-dropdown
          right
          variant="edit"
          id="dropdown-dropup"
          boundary="viewport"
          class="mr-3"
          size="sm"
          v-if="!movieSelected.isNewSchedule"
        >
          <b-dropdown-item
            @click="onClickViewSeatLayout(movieSelected)"
            v-if="movieSelected.mycinema_booking_type_id != 3"
            >View Seat Layout</b-dropdown-item
          >
          <b-dropdown-item
            @click="onEditMovie(movieSelected, selectedScreen)"
            v-if="
              movieSelected.ss_show_status != '13' &&
              movieSelected.mycinema_booking_type_id != 3 &&
              $can('update', 'Schedule') &&
              !isPastShow
            "
            >Edit</b-dropdown-item
          >
          <b-dropdown-item
            @click="onEditMovie(movieSelected, selectedScreen)"
            v-else
            >View</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              movieSelected.is_sch_disable &&
              movieSelected.ss_show_status != '13' &&
              movieSelected.mycinema_booking_type_id != 3 &&
              $can('update', 'Schedule') &&
              !isPastShow
            "
            v-on:click="onClickEnableDisableSchedule(movieSelected)"
            >{{
              movieSelected.is_sch_disable == "N"
                ? "Disable Schedule"
                : "Enable Schedule"
            }}</b-dropdown-item
          >
          <!-- <b-dropdown-item
            @click="
              $router.push({
                name: 'Access Rights For Schedule',
                query: {
                  md_id: movieSelected.md_id,
                  date: moment(movieSelected.ss_start_date).format(
                    'YYYY-MM-DD'
                  ),
                },
              })
            "
            >Edit Sales Channel</b-dropdown-item
          > -->
          <b-dropdown-item
            v-if="
              movieSelected.mycinema_booking_type_id != 3 &&
              $can('update', 'Schedule') &&
              !isPastShow
            "
            @click="onClickDuplicateSingleSchedule(movieSelected)"
            >Duplicate Schedule</b-dropdown-item
          >
          <!-- <b-dropdown-item
            v-if="movieSelected.ss_show_status != '13' && movieSelected.mycinema_booking_type_id != 3"
            v-on:click="
              onClickEnableDisableSchedule(movieSelected)
            "
            >{{
              movieSelected.is_sch_disable == "N"
                ? "Disable Schedule"
                : "Enable Schedule"
            }}</b-dropdown-item
          > -->
          <b-dropdown-item
            v-if="
              (movieSelected.booked_seats > 0 ||
                movieSelected.unpaid_count > 0) &&
              movieSelected.ss_show_status != '13' &&
              movieSelected.mycinema_booking_type_id != 3
            "
            @click="onClickSwapAuditorium(movieSelected, 1)"
            >Swap Auditorium</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              (movieSelected.booked_seats > 0 ||
                movieSelected.unpaid_count > 0) &&
              movieSelected.ss_show_status != '13' &&
              movieSelected.mycinema_booking_type_id != 3
            "
            @click="onClickSwapAuditorium(movieSelected, 2)"
            >Merge Show</b-dropdown-item
          >
          <b-dropdown-item
            @click="
              $can('read', 'Transactions')
                ? $router.push({
                    name: 'Transactions',
                    query: {
                      cinema_id: selectedScreen.cinema_id,
                      date: moment(movieSelected.ss_start_date).format(
                        'YYYY-MM-DD'
                      ),
                      md_id: movieSelected.md_id,
                      ss_id: movieSelected.ss_id,
                    },
                  })
                : $router.push({
                    path: '/access-denied',
                  })
            "
            >View Transactions</b-dropdown-item
          >
          <b-dropdown-item
            @click="
              $can('read', 'Unpaid Booking')
                ? $router.push({
                    name: 'Unpaid Bookings',
                    query: {
                      cinema_id: selectedScreen.cinema_id,
                      date: moment(movieSelected.ss_start_date).format(
                        'YYYY-MM-DD'
                      ),
                      md_id: movieSelected.md_id,
                      ss_id: movieSelected.ss_id,
                    },
                  })
                : $router.push({
                    path: '/access-denied',
                  })
            "
            >View Unpaid Bookings</b-dropdown-item
          >
          <b-dropdown-item
            v-if="movieSelected.mycinema_booking_type_id == 3"
            @click="showAdmitModal(movieSelected)"
            >Update Admits</b-dropdown-item
          >
        </b-dropdown>
        <b-dropdown
          right
          variant="edit"
          id="dropdown-dropup"
          boundary="viewport"
          class="mr-3"
          size="sm"
          v-if="movieSelected.isNewSchedule && $can('update', 'Schedule')"
        >
          <b-dropdown-item
            @click="onClickDuplicateSingleSchedule(movieSelected)"
            >Duplicate Schedule</b-dropdown-item
          >
          <b-dropdown-item
            @click="EditNewSchedule(movieSelected, selectedScreen)"
            v-if="movieSelected.ss_show_status != '13'"
            >Edit Details</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <b-modal
      id="updateSalesChannelNew"
      ref="updateSalesChannelNew"
      title="Edit Details"
      hide-footer
      size="lg"
      @hide="onHideEditNewSchModal($event)"
      @close="onCloseEditNewSchModal()"
      @cancel="onCloseEditNewSchModal()"
    >
      <div>
        <div class="row mx-0" style="font-size: 13px">
          <!-- <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie || movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div> -->
          <div class="col-12 border-bottom py-2" v-if="allowChangeVersion">
            <div class="row">
              <div class="col-2 d-flex align-items-center">Version:</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.version"
                  track-by="md_id"
                  label="movie_name"
                  @select="onChangeVersion($event, movieSelected, true)"
                  :options="getVersionList(movieSelected)"
                  :multiple="false"
                  :allow-empty="false"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie_name ||
                  movieSelected.movie ||
                  movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Length</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.mrrdr_runtime) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Total Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <div class="custom-timepicker">
                  <vue-timepicker
                    manual-input
                    v-model="movieSelected.start_time"
                    id="showtime"
                    name="showtime"
                    format="HH:mm"
                    class="time_picker"
                    input-width="100%"
                    auto-scroll
                    lazy
                    :hide-clear-button="true"
                    v-validate="'required'"
                    @change="onChangeShowStartTimeNewSchedule($event)"
                  ></vue-timepicker>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong> {{ movieSelected.end_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cine_interval_time_in_mins"
                      type="text"
                      name="intervaltime"
                      id="intervaltime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="col-2">
                <strong>Mins</strong>
              </div> -->
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cine_cleaning_time_in_mins"
                      type="text"
                      name="cleaning_time_in_mins"
                      id="cleaning_time_in_mins"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="col-2">
                <strong>Mins</strong>
              </div> -->
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Advertisement Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cine_setting_ads_time_in_mins"
                      type="text"
                      name="settingadstime"
                      id="settingadstime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="col-2">
                <strong>Mins</strong>
              </div> -->
            </div>
          </div>

          <!----Artwork------>

          <!-- <div class="col-6 border-bottom py-3">
            <div class="row">
              <div class="col-4">Artwork Image</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <label
                    class="material-file-upload"
                    @click.prevent.stop="setModalData()"
                  >
                    <div
                      class="label"
                      v-bind:class="{
                        'shift-up': movieSelected.sch_artwork_url,
                      }"
                    >
                      {{ "Artwork Image" }}
                    </div>
                    <div class="uploaded-file-name">
                      <div class="text-truncate pt-2">
                        {{ movieSelected.sch_artwork_url }}
                      </div>
                    </div>
                  </label>

                </div>
              </div>
              <div class="col-2 align-self-center pl-3">
                <img
                  width="40"
                  height="40"
                  class="rounded c-pointer img-preview"
                  @click="openImageModal()"
                  :src="_GetImagePath(movieSelected.sch_artwork_url)"
                  v-if="movieSelected.sch_artwork_url"
                />
                <img
                  v-else
                  width="35"
                  height="35"
                  class="rounded"
                  alt="Empty Image"
                  src="@/assets/img/icons/empty-image.svg"
                />
              </div>
            </div>
          </div> -->
          <!----Artwork------>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Schedule Type</div>
              <div class="col-8">
                <multiselect
                  v-model="movieSelected.selectedShowStatus"
                  track-by="status_id"
                  label="type"
                  @select="onSelectStatus($event, $event)"
                  :options="scheduleStatusArray"
                  :multiple="false"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">
                Comment <span class="text-truncate fs-12">(optional)</span>
              </div>
              <div class="col-10">
                <div class="input-material-textarea">
                  <textarea
                    rows="2"
                    placeholder="."
                    type="text"
                    v-model="movieSelected.ss_comment"
                    name="ss_comment"
                    id="ss_comment"
                    style="
                      border-radius: 10px;
                      border-color: #d3d3d3;
                      resize: none;
                    "
                  />
                  <label>Comment</label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Sales Channel</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.sales_channel"
                  track-by="user_id"
                  label="username"
                  @select="onSelectSalesChannel($event, movieSelected)"
                  @remove="onRemoveSalesChannel($event, movieSelected)"
                  :options="aggregatorUsersList"
                  :multiple="true"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Add on charges</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.AddonsCharges"
                  track-by="marc_id"
                  id="addonCharges"
                  ref="addonCharges"
                  label="addons_name"
                  :options="AddonChargesArray"
                  :multiple="true"
                >
                  <template slot="option" slot-scope="props"
                    ><span>
                      {{ props.option.addons_name }}-{{
                        props.option.add_ons_price
                      }}&nbsp;{{
                        props.option.is_percentage == "Y"
                          ? "%"
                          : currencyData.curr_code
                      }}
                    </span>
                  </template>
                  <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag">
                      <span
                        >{{ props.option.addons_name }}-{{
                          props.option.add_ons_price
                        }}&nbsp;{{
                          props.option.is_percentage == "Y"
                            ? "%"
                            : currencyData.curr_code
                        }}</span
                      >
                      <i
                        aria-hidden="true"
                        tabindex="1"
                        @keydown.enter.prevent="removeElement(props.option)"
                        @mousedown.prevent="removeElement(props.option)"
                        class="multiselect__tag-icon"
                      ></i>
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Rate Cards</div>
              <div class="col-10">
                <div class="row">
                  <div
                    class="col-8"
                    v-for="(
                      schPrice, schPriceIndex
                    ) in movieSelectedSchedulePriceArray"
                    :key="schPriceIndex"
                  >
                    <span class="font-weight-bold">{{
                      schPrice.sst_seat_type
                    }}</span>
                    <div
                      class="dropdown-curve-container placeholder-red dropDownElipsis"
                    >
                      <!-- <label class="shift-up">{{schPrice.sst_seat_type}}</label> -->
                      <!-- :title="
                          schPrice.selectedRateCard &&
                          schPrice.selectedRateCard.rc_g_name
                            ? schPrice.selectedRateCard.rc_g_name
                            : ''
                        " -->
                      <multiselect
                        v-model="schPrice.selectedRateCard"
                        track-by="rc_g_id"
                        label="rc_g_name"
                        :placeholder="'No Rate Card Selected'"
                        :class="
                          schPrice.hasOwnProperty('defaultRateCard') &&
                          schPrice.defaultRateCard
                            ? 'defaultRateCardSelect'
                            : ''
                        "
                        @select="
                          onSelectRateCardFromEdit(
                            $event,
                            movieSelected,
                            schPriceIndex
                          )
                        "
                        :allow-empty="true"
                        :options="
                          filteredRateCardList(
                            selectedScreen,
                            schPrice,
                            RatecardsList
                          )
                        "
                        :multiple="false"
                        deselect-label=""
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 pt-3 text-center">
            <button
              class="btn-outline-blue"
              :disabled="disableBtns['updateMovieBtn']"
              :class="disableBtns['updateMovieBtn'] ? 'disBtnStyle' : ''"
              @click.prevent.stop="onHandleEditSaveNewSchedule(true)"
            >
              Save
            </button>
            <button
              @click.prevent.stop="onCloseEditNewSchModal()"
              class="btn-blue"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- UPDATE MOVIE MODAL -->
    <b-modal
      id="updateMovie"
      ref="updateMovie"
      :title="
        movieSelected.hasOwnProperty('ss_show_status')
          ? movieSelected.ss_show_status == '13'
            ? `View Details`
            : `Update Movie`
          : `Update Movie`
      "
      hide-footer
      size="lg"
      show
    >
      <div>
        <div class="row mx-0" style="font-size: 13px">
          <div class="col-12 border-bottom py-2" v-if="allowChangeVersion">
            <div class="row">
              <div class="col-2 d-flex align-items-center">Version:</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.version"
                  :disabled="
                    movieSelected.ss_show_status == 13 ||
                    movieSelected.booked_seats > 0 ||
                    movieSelected.unpaid_count > 0 ||
                    movieSelected.mycinema_booking_type_id == 3
                  "
                  track-by="md_id"
                  label="movie_name"
                  @select="onChangeVersion($event, movieSelected)"
                  :options="getVersionList(movieSelected)"
                  :multiple="false"
                  :allow-empty="false"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{
                  movieSelected.movie_name ||
                  movieSelected.movie ||
                  movieSelected.movie_title
                }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <!-- <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>English</strong>
              </div>
            </div>
          </div>-->

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Length</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.mrrdr_runtime) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Total Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <div
                  class="custom-timepicker"
                  v-if="movieSelected.ss_show_status != 13"
                  @click="checkStartTimeChageAllowed(movieSelected)"
                >
                  <vue-timepicker
                    manual-input
                    v-model="movieSelected.start_time"
                    :disabled="checkStartTimeChageAllowed(movieSelected, false)"
                    id="showtime"
                    name="showtime"
                    format="HH:mm"
                    class="time_picker"
                    input-width="100%"
                    auto-scroll
                    lazy
                    :hide-clear-button="true"
                    v-validate="'required'"
                    @change="onChangeShowStartTime($event)"
                  ></vue-timepicker>
                </div>
                <div class="" v-else>
                  {{ movieSelected.ss_start_show_time }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong> {{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.interval_time_in_mins"
                      type="text"
                      :disabled="movieSelected.ss_show_status == 13"
                      name="intervaltime"
                      id="intervaltime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="col-2">
                <strong>Mins</strong>
              </div> -->
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.cleaning_time_in_mins"
                      type="text"
                      :disabled="movieSelected.ss_show_status == 13"
                      name="cleaning_time_in_mins"
                      id="cleaning_time_in_mins"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="col-2">
                <strong>Mins</strong>
              </div> -->
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Advertisement Time (Mins)</div>
              <div class="col-8">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="movieSelected.ads_time_in_mins"
                      type="text"
                      :disabled="movieSelected.ss_show_status == 13"
                      name="settingadstime"
                      id="settingadstime"
                      v-validate="'required|numeric'"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="col-2">
                <strong>Mins</strong>
              </div> -->
            </div>
          </div>
          <!-----Artwork Image Edit section--->

          <!---div class="col-6 border-bottom py-3" v-if="movieSelected.ss_show_status != 13">
            <div class="row">
              <div class="col-4">Artwork Image</div>
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <label
                    class="material-file-upload"
                    @click.prevent.stop="setModalData()"
                  >
                    <div
                      class="label"
                      v-bind:class="{
                        'shift-up': movieSelected.sch_artwork_url,
                      }"
                    >
                      {{ "Artwork Image" }}
                    </div>
                    <div class="uploaded-file-name">
                      <div class="text-truncate pt-2">
                        {{ movieSelected.sch_artwork_url }}
                      </div>
                    </div>
                  </label>
                <Tooltip :title="`Special Schedule Artwork`" />
                </div>
              </div>
              <div class="col-2 align-self-center pl-3">
                <img
                  width="40"
                  height="40"
                  class="rounded c-pointer img-preview"
                  @click="openImageModal()"
                  :src="_GetImagePath(movieSelected.sch_artwork_url)"
                  v-if="movieSelected.sch_artwork_url"
                />
                <img
                  v-else
                  width="35"
                  height="35"
                  class="rounded"
                  alt="Empty Image"
                  src="@/assets/img/icons/empty-image.svg"
                />
              </div>
            </div>
          </div---->
          <!-----Artwork Image Edit section--->
          <!-- <div class="col-6 border-bottom py-2">
            <div class="row">
              <div class="col-4">Comment <span class="text-truncate fs-12">(optional)</span></div>
              <div class="col-8">
                <div class="input-material">
                  <textarea
                    rows="2"
                    cols="30"
                    placeholder="."
                    type="text"
                    :disabled="movieSelected.ss_show_status == 13"
                    v-model="movieSelected.ss_comment"
                    name="ss_comment"
                    id="ss_comment"
                    style="border-radius:10px;border-color:#d3d3d3;resize: none;"
                  />
                  <label>Comment</label>
                </div>
              </div>
            </div>
          </div> -->

          <div
            class="col-6 border-bottom py-2"
            v-if="movieSelected.ss_show_status != 13"
          >
            <div class="row">
              <div class="col-4">Schedule Type</div>
              <div
                class="col-8"
                @click="checkStartTimeChageAllowed(movieSelected)"
              >
                <multiselect
                  :disabled="checkStartTimeChageAllowed(movieSelected, false)"
                  v-model="movieSelected.selectedShowStatus"
                  track-by="status_id"
                  label="type"
                  @select="onSelectStatus($event, $event)"
                  :options="scheduleStatusArray"
                  :multiple="false"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">
                Comment <span class="text-truncate fs-12">(optional)</span>
              </div>
              <div class="col-10">
                <div class="input-material-textarea">
                  <textarea
                    rows="2"
                    placeholder="."
                    type="text"
                    :disabled="movieSelected.ss_show_status == 13"
                    v-model="movieSelected.ss_comment"
                    name="ss_comment"
                    id="ss_comment"
                    style="
                      border-radius: 10px;
                      border-color: #d3d3d3;
                      resize: none;
                    "
                  />
                  <label>Comment</label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2">
            <div class="row">
              <!-- <div class="col-10">Disable Multi-seat-select</div> -->
              <div class="col-12">
                <div class="d-flex align-items-center align-self-center">
                  <div class="mr-2">Disable Multi-seat-select</div>
                  <div class="">
                    <b-form-checkbox
                      v-model="movieSelected.turnOffMultiSeatSelection"
                      name="check-button"
                      class="j-checkbox mb-0 pb-0"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 border-bottom py-2" v-if="showSpecialScreeningFlag">
            <div class="row">
              <!-- <div class="col-10">Special Screening</div> -->
              <div class="col-12">
                <div class="d-flex align-items-center align-self-center">
                  <div class="mr-2">Special Screening</div>
                  <div class="">
                    <b-form-checkbox
                      v-model="movieSelected.is_special_schedule"
                      name="check-button"
                      class="j-checkbox mb-0 pb-0"
                    >
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Sales Channel</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.sales_channel"
                  :disabled="movieSelected.ss_show_status == 13"
                  track-by="user_id"
                  label="username"
                  @select="onSelectSalesChannel($event, movieSelected)"
                  @remove="onRemoveSalesChannel($event, movieSelected)"
                  :options="aggregatorUsersList"
                  :multiple="true"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-2">Add on charges</div>
              <div class="col-10">
                <multiselect
                  v-model="movieSelected.AddonsCharges"
                  :disabled="movieSelected.ss_show_status == 13"
                  track-by="marc_id"
                  id="addonCharges"
                  ref="addonCharges"
                  label="addons_name"
                  :options="AddonChargesArray"
                  :multiple="true"
                >
                  <template slot="option" slot-scope="props"
                    ><span>
                      {{ props.option.addons_name }}-{{
                        props.option.add_ons_price
                      }}&nbsp;{{
                        props.option.is_percentage == "Y"
                          ? "%"
                          : currencyData.curr_code
                      }}
                    </span>
                  </template>
                  <template slot="tag" slot-scope="props">
                    <span class="multiselect__tag">
                      <span
                        >{{ props.option.addons_name }}-{{
                          props.option.add_ons_price
                        }}&nbsp;{{
                          props.option.is_percentage == "Y"
                            ? "%"
                            : currencyData.curr_code
                        }}</span
                      >
                      <i
                        aria-hidden="true"
                        tabindex="1"
                        @keydown.enter.prevent="removeElement(props.option)"
                        @mousedown.prevent="removeElement(props.option)"
                        class="multiselect__tag-icon"
                      ></i>
                    </span>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>

          <div
            class="col-12 border-bottom py-2"
            v-if="movieSelected.ss_show_status != 13"
          >
            <div class="row">
              <div class="col-2">Rate Cards</div>
              <div class="col-10">
                <div class="row">
                  <div
                    class="col-8"
                    v-for="(
                      schPrice, schPriceIndex
                    ) in movieSelectedSchedulePriceArray"
                    :key="schPriceIndex"
                  >
                    <span class="font-weight-bold">{{
                      schPrice.sst_seat_type
                    }}</span>
                    <div
                      class="dropdown-curve-container placeholder-red dropDownElipsis mb-2"
                    >
                      <!-- <label class="shift-up">{{schPrice.sst_seat_type}}</label> -->
                      <!-- :title="
                          schPrice.selectedRateCard &&
                          schPrice.selectedRateCard.rc_g_name
                            ? schPrice.selectedRateCard.rc_g_name
                            : ''
                        " -->
                      <multiselect
                        v-model="schPrice.selectedRateCard"
                        :disabled="movieSelected.ss_show_status == 13"
                        track-by="rc_g_id"
                        label="rc_g_name"
                        :placeholder="'No Rate Card Selected'"
                        @select="
                          onSelectRateCardFromEdit(
                            $event,
                            movieSelected,
                            schPriceIndex
                          )
                        "
                        :allow-empty="true"
                        :options="
                          filteredRateCardList(
                            selectedScreen,
                            schPrice,
                            RatecardsList
                          )
                        "
                        :multiple="false"
                        deselect-label=""
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-12 border-bottom py-2"
            v-if="movieSelected.mycinema_booking_type_id === 3"
          >
            <h6>Private Show Details:</h6>

            <table class="table border customerDetailsTable" border>
              <tbody>
                <tr>
                  <td><strong>Customer Name: </strong></td>
                  <td>{{ movieSelected.customer_name }}</td>
                </tr>
                <tr>
                  <td><strong>Customer Email: </strong></td>
                  <td>{{ movieSelected.cust_email }}</td>
                </tr>
                <tr>
                  <td><strong>Customer Mobile: </strong></td>
                  <td>{{ movieSelected.customer_mobile }}</td>
                </tr>
                <tr>
                  <td><strong>Is Guest User: </strong></td>
                  <td>{{ movieSelected.is_guest_user }}</td>
                </tr>
                <tr>
                  <td><strong>Special Request: </strong></td>
                  <td>
                    {{
                      movieSelected.special_request
                        ? movieSelected.special_request
                        : "None"
                    }}
                  </td>
                </tr>
                <template v-if="movieSelected.privateShowBookingDetails">
                  <tr>
                    <td><strong>Booking Code: </strong></td>
                    <td>
                      {{
                        movieSelected.privateShowBookingDetails.sb_booking_code
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Transaction Date and Time: </strong></td>
                    <td>
                      {{
                        moment(
                          movieSelected.privateShowBookingDetails
                            .sb_booking_date_time
                        ).format("DD-MM-YYYY HH:mm")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Total Amount: </strong></td>
                    <td>
                      {{
                        currFormat(
                          movieSelected.privateShowBookingDetails
                            .sb_total_amount
                        )
                      }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <!-- <p>
              <strong>Customer Name: </strong
              ><span>{{ movieSelected.customer_name }}</span>
            </p>
            <p>
              <strong>Customer Email: </strong
              ><span>{{ movieSelected.cust_email }}</span>
            </p>
            <p>
              <strong>Customer Mobile: </strong
              ><span>{{ movieSelected.customer_mobile }}</span>
            </p>
            <p>
              <strong>Is Guest User: </strong
              ><span>{{ movieSelected.is_guest_user }}</span>
            </p>
            <p>
              <strong>Special Request: </strong
              ><span>{{
                movieSelected.special_request
                  ? movieSelected.special_request
                  : "None"
              }}</span>
            </p>

            <div v-if="movieSelected.privateShowBookingDetails">
              <p>
                <strong>Booking Code: </strong
                ><span>{{
                  movieSelected.privateShowBookingDetails.sb_booking_code
                }}</span>
              </p>

              <p>
                <strong>Transaction Date and Time: </strong
                ><span>{{
                  moment(
                    movieSelected.privateShowBookingDetails.sb_booking_date_time
                  ).format("DD-MM-YYYY HH:mm")
                }}</span>
              </p>

              <p>
                <strong>Total Amount: </strong
                ><span>{{
                  currFormat(
                    movieSelected.privateShowBookingDetails.sb_total_amount
                  )
                }}</span>
              </p>
            </div> -->
          </div>

          <div
            class="col-12 pt-3 text-center"
            v-if="movieSelected.ss_show_status != 13"
          >
            <template v-if="$can('update', 'Schedule')">
              <button
                :disabled="disableBtns['updateMovieBtn']"
                :class="disableBtns['updateMovieBtn'] ? 'disBtnStyle' : ''"
                v-on:click="onUpdate()"
                class="btn-blue"
              >
                Update
              </button>
            </template>
            <button
              @click.prevent.stop="$bvModal.hide('updateMovie')"
              class="btn-blue"
            >
              Cancel
            </button>
          </div>
          <div class="col-12 pt-3 text-center" v-else>
            <button
              @click.prevent.stop="$bvModal.hide('updateMovie')"
              class="btn-blue"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="enableDisableSchedule"
      ref="enableDisableSchedule"
      title="Confirmation"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 my-4">
          Are you sure you want to
          {{ scheduleStatusType == 1 ? "disable" : "enable" }} schedule?
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('enableDisableSchedule')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-blue px-4 fs-14"
          @click.prevent.stop="handleEnableDisableSch(selectedSchedule)"
        >
          {{ scheduleStatusType == 1 ? "Disable" : "Enable" }}
        </button>
      </div>
    </b-modal>

    <b-modal
      id="beforeLeaveConfimation"
      ref="beforeLeaveConfimation"
      title="Alert!"
      size="sm"
      hide-footer
      @hidden="closeDialogBeforeLeave()"
      centered
    >
      <div>
        <p>You have unsaved changes. Do you want to save ?</p>
      </div>
      <div class="grpBtns text-right">
        <button
          class="btn btn-sm btn-secondary"
          @click.prevent.stop="discardChanges()"
        >
          Discard
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-sm btn-primary px-4 fs-14"
          @click.prevent.stop="saveChangesBeforeLeave()"
        >
          Save
        </button>
      </div>
    </b-modal>

    <b-modal
      id="ignoreconflicts"
      ref="ignoreconflicts"
      title="Confirmation"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 my-4">Are you sure you want to continue?</p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('ignoreconflicts')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-blue px-4 fs-14"
          @click.prevent.stop="handleupdateOverlapConflicts()"
        >
          Continue
        </button>
      </div>
    </b-modal>

    <b-modal
      id="warningNoRateCard"
      ref="warningNoRateCard"
      hide-footer
      hide-header
      centered
      no-fade
    >
      <div>
        <div class="svg-container text-center">
          <svg
            width="30pt"
            height="30pt"
            version="1.1"
            viewBox="0 0 1200 1200"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g fill="#ffd65b">
              <path
                d="m1110.4 938.2-426.89-693.25c-56.07-91.074-125.64-100.98-195.69-10.223-136.33 176.61-249.52 369.7-362.32 562.19-19.43 33.16-39.055 66.762-49.668 103.7-10.613 36.941-11.418 78.184 6.0195 112.43 27.441 53.895 90.504 63.438 150.75 62.586 867.37-10.098 822.88-6.6133 851.53-16.758 46.281-16.402 65.977-56.125 26.273-120.67zm-34.504 97.426c-24.562 8.6953 16.367 5.3359-843.58 15.348-44.805 0.73828-99.207-3.5469-120.01-40.004-19.488-34.129-0.64062-78.469 20.355-117.33h0.007813c167.91-310.92 303.09-483.67 368.43-586.42 21.879-34.418 44.508-69.992 70.031-96.879 7.2383-7.6328 15.734-12.711 26.199-11.637 22.645 2.3594 48.52 32.121 65.184 59.188l426.89 693.25c23.516 38.16 29.102 69.395-13.508 84.48z"
              />
              <path
                d="m780.21 125.03c-6.4219-2.2812-13.469 1.0742-15.75 7.4961l-30.621 86.078c-2.2812 6.4062 1.0664 13.453 7.4805 15.75 6.3789 2.25 13.449-1.0312 15.75-7.4961l30.621-86.078c2.2812-6.4062-1.0664-13.453-7.4805-15.75z"
              />
              <path
                d="m852.91 194.24c-20.004 26.922-43.891 50.582-70.996 70.328-5.5078 4.0117-6.7188 11.719-2.7031 17.227 4.0078 5.5312 11.742 6.6992 17.219 2.7148 29.121-21.223 54.781-46.633 76.277-75.562 4.0625-5.457 2.9219-13.18-2.543-17.242-5.4453-4.0781-13.168-2.9414-17.254 2.5352z"
              />
              <path
                d="m815.8 322.32c0.17578 6.6953 5.6602 12.008 12.32 12.008 9.3984-1.0586 32.441 0.10156 67.086-13.582 6.332-2.4883 9.4375-9.6484 6.9414-15.988-2.5117-6.3398-9.6797-9.457-15.996-6.9336-18.645 7.3516-38.27 11.332-58.336 11.848-6.8047 0.17578-12.184 5.8438-12.016 12.648z"
              />
              <path
                d="m609.96 389h-13.082c-17.531 0-31.742 14.211-31.742 31.742l0.003907 343.96c0 17.531 14.211 31.742 31.742 31.742 17.031 0 31.074-13.438 31.785-30.449 4.7812-114.63 8.1758-229.34 12.938-343.97 0.74609-18.02-13.609-33.023-31.645-33.023z"
              />
              <path
                d="m583.05 846.32-4.2969 1.4219c-19.625 7.7188-30.715 32.266-23.543 52.098 7.1758 19.828 31.406 31.598 51.426 24.973 20.02-6.625 32.453-30.523 26.383-50.719s-29.613-33.281-49.969-27.773z"
              />
            </g>
          </svg>
        </div>

        <p class="fs-18 text-center">
          <span style="font-weight: 500" class="text-warning">Warning!</span>
        </p>
        <p>
          <span style="font-size: 15px; font-weight: 500">
            <!-- {{autoSave.rateCardWarningData}} -->
            <span>Please attach Rate Card for</span>&nbsp;<span
              class="font-weight-bold"
              >{{ autoSaveObj.rateCardissueMovie }}</span
            >&nbsp;<span>on</span>&nbsp;<span class="font-weight-bold">{{
              autoSaveObj.rateCardissueScreen
            }}</span
            >&nbsp;<span>at</span>&nbsp;<span class="font-weight-bold">{{
              autoSaveObj.rateCardissueShow
            }}</span>
          </span>
        </p>

        <button
          class="btn btn-sm btn-blue float-right"
          @click.prevent.stop="$bvModal.hide('warningNoRateCard')"
        >
          OK
        </button>
      </div>
    </b-modal>

    <b-modal
      id="deletedScheduleDetailsModal"
      ref="deletedScheduleDetailsModal"
      title="Deleted Schedule Details"
      hide-footer
      show
    >
      <div v-if="deletedScheduleDetails">
        <div class="row">
          <div class="col-6">Movie</div>
          <div class="col-6">
            <strong> {{ deletedScheduleDetails.movie_title }}</strong>
          </div>
          <br />

          <div class="col-6">Show Start Time</div>
          <div class="col-6">
            <strong>
              {{ deletedScheduleDetails.start_time | format24hours }}</strong
            >
          </div>
          <br />

          <div class="col-6">Show End Time</div>
          <div class="col-6">
            <strong>
              {{ deletedScheduleDetails.end_time | format24hours }}</strong
            >
          </div>
          <br />

          <div class="col-6">Reason for deletion</div>
          <div class="col-6">
            <strong> {{ deletedScheduleDetails.scd_reason }}</strong>
          </div>
          <br />

          <div class="col-6">Deleted by</div>
          <div class="col-6">
            <strong>{{ deletedScheduleDetails.user }}</strong>
          </div>
          <div class="col-6">Deleted At</div>
          <div class="col-6">
            <strong>{{
              deletedScheduleDetails.deleted_at | fulldateparse
            }}</strong>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      ref="duplicateModal"
      title="Duplicate Schedule"
      size="lg"
    >
      <div>
        <div class="add-movie-container">
          <div class="row">
            <div class="col-md-6 mb-4">
              <div class>
                <label>{{ $tc("startdate", 1) }}</label>
              </div>
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="duplicate.ss_start_date"
                      v-on:click="clear_ss_start_date()"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="duplicate.ss_start_date"
                      name="showstartdate"
                      id="showstartdate"
                      :disabled-dates="disabledDates"
                      v-validate="'required'"
                      :typeable="true"
                    ></Datepicker>
                    <!-- :disabledDates="{
                        to: new Date(Date.now() - 8640000)
                    }"-->
                    <label
                      :class="
                        typeof duplicate.ss_start_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >Show Start Date</label
                    >
                  </div>
                </div>
                <!-- <Tooltip :title="$t('tooltip')" />-->
              </div>
              <p
                v-if="submitted && errors.has('showstartdate')"
                class="error_message"
              >
                {{ errors.first("showstartdate") }}
              </p>
            </div>

            <div class="col-md-6 mb-4">
              <div class>
                <label>{{ $tc("enddate", 1) }}</label>
              </div>
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="duplicate.ss_end_date"
                      v-on:click="clear_ss_end_date()"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="duplicate.ss_end_date"
                      name="showenddate"
                      id="showenddate"
                      v-validate="'required'"
                      :typeable="true"
                      :disabled-dates="{ to: duplicate.ss_start_date }"
                    ></Datepicker>
                    <!-- :disabledDates="{ to: new Date(Date.now() - 8640000)}" -->
                    <label
                      :class="
                        typeof duplicate.ss_end_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >Show End Date</label
                    >
                  </div>
                </div>
                <!-- <Tooltip :title="$t('tooltip')" />-->
              </div>
              <p
                v-if="submitted && errors.has('showenddate')"
                class="error_message"
              >
                {{ errors.first("showenddate") }}
              </p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-center mt-4">
              <button
                @click.prevent.stop="handleDuplicateSchedule()"
                class="btn-blue"
              >
                {{ $t("submit") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      ref="overlappedConflicts"
      title="Overlapping Shows/Event"
      size="xl"
    >
      <div>
        <div class="add-movie-container pt-0">
          <div class="movieName mb-2" v-if="isScreenDuplicate">
            <div class="">
              <b
                >Screen -
                {{
                  duplicateScreenObj.selectedScreen.screen_name &&
                  duplicateScreenObj.selectedScreen.screen_name
                    ? duplicateScreenObj.selectedScreen.screen_name
                    : ""
                }}</b
              >
            </div>
          </div>
          <div class="movieName mb-2" v-else>
            <div class="mb-1">
              <b
                >Movie -
                {{
                  selectedMultiShowSchedule && selectedMultiShowSchedule.movie
                    ? selectedMultiShowSchedule.movie
                    : ""
                }}</b
              >
            </div>
            <div class="">
              <b
                >Screen -
                {{
                  selectedScreen && selectedScreen.screen_name
                    ? selectedScreen.screen_name
                    : ""
                }}</b
              >
            </div>
          </div>
          <div class="details-wrapper d-flex justify-content-between mb-1">
            <div class="tableName text-danger">
              <b>Confilcts</b>- Overlapped with {{ overlappedCount }} movie(s)
            </div>
            <div class="d-flex">
              <div
                class="color-coding d-flex flex-wrap w-100"
                v-if="typeList.length > 0"
              >
                <div
                  class="pr-3 mb-2"
                  v-for="(type, typeIndex) in typeList"
                  :key="typeIndex"
                  v-if="!['No Rate Card Attached'].includes(type.name)"
                >
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="">
                      <div
                        class="color-box-2"
                        :style="'background-color:' + type.color"
                      ></div>
                    </div>
                    <div class="color-combination ml-1">
                      {{ type.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table_wrapper">
            <div class="swc-report mb-4">
              <table
                class="text-left conflictTable border mb-3 p-0 listviewtable"
                border="1"
              >
                <thead>
                  <tr>
                    <th>Date</th>
                    <th v-if="isScreenDuplicate">Movie</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th colspan="2">Overlapping Movie/Event</th>
                    <th>Show Time</th>
                    <th>Occupancy</th>
                    <th>Replace</th>
                    <th>Ignore</th>
                  </tr>
                </thead>
                <tbody class="sph-report">
                  <tr
                    v-for="(
                      overlap, overlapIndex
                    ) in overlappedSingleMultiScheduleArray"
                    :key="overlapIndex"
                  >
                    <td class="noPadding">
                      {{ overlap.ss_start_date }} <br /><span class="fs-12">{{
                        moment(overlap.ss_start_date).format("dddd")
                      }}</span>
                    </td>
                    <td
                      v-if="isScreenDuplicate"
                      v-b-popover.hover.bottom="{
                        content: `${overlap.movie}`,
                        html: true,
                      }"
                    >
                      {{ overlap.movie }}
                    </td>
                    <td style="overflow: visible">
                      <div class="custom-timepicker" v-if="overlap.isEdit">
                        <vue-timepicker
                          drop-direction="auto"
                          v-model="overlap.ss_start_show_time"
                          id="showtimeoverlap"
                          name="showtimeoverlap"
                          format="HH:mm"
                          class="time_picker"
                          input-width="100%"
                          auto-scroll
                          no-caret
                          lazy
                          :drop-offset-height="100"
                          :manual-input="true"
                          :hide-dropdown="true"
                          :hide-clear-button="true"
                          @change="
                            editOverlappedTime(
                              'VALIDATE',
                              overlap,
                              overlapIndex
                            )
                          "
                        ></vue-timepicker>
                      </div>
                      <div v-else>
                        <span
                          v-if="checkOverlapEdit(overlap)"
                          @click="editTimeOverlap(overlap)"
                          class="edit-pen blue-icon btn p-0"
                        ></span
                        ><span v-else class="mr-3"></span>
                        {{ overlap.ss_start_show_time }}
                      </div>
                    </td>
                    <td>{{ overlap.ss_end_show_time }}</td>
                    <td colspan="4" class="p-0">
                      <table
                        class="w-100 p-0"
                        style="
                          table-layout: fixed;
                          border-top: none;
                          border-bottom: none;
                        "
                      >
                        <tr
                          v-for="(
                            overlapMovies, overlapMoviesIndex
                          ) in overlap.overlap_schedule"
                          :key="overlapMoviesIndex"
                          class="h-45"
                        >
                          <td
                            colspan="2"
                            class="cell"
                            :style="
                              'background-color:' +
                              overlapMovies.backgroundColor
                            "
                            v-b-popover.hover.bottom="{
                              title: `<div class='fs-14'> ${overlapMovies.movie}</div>`,
                              customClass: 'my-popover-class',
                              content: `
                          <div class='row fs-13'>
                          <div class='col-4 mr-0 pr-0'><b>Show Time:</b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            overlapMovies.ss_start_show_time
                          }-${overlapMovies.ss_end_show_time}</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${moment(
                            overlapMovies.ss_actual_start_date
                          ).format('Do, MMMM (ddd)')}</div>
                          <div class='col-4 mr-0 pr-0'><b>Occupancy:</b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            overlapMovies.booked_seats
                          } Booked/ ${overlapMovies.unpaid_count} Unpaid/ ${
                                overlapMovies.screen_total_seats
                              } Seats</div>
                          </div>
                          `,
                              html: true,
                            }"
                          >
                            {{ overlapMovies.movie }}
                          </td>
                          <td class="cell">
                            {{ overlapMovies.ss_start_show_time }}-{{
                              overlapMovies.ss_end_show_time
                            }}
                          </td>
                          <!-- <td class="cell">{{overlapMovies.ss_end_show_time}}</td> -->
                          <td
                            class="cell"
                            :title="`(${overlapMovies.booked_seats}/${overlapMovies.unpaid_count}/${overlapMovies.screen_total_seats})`"
                          >
                            ({{ overlapMovies.booked_seats }} /
                            {{ overlapMovies.unpaid_count }} /
                            {{ overlapMovies.screen_total_seats }} seats)
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td class="text-center">
                      <button
                        v-if="checkOverlapEdit(overlap)"
                        class="btn btn-sm btn-primary text-center"
                        @click="onHandleReplaceOverlap(overlap, overlapIndex)"
                      >
                        Replace</button
                      ><span :title="'Not Allowed'" v-else>Not Allowed</span>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-sm btn-primary"
                        @click="onIgnoreOverlap(overlap, overlapIndex)"
                      >
                        Ignore
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tableName text-success"><b>Resolved</b></div>
            <div class="swc-report mb-5">
              <table
                class="text-left conflictTable border mb-3 p-0 listviewtable"
                border="1"
              >
                <thead>
                  <tr>
                    <th class="w-60">S.No</th>
                    <th>Date</th>
                    <th v-if="isScreenDuplicate">Movie</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Remarks</th>
                    <th colspan="2">Overlapped Movie</th>
                    <th>Time</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="sph-report">
                  <tr
                    v-for="(
                      resolved, resolvedIndex
                    ) in resolvedSingleMultiScheduleArray"
                    :key="resolvedIndex"
                  >
                    <td>{{ resolvedIndex + 1 }}</td>
                    <td class="noPadding">
                      {{ resolved.ss_start_date }} <br /><span class="fs-12">{{
                        moment(resolved.ss_start_date).format("dddd")
                      }}</span>
                    </td>
                    <td v-if="isScreenDuplicate">{{ resolved.movie }}</td>
                    <td>{{ resolved.ss_start_show_time }}</td>
                    <td>{{ resolved.ss_end_show_time }}</td>
                    <td>{{ resolved.remark || "-" }}</td>
                    <td colspan="3" class="p-0">
                      <table
                        v-if="resolved.overlap_schedule"
                        style="table-layout: fixed"
                        class="w-100 p-0 border h-45"
                        border="1"
                      >
                        <tr
                          v-for="(
                            resolvedMovies, resolvedMoviesIndex
                          ) in resolved.overlap_schedule"
                          :key="resolvedMoviesIndex"
                          class="p-0"
                        >
                          <td
                            colspan="2"
                            v-b-popover.hover.bottom="{
                              title: `<div class='fs-14'> ${resolvedMovies.movie}</div>`,
                              customClass: 'my-popover-class',
                              content: `
                          <div class='row fs-13'>
                          <div class='col-4 mr-0 pr-0'><b>Show Time:</b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            resolvedMovies.ss_start_show_time
                          }-${resolvedMovies.ss_end_show_time}</div>
                          <div class='col-4 mr-0 pr-0'><b>Day/Date:</b></div>
                          <div class='col-8 ml-0 pl-0'> ${moment(
                            resolvedMovies.ss_actual_start_date
                          ).format('Do, MMMM (ddd)')}</div>
                          <div class='col-4 mr-0 pr-0'><b>Occupancy:</b></div>
                          <div class='col-8 ml-0 pl-0'>${
                            resolvedMovies.booked_seats
                          } Booked/ ${resolvedMovies.unpaid_count} Unpaid/ ${
                                resolvedMovies.screen_total_seats
                              } Seats</div>
                          </div>
                          `,
                              html: true,
                            }"
                          >
                            {{ resolvedMovies.movie }}
                          </td>
                          <td>
                            {{ resolvedMovies.ss_start_show_time }}-{{
                              resolvedMovies.ss_end_show_time
                            }}
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td class="text-center">
                      <button
                        v-if="resolved.hasOwnProperty('overlap')"
                        class="btn btn-sm btn-primary"
                        @click="undoConflictResolve(resolved, resolvedIndex)"
                      >
                        Undo
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center mt-4">
              <button
                class="btn-blue"
                @click.prevent.stop="$bvModal.show('ignoreconflicts')"
              >
                Ignore All
              </button>
              <button
                class="btn-blue"
                v-if="fixedConflicts"
                @click.prevent.stop="$bvModal.show('ignoreconflicts')"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      ref="DuplicateSingleSchedule"
      title="Duplicate Schedule"
      size="lg"
    >
      <div>
        <div class="add-movie-container">
          <div class="row">
            <div class="col-md-6 mb-4">
              <div class>
                <label>{{ $tc("startdate", 1) }}</label>
              </div>
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="
                        singleDuplicateDetails.ss_start_date &&
                        selectedMultiShowSchedule &&
                        !selectedMultiShowSchedule.isNewSchedule
                      "
                      v-on:click="clear_singleduplicateDates('start')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      :disabled="
                        selectedMultiShowSchedule &&
                        selectedMultiShowSchedule.isNewSchedule
                      "
                      v-model="singleDuplicateDetails.ss_start_date"
                      name="single_show_duplicate_startdate"
                      id="single_show_duplicate_startdate"
                      :disabled-dates="disabledDates"
                      v-validate="'required'"
                      :typeable="true"
                    ></Datepicker>
                    <label
                      :class="
                        typeof singleDuplicateDetails.ss_start_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >Show Start Date</label
                    >
                  </div>
                </div>
                <!-- <Tooltip :title="$t('tooltip')" />-->
              </div>
              <p
                v-if="
                  submitted && errors.has('single_show_duplicate_startdate')
                "
                class="error_message"
              >
                {{ "Required" }}
              </p>
            </div>

            <div class="col-md-6 mb-4">
              <div class>
                <label>{{ $tc("enddate", 1) }}</label>
              </div>
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="singleDuplicateDetails.ss_end_date"
                      v-on:click="clear_singleduplicateDates('end')"
                    >
                      ✖
                    </button>
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="singleDuplicateDetails.ss_end_date"
                      name="single_show_duplicate_enddate"
                      id="single_show_duplicate_enddate"
                      v-validate="'required'"
                      :typeable="true"
                      :disabled-dates="{
                        to: singleDuplicateDetails.ss_start_date,
                      }"
                    ></Datepicker>
                    <label
                      :class="
                        typeof singleDuplicateDetails.ss_end_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >Show End Date</label
                    >
                  </div>
                </div>
              </div>
              <p
                v-if="submitted && errors.has('single_show_duplicate_enddate')"
                class="error_message"
              >
                {{ "Required" }}
              </p>
            </div>

            <div class="col-12 list-view-table scrollTable">
              <table class="border mb-3 tableRc">
                <thead>
                  <tr>
                    <th>{{ "Days" }}</th>
                    <th
                      v-for="(
                        screenType, screenTypeIndex
                      ) in selectedScreenSeatTypes"
                      :key="'screenType' + screenTypeIndex"
                    >
                      {{ "Rate Card" }} ({{ screenType.sst_seat_type }})
                    </th>
                  </tr>
                </thead>
                <tbody class="selectDaysTable">
                  <tr
                    v-for="(weekdaysLoop, weekdaysKey) in weekDaysArray"
                    :key="weekdaysKey"
                  >
                    <td>
                      <b-form-checkbox
                        :id="'checkbox' + weekdaysKey"
                        v-model="weekdaysLoop.value"
                        class="j-checkbox mx-3 mb-3"
                        @change="onChangeWeekdays($event, weekdaysLoop.dayName)"
                      >
                        <div class="text-capitalize">
                          {{ weekdaysLoop.dayName }}
                        </div>
                      </b-form-checkbox>
                    </td>
                    <td
                      v-for="(
                        weekPrice, weekPriceIndex
                      ) in weekdaysLoop.scheduling_price"
                      :key="weekPriceIndex"
                      v-if="weekdaysLoop.scheduling_price.length > 0"
                    >
                      <div>
                        <div class="dropdown-curve-container w-230">
                          <multiselect
                            class=""
                            :allow-empty="false"
                            v-model="weekPrice['selected_rate_card']"
                            :title="
                              weekPrice && weekPrice.selected_rate_card
                                ? weekPrice.selected_rate_card.rc_g_name
                                : ''
                            "
                            placeholder=""
                            :options="
                              filteredRateCardList(
                                selectedScreen,
                                weekPrice,
                                RatecardsList
                              )
                            "
                            label="rc_g_name"
                            track-by="rc_g_id"
                            @select="
                              onSelectRateCardForDuplicateSchedule(
                                $event,
                                weekPrice,
                                weekdaysLoop,
                                weekPriceIndex
                              )
                            "
                            :multiple="false"
                          ></multiselect>
                          <label
                            :class="
                              weekPrice.selected_rate_card ? 'shift-up' : ''
                            "
                          >
                            {{ "Rate Card" }}
                          </label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-center mt-4">
              <button
                @click.prevent.stop="handleSingleDuplicateSchedule('VALIDATE')"
                class="btn-blue"
              >
                {{ $t("submit") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      ref="rateCardWeekDayArray"
      title="Edit Week Wise Rate Card"
      size="lg"
    >
      <div>
        <div class="add-movie-container">
          <div class="row">
            <div class="col-12">
              <table class="list-view-table border mb-3">
                <thead>
                  <tr>
                    <th>{{ "Days" }}</th>
                    <th
                      v-for="(
                        screenType, screenTypeIndex
                      ) in selectedScreenSeatTypes"
                      :key="'screenType' + screenTypeIndex"
                    >
                      {{ "Rate Card" }} ({{ screenType.sst_seat_type }})
                    </th>
                  </tr>
                </thead>
                <tbody
                  class="selectDaysTable"
                  v-if="selectedMovieForEditWeekWiseDay"
                >
                  <tr
                    v-for="(
                      weekdaysLoop, weekdaysKey
                    ) in selectedMovieForEditWeekWiseDay.weekDayArray"
                    :key="weekdaysKey"
                  >
                    <td>
                      <b-form-checkbox
                        :id="'checkbox' + weekdaysKey"
                        v-model="weekdaysLoop.value"
                        class="j-checkbox mx-3 mb-3"
                        @change="
                          onChangeWeekdays_ds($event, weekdaysLoop.dayName)
                        "
                      >
                        <div class="text-capitalize">
                          {{ weekdaysLoop.dayName }}
                        </div>
                      </b-form-checkbox>
                    </td>
                    <td
                      v-for="(
                        weekPrice, weekPriceIndex
                      ) in weekdaysLoop.scheduling_price"
                      :key="weekPriceIndex"
                      v-if="weekdaysLoop.scheduling_price.length > 0"
                    >
                      <div>
                        <div class="dropdown-curve-container w-90">
                          <multiselect
                            class=""
                            :allow-empty="false"
                            v-model="weekPrice['selected_rate_card']"
                            placeholder=""
                            :options="RatecardsList"
                            label="rc_g_name"
                            track-by="rc_g_id"
                            @select="
                              onChangeRateCardForDuplicateScreen(
                                $event,
                                weekPrice,
                                weekdaysLoop,
                                weekPriceIndex
                              )
                            "
                            :multiple="false"
                          ></multiselect>
                          <label
                            :class="
                              weekPrice.selected_rate_card ? 'shift-up' : ''
                            "
                          >
                            {{ "Rate Card" }}
                          </label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-center mt-4">
              <button class="btn-blue" @click="onClickSaveRateCardChanges_ds()">
                {{ $t("Save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      ref="duplicateScreen"
      title="Duplicate Screen's Schedule"
      size="xl"
    >
      <div>
        <div class="add-movie-container">
          <div class="row">
            <div class="col-md-12 mb-4">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container w-100">
                  <multiselect
                    class=""
                    :allow-empty="false"
                    v-model="duplicateScreenObj.selectedScreen"
                    placeholder=""
                    :options="validScreenList"
                    label="screen_name"
                    track-by="screen_id"
                    @select="onSelectScreenFromDuplicateScreen($event, 1)"
                    :multiple="false"
                  ></multiselect>
                  <label
                    :class="duplicateScreenObj.selectedScreen ? 'shift-up' : ''"
                  >
                    {{ $tc("screen", 1) }}
                  </label>
                </div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="duplicateScreenObj.start_date"
                      @selected="
                        onSelectDateFunction($event, 'duplicateScreen')
                      "
                      name="single_show_duplicate_startdate"
                      id="single_show_duplicate_startdate"
                      :disabled-dates="disabledDates"
                      v-validate="'required'"
                      :typeable="true"
                    ></Datepicker>
                    <label
                      :class="
                        typeof duplicateScreenObj.start_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >Start Date</label
                    >
                  </div>
                </div>
              </div>
              <p
                v-if="submitted && !duplicateScreenObj.start_date"
                class="error_message"
              >
                {{ "Required" }}
              </p>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="duplicateScreenObj.end_date"
                      name="duplicateScreenObjend_date"
                      id="duplicateScreenObjend_date"
                      v-validate="'required'"
                      :typeable="true"
                      :disabled-dates="{
                        to: duplicateScreenObj.start_date,
                      }"
                    ></Datepicker>
                    <label
                      :class="
                        typeof duplicateScreenObj.end_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >End Date</label
                    >
                  </div>
                </div>
              </div>
              <p
                v-if="submitted && !duplicateScreenObj.end_date"
                class="error_message"
              >
                {{ "Required" }}
              </p>
            </div>

            <div class="col-12">
              <table
                class="border mb-3 tablePadding w-100"
                style="table-layout: fixed"
                border="1"
                v-if="duplicateScreenObj.moviesArray.length > 0"
              >
                <thead>
                  <tr>
                    <th>{{ "Movie" }}</th>
                    <th class="w-11p">{{ "Start" }}</th>
                    <th class="w-11p">{{ "End" }}</th>
                    <th class="w-25">{{ "Sales Channel" }}</th>
                    <th>{{ "Rate Cards" }}</th>
                    <th
                      class="w-11p"
                      v-if="duplicateScreenObj.moviesArray.length > 1"
                    ></th>
                  </tr>
                </thead>
                <tbody
                  class="selectDaysTable"
                  v-for="(movie, movieInndex) in duplicateScreenObj.moviesArray"
                  :key="movieInndex"
                >
                  <tr>
                    <td style="white-space: break-spaces">{{ movie.movie }}</td>
                    <td class="w-25">{{ movie.ss_start_show_time }}</td>
                    <td class="w-25">{{ movie.ss_end_show_time }}</td>
                    <td class="w-100">
                      <multiselect
                        v-model="movie.sales_channel"
                        track-by="user_id"
                        label="username"
                        @select="
                          onSelectDuplicateScreenSalesChannel(
                            $event,
                            movieInndex
                          )
                        "
                        @remove="
                          onRemoveDuplicateScreenSalesChannel(
                            $event,
                            movieInndex
                          )
                        "
                        :options="aggregatorUsersList"
                        :multiple="true"
                      >
                      </multiselect>
                    </td>
                    <td class="fs-13" style="white-space: normal">
                      <div
                        class="rc-details"
                        :title="getRateCardName(rc)"
                        v-for="(rc, rcIndex) in movie.scheduleShowPrice"
                        :key="rcIndex"
                      >
                        {{ getRateCardName(rc) }}
                      </div>
                    </td>
                    <td
                      v-if="duplicateScreenObj.moviesArray.length > 1"
                      class="fixedWidth-10"
                    >
                      <div class="d-flex w-100 justify-content-center">
                        <button
                          class="btn-transparent rotate-btn"
                          v-if="movie.rateCardCollapse"
                          @click="
                            onEditRateCardScreenDuplicate(movie, movieInndex)
                          "
                        >
                          <img
                            src="@/assets/img/icons/primary/chevron-down.svg"
                            height="24"
                            width="24"
                          />
                        </button>
                        <button
                          class="btn-transparent"
                          v-else
                          @click="
                            onEditRateCardScreenDuplicate(movie, movieInndex)
                          "
                        >
                          <img
                            src="@/assets/img/icons/primary/chevron-down.svg"
                            height="24"
                            width="24"
                          />
                        </button>
                      </div>
                      <!-- <div class="edit-pen blue-icon mx-1 btn" @click="onEditRateCardScreenDuplicate(movie, movieInndex)"></div> -->
                    </td>
                  </tr>
                  <tr class="bg-lightbg">
                    <td colspan="5" v-if="movie.rateCardCollapse">
                      <b-collapse
                        :id="'moreDetails-' + movieInndex"
                        class="cinema-overview-collapse list-view-table scrollTable"
                        v-model="movie.rateCardCollapse"
                      >
                        <table
                          class="tableRc border mb-3 rateCardCollapse-table"
                        >
                          <thead>
                            <tr>
                              <th>{{ "Days" }}</th>
                              <th
                                v-for="(
                                  screenType, screenTypeIndex
                                ) in selectedScreenSeatTypes"
                                :key="'screenType' + screenTypeIndex"
                              >
                                {{ "Rate Card" }} ({{
                                  screenType.sst_seat_type
                                }})
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            class="selectDaysTable"
                            v-if="selectedMovieForEditWeekWiseDay"
                          >
                            <tr
                              v-for="(
                                weekdaysLoop, weekdaysKey
                              ) in selectedMovieForEditWeekWiseDay.weekDayArray"
                              :key="weekdaysKey"
                            >
                              <td>
                                <b-form-checkbox
                                  :id="'checkbox' + weekdaysKey"
                                  v-model="weekdaysLoop.value"
                                  class="j-checkbox mx-3 mb-3"
                                  @change="
                                    onChangeWeekdays_ds(
                                      $event,
                                      weekdaysLoop.dayName
                                    )
                                  "
                                >
                                  <div class="text-capitalize">
                                    {{ weekdaysLoop.dayName }}
                                  </div>
                                </b-form-checkbox>
                              </td>
                              <td
                                v-for="(
                                  weekPrice, weekPriceIndex
                                ) in weekdaysLoop.scheduling_price"
                                :key="weekPriceIndex"
                                v-if="weekdaysLoop.scheduling_price.length > 0"
                              >
                                <div>
                                  <div class="dropdown-curve-container w-230">
                                    <multiselect
                                      class=""
                                      :allow-empty="false"
                                      v-model="weekPrice['selected_rate_card']"
                                      :title="
                                        weekPrice &&
                                        weekPrice.selected_rate_card
                                          ? weekPrice.selected_rate_card
                                              .rc_g_name
                                          : ''
                                      "
                                      placeholder=""
                                      :options="
                                        filteredRateCardList(
                                          duplicateScreenObj.selectedScreen,
                                          weekPrice,
                                          RatecardsList
                                        )
                                      "
                                      label="rc_g_name"
                                      track-by="rc_g_id"
                                      @select="
                                        onChangeRateCardForDuplicateScreen(
                                          $event,
                                          weekPrice,
                                          weekdaysLoop,
                                          weekPriceIndex
                                        )
                                      "
                                      :multiple="false"
                                    ></multiselect>
                                    <label
                                      :class="
                                        weekPrice.selected_rate_card
                                          ? 'shift-up'
                                          : ''
                                      "
                                    >
                                      {{ "Rate Card" }}
                                    </label>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="col-12 list-view-table scrollTable"
              v-if="duplicateScreenObj.moviesArray.length == 1"
            >
              <table class="tableRc border mb-3">
                <thead>
                  <tr>
                    <th>{{ "Days" }}</th>
                    <th
                      v-for="(
                        screenType, screenTypeIndex
                      ) in selectedScreenSeatTypes"
                      :key="'screenType' + screenTypeIndex"
                    >
                      {{ "Rate Card" }} ({{ screenType.sst_seat_type }})
                    </th>
                  </tr>
                </thead>
                <tbody
                  class="selectDaysTable"
                  v-if="selectedMovieForEditWeekWiseDay"
                >
                  <tr
                    v-for="(
                      weekdaysLoop, weekdaysKey
                    ) in selectedMovieForEditWeekWiseDay.weekDayArray"
                    :key="weekdaysKey"
                  >
                    <td>
                      <b-form-checkbox
                        :id="'checkbox' + weekdaysKey"
                        v-model="weekdaysLoop.value"
                        class="j-checkbox mx-3 mb-3"
                        @change="
                          onChangeWeekdays_ds($event, weekdaysLoop.dayName)
                        "
                      >
                        <div class="text-capitalize">
                          {{ weekdaysLoop.dayName }}
                        </div>
                      </b-form-checkbox>
                    </td>
                    <td
                      v-for="(
                        weekPrice, weekPriceIndex
                      ) in weekdaysLoop.scheduling_price"
                      :key="weekPriceIndex"
                      v-if="weekdaysLoop.scheduling_price.length > 0"
                    >
                      <div>
                        <div class="dropdown-curve-container w-230">
                          <multiselect
                            class=""
                            :allow-empty="false"
                            v-model="weekPrice['selected_rate_card']"
                            placeholder=""
                            :title="
                              weekPrice && weekPrice.selected_rate_card
                                ? weekPrice.selected_rate_card.rc_g_name
                                : ''
                            "
                            :options="
                              filteredRateCardList(
                                duplicateScreenObj.selectedScreen,
                                weekPrice,
                                RatecardsList
                              )
                            "
                            label="rc_g_name"
                            track-by="rc_g_id"
                            @select="
                              onChangeRateCardForDuplicateScreen(
                                $event,
                                weekPrice,
                                weekdaysLoop,
                                weekPriceIndex
                              )
                            "
                            :multiple="false"
                          ></multiselect>
                          <label
                            :class="
                              weekPrice.selected_rate_card ? 'shift-up' : ''
                            "
                          >
                            {{ "Rate Card" }}
                          </label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="col-12"
              v-if="duplicateScreenObj.moviesArray.length == 0"
            >
              <div class="list-view-table border mb-3 text-center p-5">
                <p id="no-records">No Schedule Found</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-center mt-4">
              <button
                class="btn-blue"
                :disabled="duplicateScreenObj.moviesArray.length == 0"
                :class="
                  duplicateScreenObj.moviesArray.length == 0 ? 'disabled' : ''
                "
                v-if="duplicateScreenObj.selectedScreen"
                @click="onHandleDuplicateScreen('VALIDATE')"
              >
                {{ $t("Continue") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      ref="duplicateDay"
      title="Duplicate All Schedules"
      size="xl"
    >
      <DuplicateDay
        :moviesList="duplicateDayMovieList"
        :RatecardsList="RatecardsList"
        :CinemasSettings="CinemasSettings"
        :timeZone="timeZone"
        :cinemaId="scheduleObject.cinema_id"
        :validScreens="validScreenList"
        @handleDuplicateDayUpdation="handleDuplicateDayUpdation"
        :currentSelectedDate="scheduleObject.sch_start_date"
        :aggregatorUsersList="aggregatorUsersList"
      />
    </b-modal>

    <b-modal
      hide-footer
      ref="duplicateCinemaSchedule"
      id="duplicateCinemaSchedule"
      title="Duplicate Screen's Schedule to Other Cinema"
      size="lg"
      @show="clearDuplicateCinemaSchedule"
    >
      <div>
        <div class="add-movie-container">
          <div class="row">
            <div class="col-md-4 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    v-model="cinemasSelected.cine_name"
                    type="text"
                    :disabled="true"
                    name="cinemasSelectedDuplicate"
                    id="cinemasSelectedDuplicate"
                  />
                  <label :class="cinemasSelected.cine_name ? 'shift-up' : ''">
                    {{ $tc("cinema", 2) }}
                  </label>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-4">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container w-100">
                  <multiselect
                    class=""
                    :allow-empty="false"
                    v-model="duplicateCinemaSchedule.selectedScreen"
                    placeholder=""
                    :options="validScreenList"
                    label="screen_name"
                    track-by="screen_id"
                    @select="onSelectScreenFromDuplicateScreen($event, 2)"
                    :multiple="false"
                  ></multiselect>
                  <label
                    :class="
                      duplicateCinemaSchedule.selectedScreen ? 'shift-up' : ''
                    "
                  >
                    {{ $tc("screen", 1) }}
                  </label>
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <div class="add-datepicker">
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="duplicateCinemaSchedule.start_date"
                      @selected="
                        onSelectDateFunction($event, 'duplicateCinemaScreen')
                      "
                      name="duplicateCinema_startdate"
                      id="duplicateCinema_startdate"
                      :disabled="true"
                      v-validate="'required'"
                      :typeable="true"
                    ></Datepicker>
                    <label
                      :class="
                        typeof duplicateCinemaSchedule.start_date === 'object'
                          ? 'active'
                          : ''
                      "
                      >Date</label
                    >
                  </div>
                </div>
              </div>
              <p
                v-if="submitted && !duplicateCinemaSchedule.start_date"
                class="error_message"
              >
                {{ "Required" }}
              </p>
            </div>

            <div class="col-12">
              <table
                class="border mb-3 tablePadding w-100"
                border="1"
                v-if="duplicateCinemaSchedule.moviesArray.length > 0"
              >
                <thead>
                  <tr>
                    <th>{{ "Movie" }}</th>
                    <th class="w-11p">{{ "Start" }}</th>
                    <th class="w-11p">{{ "End" }}</th>
                  </tr>
                </thead>
                <tbody
                  class="selectDaysTable"
                  v-for="(
                    movie, movieInndex
                  ) in duplicateCinemaSchedule.moviesArray"
                  :key="movieInndex"
                >
                  <tr>
                    <td>{{ movie.movie }}</td>
                    <td class="w-25">{{ movie.ss_start_show_time }}</td>
                    <td class="w-25">{{ movie.ss_end_show_time }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="col-12"
              v-if="duplicateCinemaSchedule.moviesArray.length == 0"
            >
              <div class="list-view-table border mb-3 text-center p-5">
                <p id="no-records">No Schedule Found</p>
              </div>
            </div>

            <div
              class="col-12"
              v-if="duplicateCinemaSchedule.moviesArray.length > 0"
            >
              <div
                class="row mt-2"
                v-for="(
                  singleCinema, CinemaIndex
                ) in duplicateCinemaSchedule.CopyCinemasArray"
                :key="CinemaIndex"
              >
                <div class="col-11">
                  <div class="row">
                    <div class="col-lg-6 align-self-center mb-1">
                      <div class="dropdown-curve-container pr-28px">
                        <label
                          :class="singleCinema.selectedCinema ? 'shift-up' : ''"
                          style="font-weight: 600"
                          >{{ $tc("cinema", 1) }}
                        </label>

                        <multiselect
                          :options="CinemasArraySchDuplicate"
                          v-model="singleCinema.selectedCinema"
                          @select="onSelectCinemaToCopy($event, CinemaIndex)"
                          label="cine_name"
                          track-by="cine_id"
                          placeholder=""
                          :allowEmpty="false"
                          :showLabels="false"
                        ></multiselect>
                      </div>
                    </div>

                    <div class="col-lg-6 align-self-center mb-1">
                      <div class="dropdown-curve-container pr-28px">
                        <label
                          :class="
                            singleCinema.selectedScreens.length > 0
                              ? 'shift-up'
                              : ''
                          "
                          style="font-weight: 600"
                          >{{ $t("screens") }}
                        </label>

                        <multiselect
                          :options="singleCinema.ScreenListArray"
                          v-model="singleCinema.selectedScreens"
                          label="screen_name"
                          track-by="screen_id"
                          placeholder=""
                          :allowEmpty="false"
                          :showLabels="false"
                          :multiple="true"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <!---Col 1 Starts Here---->
                <div
                  class="col-1 d-flex"
                  :class="CinemaIndex > 0 ? 'border-left' : ''"
                >
                  <button
                    v-if="CinemaIndex > 0"
                    @click.prevent.stop="removeCinemaSchCopy(CinemaIndex)"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>

              <div
                v-if="
                  Cinemas.length - 1 !=
                  duplicateCinemaSchedule.CopyCinemasArray.length
                "
                class="col-12 d-flex align-items-center justify-content-center border-top mt-4 mb-4 position-relative"
              >
                <button
                  @click.prevent.stop="addCinemaSchCopy()"
                  class="btn-white add-plus-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-center mt-4">
              <button
                class="btn-blue"
                :disabled="duplicateCinemaSchedule.moviesArray.length == 0"
                :class="
                  duplicateCinemaSchedule.moviesArray.length == 0
                    ? 'disabled'
                    : ''
                "
                v-if="duplicateCinemaSchedule.selectedScreen"
                @click="onClickSubmitCopyCinemaSch"
              >
                {{ "Submit" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      ref="copyCinemaError"
      id="copyCinemaError"
      title="Conflicts!"
      size="lg"
    >
      <div>
        <div class="add-movie-container">
          <div class="row">
            <div
              class="col-12"
              v-for="(reason, reasonIndex) in copyCinemaScheduleErrorArray"
              :key="reasonIndex"
            >
              <div class="d-flex d-flex justify-content-between">
                <div class="font-weight-bold fs-14 text-danger">
                  {{ reason[0] }}
                </div>
                <div class="fs-12">{{ "Some Schedule(s) Failed to Copy" }}</div>
              </div>
              <div class="swc-report mb-1">
                <table
                  class="text-left conflictTable border mb-3 p-0 listviewtable"
                  border="1"
                >
                  <thead>
                    <tr>
                      <th>Schedule</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th
                        v-if="
                          reason[0] == 'Not Released in Selected Region' ||
                          reason[0].includes('Cannot Schedule')
                        "
                      >
                        Cinema
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    class="sph-report"
                    v-for="(overlap, overlapIndex) in reason[1]"
                    :key="overlapIndex"
                  >
                    <tr>
                      <td>
                        {{
                          (overlap.schedule && overlap.schedule.movie) || "-"
                        }}
                      </td>
                      <td>
                        {{
                          (overlap.schedule &&
                            overlap.schedule.ss_start_show_time) ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          (overlap.schedule &&
                            overlap.schedule.ss_end_show_time) ||
                          "-"
                        }}
                      </td>
                      <td
                        v-if="overlap.reason_id == 3 || overlap.reason_id == 4"
                      >
                        {{ overlap.cinema_name }}
                      </td>
                      <td v-else class="fixedWidth-10">
                        <div class="d-flex w-100 justify-content-center">
                          <button
                            class="btn-transparent rotate-btn"
                            v-if="overlap.schedule.collapse"
                            @click="
                              openMoreScheduleInfo(
                                overlap.schedule,
                                overlapIndex,
                                reasonIndex
                              )
                            "
                          >
                            <img
                              src="@/assets/img/icons/primary/chevron-down.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                          <button
                            class="btn-transparent"
                            v-else
                            @click="
                              openMoreScheduleInfo(
                                overlap.schedule,
                                overlapIndex,
                                reasonIndex
                              )
                            "
                          >
                            <img
                              src="@/assets/img/icons/primary/chevron-down.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr class="bg-lightbg">
                      <td colspan="4" v-if="overlap.schedule.collapse">
                        <b-collapse
                          :id="'overlapMoreInfo-' + overlapIndex + reasonIndex"
                          class="cinema-overview-collapse"
                          v-model="overlap.schedule.collapse"
                        >
                          <div
                            v-if="overlap.reason_id == 1"
                            style="
                              font-weight: 500;
                              margin: 0px 0px 4px 4px;
                              font-size: 12px;
                            "
                          >
                            Overlap With:
                          </div>
                          <table
                            v-if="overlap.reason_id == 1"
                            class="text-left conflictTable border mb-3 p-0 listviewtable"
                            border="1"
                          >
                            <thead>
                              <tr>
                                <th>Schedule</th>
                                <th>Cinema</th>
                                <th>Screen</th>
                                <th>Show</th>
                              </tr>
                            </thead>
                            <tbody class="sph-report">
                              <tr
                                v-for="(overlapSch, overlapSchIndex) in overlap
                                  .schedule.overlap_schedule"
                                :key="overlapSchIndex"
                              >
                                <td>{{ overlapSch.movie_title || "-" }}</td>
                                <td>{{ overlapSch.cinema_name || "-" }}</td>
                                <td>{{ overlapSch.screen_name || "-" }}</td>
                                <td>
                                  {{ overlapSch.ss_start_show_time }} -
                                  {{ overlapSch.ss_end_show_time }}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <div
                            v-if="overlap.reason_id == 2"
                            style="
                              font-weight: 500;
                              margin: 0px 0px 4px 4px;
                              font-size: 12px;
                            "
                          >
                            Format Not Supported
                          </div>
                          <table
                            v-if="overlap.reason_id == 2"
                            class="text-left conflictTable border mb-3 p-0 listviewtable"
                            border="1"
                          >
                            <thead>
                              <tr>
                                <th>Cinema</th>
                                <th>Screen</th>
                              </tr>
                            </thead>
                            <tbody class="sph-report">
                              <tr>
                                <td>{{ overlap.cinema_name || "-" }}</td>
                                <td>{{ overlap.screen_name || "-" }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </b-collapse>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-center mt-4">
              <button
                class="btn-blue"
                @click.prevent.stop="$bvModal.hide('copyCinemaError')"
              >
                {{ "Close" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ "Artwork Image" }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <br />
      <div v-if="movieSelected.sch_artwork_url">
        <img
          :src="_GetImagePath(movieSelected.sch_artwork_url)"
          class="img-fluid"
        />
      </div>
      <div v-else class="mx-auto w-100">
        {{ "No Preview Available" }}
      </div>
    </b-modal>

    <b-modal
      id="viewSeatLayoutModal"
      ref="viewSeatLayoutModal"
      title="Seat Layout"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0 pt-3 justify-content-between">
          <div class="grid-seat-buttons">
            <div class="">
              <div class="pos-seat regular-seat bg-blue"></div>
              <p>Regular {{ $tc("seat", 1) }}</p>
            </div>

            <div>
              <div class="pos-seat wheelchair"></div>
              <p>{{ $t("wheelchair") }}</p>
            </div>

            <div>
              <div class="pos-seat vip-seat bg-blue"></div>
              <p>VIP {{ $tc("seat", 1) }}</p>
            </div>

            <div>
              <div class="pos-seat pointofsale-seat bg-blue"></div>
              <p>{{ $t("onlyPos") }}</p>
            </div>

            <div class="mx-1">
              <div
                class="pos-seat my-0 sofa-seat seat-fixed-width mx-auto bg-blue"
              ></div>
              <small>{{ $tc("Sofa", 1) }}</small>
            </div>

            <div class="">
              <div class="pos-seat recliner-seat bg-blue"></div>
              <p>{{ $t("recliner") }} {{ $tc("seat", 1) }}</p>
            </div>

            <div class="">
              <div
                class="pos-seat my-0 block-seat seat-fixed-width mx-auto"
              ></div>
              <p>{{ $tc("blockSeat", 1) }}</p>
            </div>

            <div class="">
              <div class="pos-seat broken-seat bg-blue"></div>
              <p>{{ $t("broken") }} {{ $tc("seat", 1) }}</p>
            </div>

            <div class="">
              <div class="pos-seat taken"></div>
              <p>{{ $t("taken") }}</p>
            </div>

            <div>
              <div class="pos-seat reserved-seat"></div>
              <p>{{ $t("reserved") }} {{ $tc("seat", 1) }}</p>
            </div>
          </div>
        </div>

        <div :class="['pos-seatlayout']">
          <table v-for="(seat, seatIndex) in seatType" :key="seatIndex">
            <tr v-if="seatIndex === 0">
              <td colspan="30">
                <div class="relative pb-3">
                  <img
                    src="@/assets/img/pos/pos-screen.png"
                    class="img-fluid w-100"
                  />
                  <span class="eyes-text">{{ $t("screen_title") }}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="22">
                <div class="pos-seat-class">
                  {{ seat.seatType }}
                  <strong
                    >({{ seat.seat_price }}
                    {{ currencyData.curr_code }})</strong
                  >
                </div>
              </td>
            </tr>

            <tr
              v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
              :key="seatRowIndex"
            >
              <td
                v-for="(singleSeat, singleSeatIndex) in seatRow"
                :key="'index' + singleSeatIndex"
                :class="
                  singleSeat.sst_seat_type.toLowerCase() == 'sofa'
                    ? 'lounger-container'
                    : ''
                "
              >
                <div v-if="singleSeat.srt_id == 2" class="pos-seatNumber"></div>
                <div v-else class="pos-seatNumber">
                  {{ singleSeat.sl_seat_name }}
                </div>
                <div
                  v-if="singleSeat.seat_reserve_type_id == 5"
                  class="pos-seat bg-blue vip-seat cursor-pointer"
                  disabled
                ></div>
                <div
                  v-else
                  disabled
                  class="pos-seat cursor-pointer"
                  :class="[
                    singleSeat.selectStatus == true
                      ? 'your-selection'
                      : singleSeat.isVipReserved
                      ? 'reserved-seat taken pointer-events'
                      : singleSeat.seat_reserve_type_id == 1
                      ? 'bg-blue regular-seat'
                      : singleSeat.seat_reserve_type_id == 3
                      ? 'bg-blue wheelchair'
                      : singleSeat.seat_reserve_type_id == 6
                      ? 'bg-blue love-seat'
                      : singleSeat.seat_reserve_type_id == 8
                      ? 'taken pointer-events'
                      : singleSeat.seat_reserve_type_id == 10
                      ? 'bg-blue sofa-seat'
                      : singleSeat.seat_reserve_type_id == 9
                      ? 'bg-blue pointofsale-seat'
                      : singleSeat.seat_reserve_type_id == 10
                      ? 'bg-blue normal-seat'
                      : singleSeat.seat_reserve_type_id == 11
                      ? 'bg-blue recliner-seat'
                      : singleSeat.seat_reserve_type_id == 12
                      ? 'new-block-seat'
                      : singleSeat.seat_reserve_type_id == 13
                      ? 'bg-blue pointer-events broken-seat'
                      : 'normal-seat',
                    singleSeat.sst_seat_type.toLowerCase() == 'sofa'
                      ? 'lounger'
                      : '',
                  ]"
                ></div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </b-modal>
    <!-- DELETE MOVIE MODAL -->
    <b-modal
      id="deleteMovieModal"
      ref="deleteMovieModal"
      title="Delete Movie"
      hide-footer
      show
    >
      <div>
        <div class="row mx-0">
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Movie Name:</div>
              <div class="col-8">
                <strong>{{ movieSelected.movie_title }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row hh">
              <div class="col-4">Language:</div>
              <div class="col-8">
                <strong>{{ movieSelected.lang_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.mf_name }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Sound Format:</div>
              <div class="col-8">
                <strong>{{ movieSelected.sound_format_name || "-" }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Run Time</div>
              <div class="col-8">
                <strong>{{ convertToHrs(movieSelected.lengthMinutes) }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Start Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_start_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">End Time</div>
              <div class="col-8">
                <strong>{{ movieSelected.ss_end_show_time }}</strong>
              </div>
            </div>
          </div>

          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Interval Time</div>
              <div class="col-8">
                <strong
                  >{{ CinemasSettings.cine_interval_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-4">Cleaning Time</div>
              <div class="col-8">
                <strong
                  >{{ CinemasSettings.cine_cleaning_time_in_mins }} Mins</strong
                >
              </div>
            </div>
          </div>
          <div class="col-12 border-bottom py-2">
            <div class="row">
              <div class="col-12">
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="movieSelected.delete_reason"
                    v-validate="{ required: 'required' }"
                    name="delete_reason"
                    id="delete_reason"
                  />
                  <label>Reason For Deletion</label>
                </div>
              </div>
            </div>
            <p class="error_message">
              <span v-if="deleteSubmit && errors.has('delete_reason')">{{
                errors.first("delete_reason")
              }}</span>
            </p>
          </div>
          <div class="col-12 pt-3 text-center">
            <button
              v-on:click="
                onDeleteMovie(
                  selectedScreen,
                  movieSelected,
                  selectedScreenIndex,
                  selectedMovieIndex
                )
              "
              class="btn-blue"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="settingsModal"
      ref="settingsModal"
      title="Schedule Settings"
      hide-backdrop
      hide-footer
      centered
      @show="onShowGlobalSettings"
    >
      <div class="row">
        <div class="col-lg-12 mb-4">
          <div class="row">
            <p class="font-weight-bold col-5 mt-2">Default Schedule Type</p>
            <div class="dropdown-curve-container col">
              <multiselect
                class="selectCinemaDandD"
                v-model="settings.defaultScheduleType"
                :options="scheduleDefaultTypeSettings"
                @select="onSelectDefaultScheduleSettings($event)"
                label="name"
                track-by="id"
                :multiple="false"
              ></multiselect>
              <!-- <label :class="cinemasSelected ? 'shift-up' : ''">
                {{ "Schedule Type" }}
              </label> -->
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4 pr-0">
              <label class="font-weight-bold">{{ "Enable Auto Save" }}</label>
            </div>
            <div class="col-md-4 p-0">
              <b-form-checkbox
                v-model="settings.auto_save"
                name="check-button"
                switch
              ></b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="col-12 pt-2 text-center">
          <button class="btn-blue" @click="onSaveGlobalSettings()">Save</button>
        </div>
      </div>
    </b-modal>

    <!-- ADMITS MODAL -->
    <b-modal id="admits" ref="admits" centered hide-footer hide-header>
      <div class="text-center py-4">
        <h5 class="font-weight-bold">Update Admits</h5>

        <div class="d-flex justify-content-center align-items-stretch my-4">
          <button
            class="plus-minus-btn h-50 w-60"
            @click="handleAdmitChange('sub')"
          >
            -
          </button>
          <input
            type="number"
            v-model="currentAdmits"
            :min="0"
            class="flex-grow-1 form-control h-50"
            @change="handleInputChange"
          />
          <button
            class="plus-minus-btn h-50 w-60"
            @click="handleAdmitChange('add')"
          >
            +
          </button>
        </div>
        <div class="text-muted">Total Admits: {{ totalAdmits }}</div>

        <button @click="onSubmitAdmits()" class="btn btn-primary">
          Confirm
        </button>
      </div>
    </b-modal>
    <ManagerAuthLogin
      :moduleName="'SwapAuditorium'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_SwapAuditorium'"
    />
    <ImageGallery
      v-bind:propImageName="'ArtWork Image'"
      v-bind:openModal="showModal"
      v-bind:set_height="NaN"
      v-bind:set_width="NaN"
      :showPercentageLoader="true"
      :img_desc="'Schedule Artwork Image'"
      :resetImgData="false"
      :category="'Movie Poster'"
    ></ImageGallery>
  </div>
</template>

<script>
import momentT from "moment-timezone";
import PosService from "@/services/PosService";
import MasterService from "@/services/MasterService";
import scheduleService from "@/services/scheduleService";
import RefundService from "@/services/RefundService";
import moment, { min } from "moment";
import CinemasService from "@/services/CinemasService";
import { BASEURL } from "@/config/index.js";
import { uniqBy, throttle, debounce, groupBy } from "lodash";
import DatePicker from "vue2-datepicker";
import { directive as onClickaway } from "vue-clickaway";
import _ from "lodash";
import { mapGetters } from "vuex";
import ImageGallery from "@/components/Pages/ImageGallery/imageGalleryModal";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import DuplicateDay from "@/components/Pages/ExhibitorManagement/ScheduleComponents/duplicateDay";
import VueCropper from "vue-cropperjs";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

export default {
  directives: {
    onClickaway: onClickaway,
  },
  components: {
    DatePicker,
    ImageGallery,
    VueCropper,
    VueTimepicker,
    ManagerAuthLogin,
    DuplicateDay,
  },
  data() {
    return {
      disableBtns: {
        updateMovieBtn: false,
      },
      movieListObj: {
        perPage: 30,
        currentPage: 1,
        rows: 0,
      },
      copyCinemaScheduleErrorArray: [],
      newMovieDefaultData: null,
      AddonChargesArray: [],
      selectedScheduleStatus: "",
      routerNav: {
        to: null,
        allowLeaveWithoutSave: false,
      },
      mouseOverScreen: false,
      aggregatorUsersList: [],
      autoSaveObj: {
        rateCardWarningData: "",
        rateCardissueMovie: "",
        rateCardissueScreen: "",
        rateCardissueShow: "",
      },
      scheduleDefaultTypeSettings: [
        { name: "Schedule", value: 16, id: 1 },
        { name: "Planned", value: 19, id: 2 },
      ],
      settings: {
        auto_save: false,
        default_schedule_status_type: 16,
        defaultScheduleType: { name: "Schedule", value: 16, id: 1 },
      },
      leftValue: 0,
      selectedMovieForEditWeekWiseDay: {
        weekDayArray: [],
      },
      isScreenDuplicate: false,
      duplicateScreenObj: {
        screen_id: null,
        selectedScreen: "",
        start_date: new Date(),
        end_date: new Date(),
        moviesArray: [],
      },
      duplicateCinemaSchedule: {
        screen_id: null,
        selectedScreen: "",
        selectedCinema: "",
        start_date: new Date(),
        end_date: new Date(),
        moviesArray: [],
        CopyCinemasArray: [
          {
            selectedCinema: "",
            cinema_id: "",
            ScreenListArray: [],
            selectedScreens: [],
          },
        ],
      },
      screenArrayInsert: [],
      MultipleSchedule: [],
      overlappedSingleMultiScheduleArray: [],
      resolvedSingleMultiScheduleArray: [],
      colorCollapse: false,
      weekdayerror: "",
      newStatusId: 1619,
      weekDays: {
        selectAll: true,
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
      },
      statusArrayNew: [
        { type: "Scheduled/Planned", status_id: 1619 },
        { type: "Scheduled Only", status_id: 16 },
        { type: "Planned", status_id: 19 },
        { type: "Deleted", status_id: 17 },
        { type: "Event", status_id: 1600 },
        { type: "Private Shows", status_id: 3 },
        { type: "On Demand", status_id: 2 },
      ],
      weekDaysArray: [
        {
          dayName: "selectAll",
          value: true,
          scheduling_price: [],
          day: null,
        },
        {
          dayName: "Sunday",
          value: true,
          scheduling_price: [],
          day: 0,
        },
        {
          dayName: "Monday",
          value: true,
          scheduling_price: [],
          day: 1,
        },
        {
          dayName: "Tuesday",
          value: true,
          scheduling_price: [],
          day: 2,
        },
        {
          dayName: "Wednesday",
          value: true,
          scheduling_price: [],
          day: 3,
        },
        {
          dayName: "Thursday",
          value: true,
          scheduling_price: [],
          day: 4,
        },
        {
          dayName: "Friday",
          value: true,
          scheduling_price: [],
          day: 5,
        },
        {
          dayName: "Saturday",
          value: true,
          scheduling_price: [],
          day: 6,
        },
      ],
      singleDuplicateDetails: {
        ss_start_date: "",
        ss_end_date: "",
      },
      selectedMultiShowSchedule: null,
      deletedScheduleDetails: null,
      showModal: false,
      duplicate: {
        cine_id: null,
        ss_start_date: "",
        ss_end_date: "",
      },
      showFooterDetails: true,
      currencyData: null,
      screenObj: null,
      seatLayoutData: [],
      selectedSchedule: null,
      scheduleStatusType: null,
      showTypeFilter: { type: "Scheduled/Planned", status_id: 1619 },
      showTypeFilterId: 16,
      movietoggleOn: false,
      filmTitle: "",
      searchScreen: "",
      tab: "",
      editRightMouseMovieBlock: {
        show: false,
        X: 0,
        Y: 0,
      },
      clickSelectedMovies: [],
      btenable: false,
      deleteFlag: false,
      submitted: true,

      typeList: [
        {
          color: "green",
          name: "Regular Schedule",
        },
        {
          color: "gold",
          name: "Planned Schedule",
        },
        {
          color: "#88F588",
          name: "Rate Card Data Added",
        },
        {
          color: "red",
          name: "Rate Card Data Not Added",
        },
        {
          color: "#ebebeb",
          name: "Disabled Schedule",
        },
        {
          color: "#ADD8E6",
          name: "Private Screening",
        },
      ],

      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },

      timeZone: {
        tz_name: "",
        tz_utc_offset: "",
      },

      duplicate: {
        cine_id: null,
        ss_start_date: "",
        ss_end_date: "",
      },
      deleteSubmit: false,
      searchRateCard: "",
      topValue: 0,
      intervalsArray: [],
      isRoleID: true,
      Cinemas: [],
      baseURL: BASEURL,
      movieSelected: {
        delete_reason: "Please Enter Reason for Deletion",
        lang_name: "Spanish",
        md_id: 12,
        md_thumbnail_url: "/uploads/movies/1566220586425-dummy.jpg",
        mf_name: "3D",
        movie_id: 7,
        movie_is_active: "Y",
        movie_title: "Frozen 2",
        mrrdr_runtime: 132,
        interval_time_in_mins: "",
        cleaning_time_in_mins: "",
        ads_time_in_mins: "",
        start_time: "",
        turnOffMultiSeatSelection: false,
        is_special_schedule: false,
      },
      selectedMovieIndex: null,
      selectedScreenIndex: null,
      selectedScreenTypeIndex: null,
      //
      selectedScreen: {},
      cinemasSelected: "",
      cinemaSelectedPlaceHolder: "Select Cinema",
      selectedCinema: "",
      selectedDuplicateCinema: "",
      lists: {
        movies: [],
        cinemas: {
          list: [],
          selectedCinema: {
            cine_name: "",
          },
        },
        screens: [],
      },
      selectedNewDate: "",
      initialSelectedScreen: "Screen 2",
      silderOne: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 7,
      },
      silderTwo: {
        infinite: false,
        dots: false,
        arrows: true,
        slidesToShow: 5,
      },
      dropLocation: {
        screen: "-1",
        hour: "",
        minute: "",
        positionLeft: "",
        positionLeftEndTime: "",
        time: "",
      },
      dropLocationClone: {},
      draggedObject: {
        screen: "",
        length: "",
        oldStart: "",
        newStart: "",
        movie: "",
      },
      selectedMoviesInScreens: [],
      selectedMoviesInScreensFlag: false,

      // Saif

      showScheduleCard: false,
      selectedScreenSeatTypes: [],
      selectedRateCardObject: {},

      CinemasList: [],
      MoviesList: [],
      ScreenList: [],
      RatecardsList: [],
      RatecardsListCopy: [],
      CinemasSettings: {
        cine_setting_id: null,
        cine_id: null,
        cine_operation_start_time: null,
        cine_operation_end_time: null,
        cine_cleaning_time_in_mins: null,
        cine_setting_ads_time_in_mins: null,
        cine_interval_time_in_mins: null,
        cine_seat_release_time_in_mins: null,
        cine_cutoff_time_in_mins: null,
        cine_setting_is_active: "Y",
      },
      selected: {
        cinema: "",
      },
      scheduleObject: {
        cinema_id: null,
        sch_start_date: null,
        sch_end_date: null,
        sch_is_active: "Y",
      },

      FinalScreenAndMovieScheduleList: [
        {
          screen_id: null,
          screen_name: "",

          // sch_start_date: null,
          // sch_end_date: null,
          // sch_is_active: "Y",
          movies: [
            {
              movie_details_id: null,
              movie_title: null,
              ss_start_show_time: null,
              ss_end_show_time: null,
              ss_start_date: null,
              ss_end_date: null,
              ss_start_date_time: null,
              ss_end_date_time: null,
              ss_actual_end_date: null,
              ss_actual_end_date_time: null,
              ss_actual_start_date: null,
              ss_actual_start_date_time: null,
              ss_is_active: "Y",
              scheduleShowPrice: [
                {
                  searchRateCard: null,
                  rate_card_id: null,
                  schedule_show_id: null,
                  screen_seat_type_id: null,
                  sst_seat_type: "",
                  p_start_date_time: null,
                  p_end_date_time: null,
                  p_is_active: "Y",
                },
              ],
            },
          ],
        },
      ],
      FinalArray: [],
      selectedStatusId: 16,
      debounce: null,
      screenSearchDebounce: null,
      // Saif
      //NEW
      isMovieCardSelected: false,
      isPastShow: false,
      selectedSessionType: "Closed",
      getStatusId: 16,
      isChanged: false,
      selectedStatus: "",
      scheduleStatusArray: [
        { type: "Schedule", status_id: 16 },
        { type: "Planned", status_id: 19 },
      ],
      currentAdmits: 0,
      remainingAdmits: 0,
      BookingID: null,
      totalAdmits: 0,
      checkAdmitValid: false,
      AdmitError: "",
      zoomLevel: 2,
      duplicateSubmitted: false,
      updateTime: null,
      arrayDays_duplicate: [
        {
          day: "is_sunday",
          checkDay: 0,
        },
        {
          day: "is_monday",
          checkDay: 1,
        },
        {
          day: "is_tuesday",
          checkDay: 2,
        },
        {
          day: "is_wednesday",
          checkDay: 3,
        },
        {
          day: "is_thursday",
          checkDay: 4,
        },
        {
          day: "is_friday",
          checkDay: 5,
        },
        {
          day: "is_saturday",
          checkDay: 6,
        },
      ],
      duplicateDayMovieList: [],
    };
  },
  computed: {
    ...mapGetters([
      "finalImagePath",
      "MANAGER_AUTH_FOR_CHANGES",
      "MANAGER_AUTH_FOR_REPRINT",
    ]),
    defaultRateCardDuplicate() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.empire) || false;
    },
    showSpecialScreeningFlag() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.EPIX) || false;
    },
    validScreenList() {
      return [...this.ScreenList]
        .filter((_screen) => this.checkScreenValidity(_screen))
        .sort((a, b) => a.screen_order - b.screen_order);
    },
    CinemasArraySchDuplicate() {
      let cinemas = _.cloneDeep(this.Cinemas);
      cinemas = cinemas.filter(
        (x) =>
          !this.duplicateCinemaSchedule.CopyCinemasArray.some(
            (y) => y.cinema_id == x.cine_id
          ) && x.cine_id != this.scheduleObject.cinema_id
      );
      return cinemas;
    },
    movieSelectedSchedulePriceArray() {
      if (
        this.movieSelected &&
        this.movieSelected.hasOwnProperty("scheduleShowPrice") &&
        this.movieSelected.scheduleShowPrice.length > 0
      ) {
        return this.movieSelected.scheduleShowPrice;
      } else {
        return [];
      }
    },
    showScreenDetails() {
      return this.mouseOverScreen;
    },
    getLeftScroll() {
      let defaultLeft = -46;
      return parseFloat(defaultLeft + this.leftValue);
    },
    autoSave() {
      return this.settings.auto_save;
    },
    DefaultScheduleTypeonDrop() {
      return this.settings.default_schedule_status_type;
    },
    fixedConflicts() {
      let count = 0;
      this.resolvedSingleMultiScheduleArray.map((x) => {
        if (x.hasOwnProperty("overlap")) {
          count++;
        }
      });

      if (count > 0) {
        return true;
      } else {
        return false;
      }
    },
    overlappedCount() {
      let count = 0;
      this.overlappedSingleMultiScheduleArray.map((x) => {
        count += x.overlap_schedule.length;
      });

      return count;
    },
    seatType() {
      return this.seatLayoutData;
    },
    zoomIndex() {
      if (this.zoomLevel == 1) {
        return 0.8;
      } else if (this.zoomLevel == 2) {
        return 0.9;
      } else if (this.zoomLevel == 3) {
        return 1;
      }
    },
    isMovieSelected() {
      return (
        this.selectedMoviesInScreens.filter((singleScreen) => {
          return singleScreen.movies.length > 0;
        }).length > 0
      );
    },
    SelectedDate() {
      return this.scheduleObject.sch_start_date;
    },
    allowChangeVersion() {
      let status = false;
      let settings = [];
      let globalOptions = this.$store.getters.getGlobalOptions;
      if (globalOptions && globalOptions.length > 0) {
        settings = globalOptions.filter(
          (x) => x.go_key == "CHANGE_VERSION_IN_SCHEDULE"
        );
      }
      if (settings && settings.length > 0) {
        status = settings[0].go_value == "Y" ? true : false;
      }

      return status;
    },
    globalList() {
      let globalOptions = this.$store.getters.getGlobalOptions;
      let settings = [];
      if (globalOptions && globalOptions.length > 0) {
        settings = globalOptions.filter(
          (x) =>
            x.go_key == "SCHEDULE_AUTO_SAVE" ||
            x.go_key == "DEFAULT_DROP_SCHEDULE_STATUS_ID"
        );
      }
      return settings;
    },
  },
  watch: {
    SelectedDate: function (val) {
      this.$store.dispatch("setSchDropDownDates", val);
    },
    finalImagePath(newval) {
      this.movieSelected.sch_artwork_url = newval;
      this.$forceUpdate();
    },
  },
  mounted: function () {
    // this.startTour("myScheduleDragAndDropTour2");
    this.updateTime = setInterval(() => {
      this.$forceUpdate();
    }, 60 * 1000);
    document.addEventListener("keyup", this.arrowLeftRight);
    window.addEventListener("search", this.getActiveMoviesonClear);
  },
  destroyed: function () {
    clearInterval(this.updateTime);
    document.removeEventListener("keyup", this.arrowLeftRight);
    document.removeEventListener("search", this.getActiveMoviesonClear);
  },
  beforeRouteLeave(to, from, next) {
    // if (this.isChanged && !this.routerNav.allowLeaveWithoutSave) {
    //   this.routerNav.to = to;
    //   this.showFooterDetails = false;
    //   this.$refs.beforeLeaveConfimation.show();
    //   return;
    // } else {
    //   next();
    // }

    let checkRouteArray = ["/swap-auditorium", "/merge-schedule"];

    if (
      !this.routerNav.allowLeaveWithoutSave &&
      checkRouteArray.some((x) => to.path.includes(x)) &&
      this.MANAGER_AUTH_FOR_CHANGES == "Y"
    ) {
      this.routerNav.to = to;
      this.showFooterDetails = false;
      this.$bvModal.show("authManager_SwapAuditorium");
      return;
    } else {
      next();
    }

    // next();
  },
  beforeMount: function () {
    // this.getAllActiveScreens();
    // this.getAllMovies();
    // this.getAllActiveCinemas();
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList();
    } else {
      this.getCinemaList(obj);
    }
    // this.getCinemaList(obj);
    this.getSettingsDetails();
    const tempCinemaId = this.$route.query["cinema_id"];
    this.getPosAggregatorUsers(tempCinemaId);
    this.getCurrencyCode();

    console.table({
      "this.$store.getters.schDropDownDate":
        this.$store.getters.schDropDownDate,
    });

    this.scheduleObject.sch_start_date = new Date(); // this.$store.getters.schDropDownDate;
    this.scheduleObject.sch_end_date = new Date();

    // let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //  this.onSelectCinemaFromMultiSelect(CinemaObj)
    // }
  },
  methods: {
    onSelectDuplicateScreenSalesChannel(event, movieIndex) {
      console.log({
        event,
        movieIndex,
        mArray: this.duplicateScreenObj.moviesArray,
      });
      if (
        !this.duplicateScreenObj.moviesArray[movieIndex].sales_channel_changes
      ) {
        movie.sales_channel_changes = [];
      }
      event["is_changed"] = true;
      event["value"] = "Y";
      if (this.duplicateScreenObj.moviesArray[movieIndex]["ss_id"]) {
        event["ss_id"] = this.duplicateScreenObj.moviesArray[movieIndex].ss_id;
      }
      if (this.duplicateScreenObj.moviesArray[movieIndex]["md_id"]) {
        event["md_id"] = this.duplicateScreenObj.moviesArray[movieIndex].md_id;
      }
      let checkIndex = -1;
      checkIndex = this.duplicateScreenObj.moviesArray[
        movieIndex
      ].sales_channel_changes.findIndex(
        (user) => user.user_id == event.user_id
      );
      if (checkIndex > -1) {
        this.duplicateScreenObj.moviesArray[
          movieIndex
        ].sales_channel_changes.splice(checkIndex, 1);
      } else {
        this.duplicateScreenObj.moviesArray[
          movieIndex
        ].sales_channel_changes.push(event);
      }
    },
    onRemoveDuplicateScreenSalesChannel(event, movieIndex) {
      console.log({ event, movieIndex });
      event["is_changed"] = true;
      event["value"] = "N";
      if (this.duplicateScreenObj.moviesArray[movieIndex]["ss_id"]) {
        event["ss_id"] = this.duplicateScreenObj.moviesArray[movieIndex].ss_id;
      }
      if (this.duplicateScreenObj.moviesArray[movieIndex]["md_id"]) {
        event["md_id"] = this.duplicateScreenObj.moviesArray[movieIndex].md_id;
      }
      let checkIndex = -1;
      checkIndex = this.duplicateScreenObj.moviesArray[
        movieIndex
      ].sales_channel_changes.findIndex(
        (user) => user.user_id == event.user_id
      );
      if (checkIndex > -1) {
        this.duplicateScreenObj.moviesArray[
          movieIndex
        ].sales_channel_changes.splice(checkIndex, 1);
      } else {
        this.duplicateScreenObj.moviesArray[
          movieIndex
        ].sales_channel_changes.push(event);
      }
    },
    checkScreenValidity(_screen) {
      let status = true;
      if (
        _screen.hasOwnProperty("valid_from_date") &&
        moment(_screen["valid_from_date"]).isValid()
      ) {
        if (
          moment(
            moment(_screen["valid_from_date"]).format("YYYY-MM-DD")
          ).isAfter(
            moment(this.scheduleObject["sch_start_date"]).format("YYYY-MM-DD")
          )
        ) {
          status = false;
        }
      }
      if (
        _screen.hasOwnProperty("valid_to_date") &&
        moment(_screen["valid_to_date"]).isValid()
      ) {
        if (
          moment(
            moment(_screen["valid_to_date"]).format("YYYY-MM-DD")
          ).isBefore(
            moment(this.scheduleObject["sch_start_date"]).format("YYYY-MM-DD")
          )
        ) {
          status = false;
        }
      }
      return status;
    },
    filteredRateCardList(screen, screenType, tempArr = []) {
      // console.log('selectedMovie filteredRateCardList', this.movieSelected, tempArr);
      let selectedScreen = _.cloneDeep(screen);
      let sst_id = screenType["sst_id"] || screenType["screen_seat_type_id"];
      let returnArray = [];
      let mappedRcArray = selectedScreen["selectedMappedRateCards"].filter(
        (x) => x.sst_id == sst_id
      );

      let isForeignMovie = "N";
      if (
        this.movieSelected &&
        this.movieSelected.hasOwnProperty("is_foreign_movie") &&
        this.movieSelected["is_foreign_movie"] &&
        !this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)
      ) {
        isForeignMovie = this.movieSelected["is_foreign_movie"] || "N";
      }

      if (
        selectedScreen["selectedMappedRateCards"].length == 0 ||
        mappedRcArray.length == 0 ||
        !sst_id
      ) {
        returnArray = _.cloneDeep(tempArr);
      } else {
        returnArray = tempArr.filter((x) =>
          mappedRcArray.some((y) => y.rc_g_id == x.rc_g_id)
        );
      }
      return returnArray.filter((x) => x.is_foreign_rc == isForeignMovie);
    },
    onChangeMovieListPagination: function (event) {
      if (event) {
        this.movieListObj.currentPage = event;
      } else {
        this.movieListObj.currentPage = 1;
      }
      this.getAllActiveMovies();
    },
    openMoreScheduleInfo(schedule, overlapIndex, reasonIndex) {
      this.copyCinemaScheduleErrorArray.forEach((x, reasonIndexloop) => {
        x[1].forEach((y, overlapIndexloop) => {
          if (
            reasonIndexloop == reasonIndex &&
            overlapIndex == overlapIndexloop
          ) {
            y.schedule.collapse = !y.schedule.collapse;
          } else {
            y.schedule.collapse = false;
          }
        });
      });
      this.$forceUpdate();
    },
    clearDuplicateCinemaSchedule() {
      this.duplicateCinemaSchedule = {
        screen_id: null,
        selectedScreen: "",
        start_date: new Date(this.scheduleObject.sch_start_date),
        end_date: new Date(this.scheduleObject.sch_start_date),
        moviesArray: [],
        CopyCinemasArray: [
          {
            selectedCinema: "",
            cinema_id: "",
            ScreenListArray: [],
            selectedScreens: [],
          },
        ],
      };
    },
    getScreensByCinemaPromise: function (cinema_id) {
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show();
        let ScreensList = [];
        let payload = {
          cinema_id: cinema_id,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              ScreensList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              resolve(ScreensList);
            } else {
              resolve(ScreensList);
            }
          })
          .catch((error) => {
            console.log("Error:", error);
            resolve(ScreensList);
          })
          .finally(() => {
            loader.hide();
          });
      });
    },
    validateDuplicateCinemaSch(showErrorMsg = true) {
      let errorCount = 0;
      let errorMsg = "";

      if (
        !this.duplicateCinemaSchedule.CopyCinemasArray.some((x) => x.cinema_id)
      ) {
        errorCount++;
        errorMsg = "Please Select atleast one cinema to copy schedule";
      } else if (!this.scheduleObject.cinema_id) {
        errorCount++;
        errorMsg = "Please Select Cinema";
      } else if (!this.duplicateCinemaSchedule.screen_id) {
        errorCount++;
        errorMsg = "Please Select Screen";
      } else if (!this.duplicateCinemaSchedule.start_date) {
        errorCount++;
        errorMsg = "Please Select Date";
      } else if (
        this.duplicateCinemaSchedule.CopyCinemasArray.some(
          (x) => x.cinema_id && x.selectedScreens.length == 0
        )
      ) {
        errorCount++;
        errorMsg = "Please Select Screen";
      }

      if (errorCount > 0) {
        if (showErrorMsg) {
          this.$toasted.show(errorMsg);
        }
        return false;
      } else {
        return true;
      }
    },
    onClickSubmitCopyCinemaSch() {
      if (this.validateDuplicateCinemaSch()) {
        let loader = this.$loading.show();
        let tempArr = this.duplicateCinemaSchedule.CopyCinemasArray.filter(
          (x) => x.cinema_id
        );
        this.duplicateCinemaSchedule["CopyCinemasArray"] = _.cloneDeep(tempArr);

        let payload = {
          cinema_id: this.scheduleObject.cinema_id,
          screen_id: this.duplicateCinemaSchedule.screen_id,
          duplicate_obj: this.duplicateCinemaSchedule,
        };

        scheduleService
          .CopyCinemaSchedule(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
              this.getSchedule();
              this.$refs.duplicateCinemaSchedule.hide();
            } else {
              this.$toasted.show(data.message);
            }

            if (
              data.hasOwnProperty("overlapFinalArray") &&
              data.overlapFinalArray.length > 0
            ) {
              data.overlapFinalArray.forEach((x) => {
                x["collapse"] = false;
              });

              this.copyCinemaScheduleErrorArray = _.toPairs(
                _.groupBy(data.overlapFinalArray, "reason")
              );
              this.$refs.copyCinemaError.show();
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    addCinemaSchCopy() {
      let obj = {
        selectedCinema: "",
        cinema_id: "",
        ScreenListArray: [],
        selectedScreens: [],
      };
      this.duplicateCinemaSchedule.CopyCinemasArray.push(obj);
    },
    removeCinemaSchCopy(CinemaIndex) {
      this.duplicateCinemaSchedule.CopyCinemasArray.splice(CinemaIndex, 1);
    },
    async onSelectCinemaToCopy(cinema, CinemaIndex) {
      this.duplicateCinemaSchedule.CopyCinemasArray[CinemaIndex].cinema_id =
        cinema.cine_id;
      this.duplicateCinemaSchedule.CopyCinemasArray[
        CinemaIndex
      ].ScreenListArray = await this.getScreensByCinemaPromise(cinema.cine_id);
      this.duplicateCinemaSchedule.CopyCinemasArray[
        CinemaIndex
      ].selectedScreens = [];
    },
    onClickDuplicateCinemaSchedule() {
      if (!this.scheduleObject.cinema_id) {
        this.$toasted.show("Please Select Cinema");
      } else {
        this.duplicateCinemaSchedule.start_date = new Date(
          this.scheduleObject.sch_start_date
        );
        this.$forceUpdate();
        this.$refs.duplicateCinemaSchedule.show();
      }
      this.showFooterDetails = false;
    },
    onChangeVersion(event, movieSelected, newSchedule = false) {
      let versionObj = {
        movie_id: event.movie_id,
        md_id: event.md_id,
        movie_name: event.movie_name,
        sound_format_id: event.sound_format_id,
        mf_id: event.mf_id,
      };
      movieSelected["version"] = versionObj;

      console.log("movieSelected", movieSelected);

      let skipKeys = [
        "scheduleShowPrice",
        "version",
        "isNewSchedule",
        "show_schedule_id",
        "unpaid_count",
        "ss_comment",
        "booked_seats",
        "admits",
      ];

      Object.keys(movieSelected).map((key) => {
        if (!skipKeys.includes(key)) {
          movieSelected[key] = event[key] || movieSelected[key];
        }
      });
      if (newSchedule) {
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ] = _.cloneDeep(movieSelected);
      }
    },
    getVersionList(movieSelected) {
      let versionArray = [];
      let tempArray = this.MoviesList.filter(
        (x) => x.movie_id == movieSelected.movie_id
      );
      if (tempArray && tempArray.length > 0) {
        tempArray.forEach((screenMovie) => {
          let errCount = 0;
          if (
            this.selectedScreen.hasOwnProperty("videoFormats") &&
            this.selectedScreen.videoFormats.length > 0
          ) {
            let videoFormats = this.selectedScreen.videoFormats.map(
              (vf) => vf.mf_id
            );
            if (
              screenMovie.mf_id &&
              !videoFormats.includes(screenMovie.mf_id)
            ) {
              errCount++;
            }
          }

          if (
            this.selectedScreen.hasOwnProperty("soundFormats") &&
            this.selectedScreen.soundFormats.length > 0
          ) {
            let soundFormats = this.selectedScreen.soundFormats.map(
              (sf) => sf.sound_format_id
            );
            if (
              screenMovie.sound_format_id &&
              !soundFormats.includes(screenMovie.sound_format_id)
            ) {
              errCount++;
            }
          }

          screenMovie["AddonsCharges"] = [];
          screenMovie["sales_channel"] = [];
          screenMovie["sales_channel_changes"] = [];

          if (screenMovie.mf_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 1 &&
                z.main_id == screenMovie.mf_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            screenMovie["AddonsCharges"].push(...tempArray);
          }
          if (screenMovie.movie_experience_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 2 &&
                z.main_id == screenMovie.movie_experience_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            screenMovie["AddonsCharges"].push(...tempArray);
          }
          if (screenMovie.sound_format_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 3 &&
                z.main_id == screenMovie.sound_format_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            screenMovie["AddonsCharges"].push(...tempArray);
          }
          if (screenMovie.movie_resolution_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 4 &&
                z.main_id == screenMovie.movie_resolution_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            screenMovie["AddonsCharges"].push(...tempArray);
          }
          if (screenMovie.aspect_ratio_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 5 &&
                z.main_id == screenMovie.aspect_ratio_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            screenMovie["AddonsCharges"].push(...tempArray);
          }
          let tempArray = [];
          tempArray = this.AddonChargesArray.filter(
            (z) =>
              z.type_id == 0 &&
              z.add_ons_price > 0 &&
              z.is_compulsory_add_ons == "Y"
          );
          screenMovie["AddonsCharges"].push(...tempArray);

          if (
            screenMovie.hasOwnProperty("md_sales_channel") &&
            screenMovie.md_sales_channel
          ) {
            screenMovie.sales_channel = [];
            this.aggregatorUsersList.map((u) => {
              if (
                !screenMovie.md_sales_channel.some(
                  (el) => el.user_id == u.user_id
                )
              ) {
                let obj = {
                  ...u,
                  is_changed: true,
                  value: "N",
                  ss_id: undefined,
                  md_id: undefined,
                };
                screenMovie.sales_channel_changes.push(obj);
              } else {
                screenMovie.sales_channel.push(u);
              }
            });
          }

          if (errCount == 0) {
            versionArray.push(screenMovie);
          }
        });
      }
      return versionArray;
    },
    removeElement: function (element) {
      this.$refs.addonCharges.removeElement(element);
    },
    async onClickSwapAuditorium({ md_id, screen_id, ss_id }, type) {
      let disablePayload = {
        md_id: md_id,
        ss_id: ss_id,
        type: 1,
      };

      await MasterService.EnableDisableSchedule(disablePayload);

      if (type == 1) {
        this.$router.push({
          name: "Swap Auditorium",
          params: {
            md_id: md_id,
            screen_id: screen_id,
            ss_id: ss_id,
            type: type,
          },
        });
      } else if (type == 2) {
        this.$router.push({
          name: "Merge Schedule",
          params: {
            md_id: md_id,
            screen_id: screen_id,
            ss_id: ss_id,
            type: type,
          },
        });
      }
    },
    getAllAddonsCharges() {
      if (this.scheduleObject.cinema_id) {
        this.AddonChargesArray = [];
        let payload = {
          cinema_id: this.scheduleObject.cinema_id,
        };
        MasterService.getAllAddonsCharges(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.AddonChargesArray = data.Records.filter(
                (z) => z.add_ons_price > 0 && z.is_addons_active == "Y"
              );
            } else {
              console.log("Error:", data.message);
            }
          })
          .catch((err) => {
            console.log("Error Catch:", err);
          });
      } else {
        console.log("Please Select Cinema: Get Addons Charges");
      }
    },
    onHideEditNewSchModal(event) {
      if (event.trigger == "backdrop") {
        this.onCloseEditNewSchModal();
      }
    },
    onCloseEditNewSchModal() {
      this.movieSelected = _.cloneDeep(this.newMovieDefaultData);
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ] = _.cloneDeep(this.newMovieDefaultData);
      this.$bvModal.hide("updateSalesChannelNew");
      this.$forceUpdate();
    },
    checkDrag(event) {
      console.log("Dragging Element", event);
    },
    checkStartTimeChageAllowed(movie, showToast = true) {
      let count = 0;
      if (
        movie.hasOwnProperty("unpaid_count") &&
        !isNaN(movie.unpaid_count) &&
        movie.unpaid_count > 0
      ) {
        count++;
      } else if (
        movie.hasOwnProperty("booked_seats") &&
        !isNaN(movie.booked_seats) &&
        movie.booked_seats > 0
      ) {
        count++;
      }
      if (count > 0) {
        if (showToast) {
          this.$toasted.show(
            "Transaction(s) found for this show. Edit Not Allowed."
          );
        }
        return true;
      } else {
        return false;
      }
    },
    onHandleEditSaveNewSchedule(save) {
      if (!this.movieSelected.start_time) {
        return this.$toasted.show("Please Select Start Time");
      } else {
        // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        //   this.selectedMovieIndex
        // ] = _.cloneDeep(this.movieSelected);
        this.disableBtns["updateMovieBtn"] = true;
        let start = this.newGetScreenPositionCalc(
          this.movieSelected.start_time,
          this.movieSelected.start_time.split(":")[1]
        );
        this.movieSelected.start = start;
        let end_time = moment(this.movieSelected.selected_time)
          .add(parseInt(this.movieSelected.lengthMinutes), "m")
          .toDate();
        this.movieSelected.end_time = moment(end_time).format("HH:mm");

        let overlap = this.checkOverLapMovie(
          this.movieSelected,
          this.movieSelected.screen
        );
        if (overlap && overlap.status) {
          this.disableBtns["updateMovieBtn"] = false;
          this.$toasted.show(
            `Movie Overlapped with ${overlap.movie.movie_title} starting at ${overlap.movie.start_time} and ending at  ${overlap.movie.end_time}`,
            {
              duration: 5000,
            }
          );
          this.movieSelected.start = this.movieSelected.old_start;
          this.movieSelected.end_time = this.movieSelected.old_end_time;
          this.movieSelected.start_time = this.movieSelected.old_start_time;
          this.movieSelected["selected_time"] =
            moment().format("YYYY-MM-DD") +
            " " +
            this.movieSelected.old_start_time;
        } else {
          this.$refs.updateSalesChannelNew.hide();
          if (save) {
            this.isChanged = true;
            this.submitSchedule();
          }
        }
      }
    },
    checkIndicator(movie) {
      if (
        movie.sales_channel &&
        movie.sales_channel.length == movie.all_sales_channel_length
      ) {
        return false;
      } else {
        return true;
      }
    },
    onCheckAuthentication(response) {
      const { valid, name } = response;
      if (valid) {
        if (name == "SwapAuditorium") {
          this.$bvModal.hide("authManager_SwapAuditorium");
          this.routerNav.allowLeaveWithoutSave = true;
          this.$router.push(this.routerNav.to);
        }
      }
    },
    closeDialogBeforeLeave() {
      // this.routerNav.to = null
      this.routerNav.allowLeaveWithoutSave = false;
      this.$refs.beforeLeaveConfimation.hide();
      console.log("Cancel POPUP leave");
    },
    discardChanges() {
      console.log("Coming to discard Changes", this.routerNav);
      this.routerNav.allowLeaveWithoutSave = true;
      this.$refs.beforeLeaveConfimation.hide();
      this.$router.push(this.routerNav.to);
    },
    saveChangesBeforeLeave() {
      console.log("Coming to Save Changes before leave", this.routerNav);
      this.$refs.beforeLeaveConfimation.hide();
      this.routerNav.allowLeaveWithoutSave = true;
      this.submitSchedule();
      setTimeout((x) => {
        this.$router.push(this.routerNav.to);
      }, 1000);
    },
    EditNewSchedule(screenMovie, screen) {
      this.showFooterDetails = false;
      this.newMovieDefaultData = _.cloneDeep(screenMovie);
      this.movieSelected = screenMovie;
      this.selectedScreen = screen;

      let versionObj = {
        movie_id: screenMovie.movie_id,
        md_id: screenMovie.md_id,
        movie_name: screenMovie.movie_name,
        sound_format_id: screenMovie.sound_format_id,
        mf_id: screenMovie.mf_id,
      };
      let tempObj = {
        version: versionObj,
        startTime2: screenMovie.start_time,
        selected_time:
          moment().format("YYYY-MM-DD") + " " + screenMovie.start_time,
      };
      this.movieSelected = { ...this.movieSelected, ...tempObj };

      let selectedStatus = this.scheduleStatusArray.filter(
        (x) => x.status_id == this.movieSelected.ss_show_status
      );
      if (selectedStatus.length > 0) {
        this.selectedStatus = selectedStatus[0].type;
        this.selectedScheduleStatus = selectedStatus[0];
      }
      this.$refs.updateSalesChannelNew.show();
    },
    onSelectSalesChannel(event, movie) {
      console.log("SELECT EVENT", event);
      event["is_changed"] = true;
      event["value"] = "Y";
      event["ss_id"] = this.movieSelected.ss_id;
      event["md_id"] = this.movieSelected.md_id;
      let checkIndex = -1;
      checkIndex = this.movieSelected.sales_channel_changes.findIndex(
        (user) => user.user_id == event.user_id
      );
      if (checkIndex > -1) {
        this.movieSelected.sales_channel_changes.splice(checkIndex, 1);
        // this.movieSelected.sales_channel_changes.push(event)
      } else {
        this.movieSelected.sales_channel_changes.push(event);
      }
      console.log(
        "this.movieSelected.sales_channel_changes",
        this.movieSelected.sales_channel_changes
      );
    },
    onRemoveSalesChannel(event, movie) {
      console.log("Remove EVENT", event);
      event["is_changed"] = true;
      event["value"] = "N";
      event["ss_id"] = this.movieSelected.ss_id;
      event["md_id"] = this.movieSelected.md_id;
      let checkIndex = -1;
      checkIndex = this.movieSelected.sales_channel_changes.findIndex(
        (user) => user.user_id == event.user_id
      );
      if (checkIndex > -1) {
        this.movieSelected.sales_channel_changes.splice(checkIndex, 1);
        // this.movieSelected.sales_channel_changes.push(event)
      } else {
        this.movieSelected.sales_channel_changes.push(event);
      }
      console.log(
        "this.movieSelected.sales_channel_changes",
        this.movieSelected.sales_channel_changes
      );
    },
    viewScreenBox(status) {
      this.mouseOverScreen = status;
    },
    onSelectDateFunction(event, type) {
      if (type == "duplicateScreen") {
        this.duplicateScreenObj.end_date = new Date(moment(event).format());
      } else if (type == "duplicateCinemaScreen") {
        this.duplicateCinemaSchedule.end_date = new Date(
          moment(event).format()
        );
      }
    },
    checkDefaultRateCard(rcObj) {
      if (rcObj.hasOwnProperty("defaultRateCard") && rcObj.defaultRateCard) {
        return true;
      } else {
        return false;
      }
    },
    getPosAggregatorUsers: function (cine_id) {
      MasterService.GetPosAggregatorUsers({ cinema_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.aggregatorUsersList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    getShowDateForNewSchedule(movie) {
      if (movie.isNewSchedule) {
        let MovieStartTime = moment(movie.start_time, "HH:mm");
        let final_show_date = moment(this.scheduleObject.sch_start_date).format(
          "YYYY-MM-DD"
        );
        if (
          MovieStartTime.isSameOrAfter(
            moment(moment().format("YYYY-MM-DD 00:00"))
          ) &&
          MovieStartTime.isSameOrBefore(
            moment(this.CinemasSettings.cine_operation_start_time, "HH:mm")
          )
        ) {
          final_show_date = moment(final_show_date).add(1, "d");
        }
        return moment(final_show_date).format("Do, MMMM (ddd)");
      } else {
        return moment(movie.ss_actual_start_date).format("Do, MMMM (ddd)");
      }
    },
    onShowGlobalSettings() {
      this.getSettingsDetails();
      this.$forceUpdate();
    },
    onSelectDefaultScheduleSettings(type) {
      this.settings.default_schedule_status_type = type.value;
    },
    getSettingsDetails() {
      this.globalList.map((x) => {
        if (x.go_key == "SCHEDULE_AUTO_SAVE") {
          this.settings.auto_save = x.go_value == "Y" ? true : false;
        }
        if (x.go_key == "DEFAULT_DROP_SCHEDULE_STATUS_ID") {
          this.settings.default_schedule_status_type =
            x.go_value == "19" ? 19 : 16;
          this.settings.defaultScheduleType =
            this.scheduleDefaultTypeSettings.filter(
              (z) => z.value == this.settings.default_schedule_status_type
            );
        }
      });
      this.$forceUpdate();
    },
    onSaveGlobalSettings: function () {
      let finalObj = [];
      console.log("settings", this.settings);
      this.globalList.map((x) => {
        finalObj.push({ ...x });
      });

      finalObj.map((x) => {
        if (x.go_key == "SCHEDULE_AUTO_SAVE") {
          x.go_value = this.settings.auto_save ? "Y" : "N";
        }
        if (x.go_key == "DEFAULT_DROP_SCHEDULE_STATUS_ID") {
          x.go_value =
            this.settings.default_schedule_status_type == 19 ? "19" : "16";
        }
      });

      let payload = {
        globalList: finalObj,
      };
      MasterService.EditGlobalOptions(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show("Settings Updated SuccessFully");
            this.$store.dispatch("fetchGlobalOptions");
            this.$refs.settingsModal.hide();
          } else {
            this.$toasted.show("Unable to save settings");
          }
        })
        .catch(this._CatchError);
    },
    openSettingsModal() {
      this.$refs.settingsModal.show();
    },
    onHandleDuplicateScreen(action) {
      if (!this.duplicateScreenObj.screen_id) {
        return this.$toasted.show("Please Select Screen");
      } else if (!this.duplicateScreenObj.start_date) {
        return this.$toasted.show("Please Select Start Date");
      } else if (!this.duplicateScreenObj.end_date) {
        return this.$toasted.show("Please Select End Date");
      } else if (
        moment(this.duplicateScreenObj.start_date).isAfter(
          this.duplicateScreenObj.end_date
        )
      ) {
        return this.$toasted.show("Start date must Be smaller than End date");
      } else {
        console.log(
          "Final Array of movies to duplicate",
          this.duplicateScreenObj
        );
        let loader = this.$loading.show();
        let MultipleSchedule = [];
        this.isScreenDuplicate = true;

        this.duplicateScreenObj.moviesArray.forEach((x) => {
          x["scheduling_price"] = x.scheduleShowPrice;
        });

        let obj = {
          moviesArray: this.duplicateScreenObj.moviesArray,
          screen_id: this.duplicateScreenObj.screen_id,
          screen_name: this.duplicateScreenObj.selectedScreen.screen_name,
        };

        MultipleSchedule.push(obj);

        this.MultipleSchedule = MultipleSchedule;

        let payload = {
          CinemasSettings: this.CinemasSettings,
          timeZone: this.timeZone,
          ACTION: action,
          MultipleSchedule: MultipleSchedule,
          cinema_id: this.scheduleObject.cinema_id,
          sch_start_date: moment(this.duplicateScreenObj.start_date).format(
            "YYYY-MM-DD"
          ),
          sch_end_date: moment(this.duplicateScreenObj.end_date).format(
            "YYYY-MM-DD"
          ),
        };
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            scheduleService
              .addMultipleSchedule(payload)
              .then((result) => {
                const { data } = result;

                if (data.status) {
                  if (action == "INSERT") {
                    this.$toasted.show(data.message);
                    this.$refs.DuplicateSingleSchedule.hide();
                    this.$refs.duplicateScreen.hide();
                    this.isChanged = false;
                    this.getSchedule();
                  } else if (action == "VALIDATE") {
                    this.overlappedSingleMultiScheduleArray = [];
                    this.resolvedSingleMultiScheduleArray = [];
                    let count = 0;
                    let validateData = data.Records.screenArrayInsert;
                    this.screenArrayInsert = data.Records.screenArrayInsert;
                    validateData.map((x) => {
                      x.moviesArray.map((y) => {
                        y["created_at"] = moment(y.created_at).format(
                          "YYYY-MM-DD HH:mm:ss"
                        );
                        if (y.checkExistSchedule) {
                          count++;
                          y["isEdit"] = false;
                          y["overlap"] = true;
                          this.overlappedSingleMultiScheduleArray.push(y);
                        } else {
                          this.resolvedSingleMultiScheduleArray.push(y);
                        }
                      });
                    });
                    this.overlappedSingleMultiScheduleArray = _.orderBy(
                      this.overlappedSingleMultiScheduleArray,
                      ["ss_start_date", "ss_start_show_time"],
                      ["asc", "asc"]
                    );
                    if (
                      count > 0 &&
                      this.overlappedSingleMultiScheduleArray.length > 0
                    ) {
                      this.$refs.overlappedConflicts.show();
                      this.$refs.DuplicateSingleSchedule.hide();
                      this.$refs.duplicateScreen.hide();
                    } else {
                      this.onHandleDuplicateScreen("INSERT");
                    }
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                console.log("Error:", err);
              })
              .finally(() => {
                loader.hide();
              });
          }
        });
      }
    },
    onClickSaveRateCardChanges_ds() {
      this.$refs.rateCardWeekDayArray.hide();
    },
    onEditRateCardScreenDuplicate(movie, movieIndex) {
      this.selectedMovieForEditWeekWiseDay = movie;
      this.duplicateScreenObj.moviesArray.forEach((x, index) => {
        if (movieIndex != index) {
          x.rateCardCollapse = false;
        }
      });
      this.duplicateScreenObj.moviesArray[movieIndex].rateCardCollapse =
        !this.duplicateScreenObj.moviesArray[movieIndex].rateCardCollapse;
      //  this.$refs.rateCardWeekDayArray.show();
      this.$forceUpdate();
    },
    onClickDuplicateScreen() {
      if (
        moment(
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD")
        ).isBefore(momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD"))
      ) {
        this.duplicateScreenObj.start_date = new Date(
          moment(
            momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD")
          ).format()
        );
        this.duplicateScreenObj.end_date = new Date(
          moment(
            momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD")
          ).format()
        );
      } else if (this.scheduleObject.sch_start_date) {
        this.duplicateScreenObj.start_date = new Date(
          moment(this.scheduleObject.sch_start_date).add(1, "d").format()
        );
        this.duplicateScreenObj.end_date = new Date(
          moment(this.scheduleObject.sch_start_date).add(1, "d").format()
        );
      } else {
        this.duplicateScreenObj.start_date = new Date(
          moment().add(1, "d").format()
        );
        this.duplicateScreenObj.end_date = new Date(
          moment().add(1, "d").format()
        );
      }
      this.duplicateScreenObj["screen_id"] = null;
      this.duplicateScreenObj["selectedScreen"] = "";
      this.duplicateScreenObj["moviesArray"] = [];
      this.showFooterDetails = false;
      this.$refs.duplicateScreen.show();
    },
    onClickDuplicateDay() {
      this.generateMovieListDuplicateDay();
      this.$refs.duplicateDay.show();
    },
    getRateCardName(rc) {
      let text = ``;
      text =
        rc.sst_seat_type +
        "-" +
        rc.rc_name +
        "-" +
        this.currFormat(rc.rc_total_amount);
      return text;
    },
    getAllRateCardName(rcArray = []) {
      let text = ``;
      text = rcArray.map((rc) => this.getRateCardName(rc)).join(", ");
      return text;
    },
    onSelectScreenFromDuplicateScreen(screen, type) {
      if (type == 1) {
        this.duplicateScreenObj.screen_id = screen.screen_id;
        this.duplicateScreenObj.selectedScreen = screen;
        this.duplicateScreenObj.moviesArray = [];
        this.getSelectedScreenMovies(screen, type);
      } else if (type == 2) {
        this.duplicateCinemaSchedule.screen_id = screen.screen_id;
        this.duplicateCinemaSchedule.selectedScreen = screen;
        this.duplicateCinemaSchedule.moviesArray = [];
        this.getSelectedScreenMovies(screen, type);
      }
    },
    onAttachRateCardDayWiseScreenDuplicate(screen, schedule, dayCount) {
      let arrayMap = screen["screen_seat_card_mapping"];
      let mapping_array = [];
      let final_schedule_pricing_array = [];
      let schTime = schedule["ss_start_show_time"] || schedule["start_time"];
      let old_scheduleShowPriceArray = schedule["scheduleShowPrice"] || [];
      let checkInd = this.arrayDays_duplicate.findIndex(
        (days) => days.checkDay == dayCount
      );

      console.log(
        "schedule onAttachRateCardDayWiseScreenDuplicate",
        schedule,
        arrayMap
      );

      arrayMap.map((z) => {
        let rateCardStartTime = moment(z.start_time, "HH:mm").format(
          "DD-MM-YYYY HH:mm"
        );
        let rateCardEndTime = "";
        if (
          moment(z.end_time, "HH:mm").isBefore(moment(z.start_time, "HH:mm"))
        ) {
          rateCardEndTime = moment(z.end_time, "HH:mm")
            .add(1, "days")
            .format("DD-MM-YYYY HH:mm");
        } else {
          rateCardEndTime = moment(z.end_time, "HH:mm").format(
            "DD-MM-YYYY HH:mm"
          );
        }
        let startMovieTime_temp = moment(schTime, "HH:mm").format(
          "DD-MM-YYYY HH:mm"
        );
        let cinemaStartDateTime = moment(
          this.CinemasSettings.cine_operation_start_time,
          "HH:mm"
        ).format("DD-MM-YYYY HH:mm");

        if (
          moment(
            moment(startMovieTime_temp, "DD-MM-YYYY HH:mm").format(
              "YYYY-MM-DD HH:mm"
            )
          ).isSameOrAfter(moment(moment().format("YYYY-MM-DD 00:00"))) &&
          moment(
            moment(startMovieTime_temp, "DD-MM-YYYY HH:mm").format(
              "YYYY-MM-DD HH:mm"
            )
          ).isSameOrBefore(
            moment(
              moment(cinemaStartDateTime, "DD-MM-YYYY HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            )
          )
        ) {
          startMovieTime_temp = moment(startMovieTime_temp, "DD-MM-YYYY HH:mm")
            .add(1, "d")
            .format("DD-MM-YYYY HH:mm");
        }

        startMovieTime_temp = moment(
          startMovieTime_temp,
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
        rateCardStartTime = moment(
          rateCardStartTime,
          "DD-MM-YYYY HH:mm"
        ).format("YYYY-MM-DD HH:mm");
        rateCardEndTime = moment(rateCardEndTime, "DD-MM-YYYY HH:mm").format(
          "YYYY-MM-DD HH:mm"
        );

        if (
          moment(startMovieTime_temp).isBetween(
            rateCardStartTime,
            rateCardEndTime
          )
        ) {
          mapping_array.push(z);
        }
      });

      console.log("arrayMap", arrayMap);
      console.log("mapping_array", mapping_array);
      console.log("dayCount", dayCount);
      console.log("checkInd", checkInd);

      let isForeignMovie = "N";
      if (
        schedule &&
        schedule.hasOwnProperty("is_foreign_movie") &&
        schedule["is_foreign_movie"] &&
        !this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)
      ) {
        isForeignMovie = schedule["is_foreign_movie"] || "N";
      }
      mapping_array = mapping_array.filter(
        (_ma) => _ma["is_foreign_rc"] == isForeignMovie
      );

      if (mapping_array.length > 0 && old_scheduleShowPriceArray.length > 0) {
        old_scheduleShowPriceArray.forEach((old_sch_price, seatTypeIndex) => {
          let screenRateCardObj = mapping_array.filter(
            (st) =>
              st.screen_seat_type_id == old_sch_price.screen_seat_type_id &&
              st[this.arrayDays_duplicate[checkInd].day] == "Y"
          );
          if (screenRateCardObj.length > 0) {
            let screenRateCard = screenRateCardObj[0];
            let findRateCard = this.RatecardsList.find(
              (rc) => rc.rc_g_id == screenRateCard.rate_card_id
            );
            if (findRateCard) {
              let rcObj = {
                ...old_sch_price,
                defaultRateCard:
                  findRateCard["default_rate_card"] == "Y" ? true : false,
                rate_card_group_id: findRateCard.rc_g_id,
                rate_card_id: findRateCard.rc_id,
                rc_g_name: findRateCard.rc_g_name,
                rc_name: findRateCard.rc_name,
                rc_total_amount: findRateCard.rc_total_amount,
                searchRateCard: "",
                selected_rate_card: {
                  rc_g_id: findRateCard.rc_g_id,
                  rc_g_name: findRateCard.rc_g_name,
                  rc_id: findRateCard.rc_id,
                  rc_name: findRateCard.rc_name,
                },
              };
              final_schedule_pricing_array.push(rcObj);
            } else {
              console.log("NOT FOUND findRateCard", findRateCard);
            }
          } else {
            console.log("IN ELSE LINE 6355", screenRateCardObj);
          }
        });
      } else {
        console.log("NO MAPPING ARRAY", {
          mapping_array: mapping_array,
          old_scheduleShowPriceArray: old_scheduleShowPriceArray,
        });
      }
      if (final_schedule_pricing_array.length > 0) {
        return final_schedule_pricing_array;
      } else {
        return old_scheduleShowPriceArray;
      }
    },
    getSelectedScreenMovies(screen, type) {
      let tempScreen = this.selectedMoviesInScreens.filter(
        (x) => x.screen_id == screen.screen_id
      );
      this.selectedScreenSeatTypes = screen.screen_seat_types;
      let tempMovies = tempScreen.length > 0 ? tempScreen[0].movies : [];
      console.log(
        "getSelectedScreenMovies",
        tempMovies,
        this.selectedMoviesInScreens,
        tempMovies[0].scheduleShowPrice
      );
      tempMovies = tempMovies.filter(
        (x) => x.mycinema_booking_type_id == 0 && !x.isNewSchedule
      );
      tempMovies.map((x) => {
        let temp_schedule_pricing = [];
        x.scheduleShowPrice.map((y) => {
          let obj = {
            ...y,
            rc_g_name: y.rc_name,
            selected_rate_card: {
              rc_g_id: y.rate_card_group_id || null,
              rc_id: y.rc_id || null,
              rc_g_name: y.rc_name || null,
            },
          };
          temp_schedule_pricing.push(obj);
        });

        console.log("temp_schedule_pricing", temp_schedule_pricing);
        x["sales_channel_changes"] = [];
        this.aggregatorUsersList.map((user) => {
          const salesChannelExist = x["sales_channel"].find((salesChannel) => {
            return salesChannel.user_id == user.user_id;
          });
          if (!salesChannelExist) {
            x["sales_channel_changes"].push({
              ...user,
              is_changed: true,
              value: "N",
            });
          }
        });
        x["weekDayArray"] = _.cloneDeep(this.weekDaysArray);
        x["weekDayArray"].map((z) => {
          let schedule_pricing_array_day_wise = _.cloneDeep(
            temp_schedule_pricing
          );
          if ((z.day || z.day == 0) && this.defaultRateCardDuplicate) {
            let temp_schedule_pricing_array_day_wise =
              this.onAttachRateCardDayWiseScreenDuplicate(screen, x, z.day);
            console.log(
              "schedule_pricing_array_day_wise",
              schedule_pricing_array_day_wise
            );
            // z.scheduling_price = _.cloneDeep(temp_schedule_pricing);
            if (
              temp_schedule_pricing_array_day_wise &&
              temp_schedule_pricing_array_day_wise.length > 0
            ) {
              schedule_pricing_array_day_wise = _.cloneDeep(
                temp_schedule_pricing_array_day_wise
              );
            }
          }
          z.scheduling_price = _.cloneDeep(schedule_pricing_array_day_wise);
        });
        if (type == 1) {
          this.duplicateScreenObj.moviesArray.push({
            ...x,
            rateCardCollapse: false,
          });
        } else if (type == 2) {
          this.duplicateCinemaSchedule.moviesArray.push({
            ...x,
            rateCardCollapse: false,
          });
        }
      });
      if (this.duplicateScreenObj.moviesArray.length == 1 && type == 1) {
        this.selectedMovieForEditWeekWiseDay =
          this.duplicateScreenObj.moviesArray[0];
      }
    },
    getRateCardNameonHover(screenTypeIndex) {
      if (
        this.selectedScreenIndex != null &&
        this.selectedScreenIndex != -1 &&
        this.selectedMovieIndex != null &&
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ] &&
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice.length > 0 &&
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice[screenTypeIndex] &&
        (this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice[screenTypeIndex].rate_card_name ||
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice[screenTypeIndex].rc_name)
      ) {
        return this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice[screenTypeIndex].rate_card_name
          ? this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
              this.selectedMovieIndex
            ].scheduleShowPrice[screenTypeIndex].rate_card_name
          : this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
              this.selectedMovieIndex
            ].scheduleShowPrice[screenTypeIndex].rc_name
          ? this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
              this.selectedMovieIndex
            ].scheduleShowPrice[screenTypeIndex].rc_name
          : "";
      } else {
        return "No Rate Card Attached";
      }
    },
    getPopOverClassName(movie) {
      let className = `standard-header`;
      if (movie.isNewSchedule && movie.isReady) {
        className = `lightgreen-header`;
      } else if (movie.isNewSchedule && !movie.isReady) {
        className = `lightred-header`;
      } else if (movie.is_sch_disable == "Y") {
        className = `lightgrey-header`;
      } else if (movie.ss_show_status == 13) {
        className = `lightgrey-header`;
      } else if (movie.ss_show_status == 17) {
        className = `lightgrey-header`;
      } else if (movie.ss_show_status == 19) {
        className = `planned-header`;
      } else if (movie.mycinema_booking_type_id == 3) {
        className = `private-header`;
      } else if (
        movie.mycinema_booking_type_id == 2 ||
        movie.mycinema_booking_type_id == 1
      ) {
        className = `ondemand-header`;
      } else if (movie.is_event && movie.is_event == "Y") {
        className = `event-header`;
      } else {
        className = `standard-header`;
      }
      return className;
    },
    getCardColor(movie) {
      let color = `#00800054`;
      if (movie.isNewSchedule && movie.isReady) {
        color = "#88f58842";
      } else if (movie.isNewSchedule && !movie.isReady) {
        color = "#ff000026";
      } else if (movie.is_sch_disable == "Y") {
        color = "#b5b6b742";
      } else {
        color = movie.backgroundColor;
      }
      return color;
    },
    checkOverlapEdit(overlap) {
      let count = 0;
      overlap.overlap_schedule.map((x) => {
        if (x.booked_seats > 0) {
          count++;
        }

        if (x.unpaid_count > 0) {
          count++;
        }
      });

      if (count > 0) {
        return false;
      } else {
        return true;
      }
    },
    undoConflictResolve(conflict, index) {
      conflict["remark"] = "";
      conflict["checkExistSchedule"] = true;
      this.overlappedSingleMultiScheduleArray.push(conflict);
      this.resolvedSingleMultiScheduleArray.splice(index, 1);
      this.overlappedSingleMultiScheduleArray = _.orderBy(
        this.overlappedSingleMultiScheduleArray,
        ["ss_start_date", "ss_start_show_time"],
        ["asc", "asc"]
      );
      this.$forceUpdate();
    },
    handleupdateOverlapConflicts() {
      let loader = this.$loading.show();
      let finalArray = this.overlappedSingleMultiScheduleArray.concat(
        this.resolvedSingleMultiScheduleArray
      );
      this.screenArrayInsert.forEach((x) => {
        x["created_at"] = moment(x.created_at).format("YYYY-MM-DD HH:mm:ss");
        x["moviesArray"] = finalArray;
      });
      let payload = {
        schedule_array: this.screenArrayInsert,
        cinema_id: this.scheduleObject.cinema_id,
      };
      scheduleService
        .saveOverlapConflicts(payload)
        .then((response) => {
          const { data } = response;
          if (data) {
            this.overlappedSingleMultiScheduleArray = [];
            this.resolvedSingleMultiScheduleArray = [];
            this.$refs.overlappedConflicts.hide();
            this.$refs.ignoreconflicts.hide();
            this.$toasted.show(data.message);
            console.log("Error:", data.message);
          } else {
            // this.$toasted.show(data.message)
          }
        })
        .catch((err) => {
          console.log("Error:", error);
        })
        .finally(() => {
          loader.hide();
        });
    },
    onHandleApplyOverlapChanges(overlap, index) {
      let scheduleDetail = [];
      scheduleDetail.push(overlap);
      let payload = {
        scheduleDetail: scheduleDetail,
      };
      scheduleService.ChechOverlapScheduleNew(payload).then((response) => {
        const { data } = response;
        if (data && data.status) {
          this.resolvedSingleMultiScheduleArray.push(overlap);
          this.overlappedSingleMultiScheduleArray.splice(index, 1);
          this.$forceUpdate();
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    onHandleReplaceOverlap(overlap, index) {
      overlap["remark"] = `Replaced (${overlap.overlap_schedule.length})x`;
      overlap["is_replaced"] = true;
      this.resolvedSingleMultiScheduleArray.push(overlap);
      this.overlappedSingleMultiScheduleArray.splice(index, 1);
      this.$forceUpdate();
    },
    onIgnoreOverlap(overlap, index) {
      overlap["remark"] = "Ignored";
      this.resolvedSingleMultiScheduleArray.push(overlap);
      this.overlappedSingleMultiScheduleArray.splice(index, 1);
      this.$forceUpdate();
    },
    editTimeOverlap(overlap) {
      overlap["isEdit"] = !overlap["isEdit"];
      this.$forceUpdate();
    },
    collapseColorCodes() {
      this.colorCollapse = !this.colorCollapse;
    },
    checkExist() {
      let currentTime = momentT()
        .tz(this.timeZone.tz_name)
        .format("YYYY-MM-DD");
      let show_time = moment(this.scheduleObject.sch_start_date).format(
        "YYYY-MM-DD"
      );
      console.log(currentTime, show_time, currentTime == show_time);

      return currentTime == show_time;
    },
    getCurrentTimeBar() {
      let currentTime = momentT().tz(this.timeZone.tz_name).format("HH:mm");
      let positionLeft = this.newGetScreenPositionCalc(
        currentTime,
        currentTime.split(":")[1]
      );
      return {
        positionLeft: positionLeft,
        currentTime: currentTime,
      };
    },
    getWidth(obj) {
      let per_width = 49 / 60;
      let lengthMinutes =
        parseInt(obj.mrrdr_runtime) +
        parseInt(obj.ads_time_in_mins || 0) +
        parseInt(obj.cleaning_time_in_mins || 0) +
        parseInt(obj.interval_time_in_mins || 0);
      let actualWidth = parseInt(lengthMinutes * per_width);
      return actualWidth + "px";
    },
    moment,
    validateWeekDayRateCard() {
      let count = 0;
      let error = "";
      this.weekDaysArray.map((x) => {
        if (!x.hasOwnProperty("scheduling_price")) {
          count++;
          error = "Something Went Wrong!. Please Refresh and Try1.";
        }
        x.scheduling_price.map((y) => {
          console.log(y, "SchedulePricing");
          if (!y.rate_card_group_id) {
            count++;
            error = "Rate Card is Required.";
          } else if (!y.rate_card_id) {
            count++;
            error = "Rate Card Id is Required.";
          } else if (!y.screen_seat_type_id) {
            count++;
            error = " Screen Seat Type Id Missing.";
          }
        });
      });

      if (count > 0) {
        this.$toasted.show(error);
        return false;
      } else {
        return true;
      }
    },
    editOverlappedTime(action = "VALIDATE", overlap, index) {
      let tempArrMovies = overlap.hasOwnProperty("overlap_with_movie_obj")
        ? [overlap.overlap_with_movie_obj]
        : [];
      if (tempArrMovies.length == 0) {
        return this.$toasted.show("Something Went Wrong!, No Movies Found");
      }
      let moviesMultiSchObj = {
        ...this.MultipleSchedule[0],
      };
      moviesMultiSchObj.moviesArray = tempArrMovies;

      console.log("tempArrMovies", tempArrMovies);
      console.log("overlap", overlap);
      console.log("moviesMultiSchObj", moviesMultiSchObj);

      moviesMultiSchObj.moviesArray[0].ss_start_show_time = moment(
        overlap.ss_start_show_time,
        "HH:mm"
      ).format("HH:mm");
      moviesMultiSchObj.moviesArray[0].start_time = moment(
        overlap.ss_start_show_time,
        "HH:mm"
      ).format("HH:mm");

      let payload = {
        CinemasSettings: this.CinemasSettings,
        timeZone: this.timeZone,
        ACTION: action,
        MultipleSchedule: [moviesMultiSchObj],
        cinema_id: this.scheduleObject.cinema_id,
        sch_start_date: moment(overlap.ss_actual_start_date).format(
          "YYYY-MM-DD"
        ),
        sch_end_date: moment(overlap.ss_actual_start_date).format("YYYY-MM-DD"),
      };
      this.$validator.validate().then(async (valid) => {
        if (valid) {
          scheduleService
            .addMultipleSchedule(payload)
            .then((result) => {
              const { data } = result;

              if (data.status) {
                let count = 0;
                let scheduleArray = [];
                let validateData = data.Records.screenArrayInsert;
                validateData.map((x) => {
                  x.moviesArray.map((y) => {
                    if (y.checkExistSchedule) {
                      count++;
                      scheduleArray.push(y);
                    } else {
                      scheduleArray.push(y);
                    }
                  });
                });

                if (count > 0) {
                  this.$toasted.show(
                    `Overlapped with ${scheduleArray[0].overlap_schedule[0].movie}`
                  );
                  scheduleArray[0]["overlap"] = true;
                  this.overlappedSingleMultiScheduleArray[index] =
                    scheduleArray[0];
                  this.$forceUpdate();
                } else {
                  this.overlappedSingleMultiScheduleArray.splice(index, 1);
                  scheduleArray[0]["remark"] = "Time Changed";
                  scheduleArray[0]["checkExistSchedule"] = false;
                  scheduleArray[0]["overlap"] = true;
                  scheduleArray[0]["overlap_schedule"] =
                    overlap.overlap_schedule;
                  this.resolvedSingleMultiScheduleArray.push(scheduleArray[0]);
                  this.$toasted.show(`Conflict Resolved.`);
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              // loader.hide();
            });
        }
      });
    },
    handleSingleDuplicateSchedule(action = "VALIDATE") {
      if (!this.singleDuplicateDetails.ss_start_date) {
        return this.$toasted.show("Please enter a start date");
      } else if (!this.singleDuplicateDetails.ss_end_date) {
        return this.$toasted.show("Please enter a to date");
      } else if (
        moment(this.singleDuplicateDetails.ss_start_date).isAfter(
          this.singleDuplicateDetails.ss_end_date
        )
      ) {
        return this.$toasted.show("From Date Must be Smaller than To Date");
      } else if (!this.validateWeekDayRateCard()) {
        return;
      } else {
        let loader = this.$loading.show();
        this.duplicateSubmitted = true;
        this.isScreenDuplicate = false;
        let MultipleSchedule = [];
        let moviesArray = [];
        let lengthMinutes =
          parseInt(this.selectedMultiShowSchedule.mrrdr_runtime) +
          parseInt(
            this.selectedMultiShowSchedule.cine_setting_ads_time_in_mins
          ) +
          parseInt(this.selectedMultiShowSchedule.cine_cleaning_time_in_mins) +
          parseInt(this.selectedMultiShowSchedule.cine_interval_time_in_mins);
        this.selectedMultiShowSchedule["lengthMinutes"] = lengthMinutes;

        let mainObj = { ...this.selectedMultiShowSchedule };

        mainObj["interval_time_in_mins"] =
          this.selectedMultiShowSchedule.cine_interval_time_in_mins;
        mainObj["cleaning_time_in_mins"] =
          this.selectedMultiShowSchedule.cine_cleaning_time_in_mins;
        mainObj["ads_time_in_mins"] =
          this.selectedMultiShowSchedule.cine_setting_ads_time_in_mins;
        mainObj["cinema_id"] = this.scheduleObject.cinema_id;
        mainObj["screen_id"] = this.selectedScreen.screen_id;
        mainObj["weekDayArray"] = this.weekDaysArray;
        mainObj["scheduling_price"] =
          this.selectedMultiShowSchedule.scheduleShowPrice;

        let newSalesChannelTempArray = [];
        if (
          mainObj.hasOwnProperty("sales_channel_changes") &&
          mainObj.sales_channel_changes.length == 0
        ) {
          mainObj.sales_channel;

          newSalesChannelTempArray = this.aggregatorUsersList.filter((el) => {
            return !mainObj.sales_channel.some((v) => {
              return v.user_id == el.user_id;
            });
          });

          if (newSalesChannelTempArray.length > 0) {
            newSalesChannelTempArray.forEach((e) => {
              e["is_changed"] = true;
              e["value"] = "N";
              e["ss_id"] = mainObj.ss_id;
              e["md_id"] = mainObj.md_id;
            });
          }

          mainObj.sales_channel_changes = _.cloneDeep(newSalesChannelTempArray);
        }

        moviesArray.push(mainObj);

        let obj = {
          moviesArray: moviesArray,
          screen_id: this.selectedScreen.screen_id,
          screen_name: this.selectedScreen.screen_name,
        };

        MultipleSchedule.push(obj);

        this.MultipleSchedule = MultipleSchedule;

        console.log("weekDaysArray", this.weekDaysArray);

        let payload = {
          CinemasSettings: this.CinemasSettings,
          timeZone: this.timeZone,
          ACTION: action,
          MultipleSchedule: MultipleSchedule,
          cinema_id: this.scheduleObject.cinema_id,
          sch_start_date: moment(
            this.singleDuplicateDetails.ss_start_date
          ).format("YYYY-MM-DD"),
          sch_end_date: moment(this.singleDuplicateDetails.ss_end_date).format(
            "YYYY-MM-DD"
          ),
        };
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            scheduleService
              .addMultipleSchedule(payload)
              .then((result) => {
                const { data } = result;

                if (data.status) {
                  if (action == "INSERT") {
                    this.$toasted.show(data.message);
                    this.$refs.DuplicateSingleSchedule.hide();
                    this.isChanged = false;
                    this.getSchedule();
                  } else if (action == "VALIDATE") {
                    this.overlappedSingleMultiScheduleArray = [];
                    this.resolvedSingleMultiScheduleArray = [];
                    let count = 0;
                    let validateData = data.Records.screenArrayInsert;
                    this.screenArrayInsert = data.Records.screenArrayInsert;
                    validateData.map((x) => {
                      x.moviesArray.map((y) => {
                        y["created_at"] = moment(y.created_at).format(
                          "YYYY-MM-DD HH:mm:ss"
                        );
                        if (y.checkExistSchedule) {
                          count++;
                          y["isEdit"] = false;
                          y["overlap"] = true;
                          this.overlappedSingleMultiScheduleArray.push(y);
                        } else {
                          this.resolvedSingleMultiScheduleArray.push(y);
                        }
                      });
                    });
                    this.overlappedSingleMultiScheduleArray = _.orderBy(
                      this.overlappedSingleMultiScheduleArray,
                      ["ss_start_date", "ss_start_show_time"],
                      ["asc", "asc"]
                    );
                    if (
                      count > 0 &&
                      this.overlappedSingleMultiScheduleArray.length > 0
                    ) {
                      this.$refs.overlappedConflicts.show();
                      this.$refs.DuplicateSingleSchedule.hide();
                    } else {
                      this.handleSingleDuplicateSchedule("INSERT");
                    }
                    console.log("VALIDATE", data);
                    console.log(
                      "this.overlappedSingleMultiScheduleArray",
                      this.overlappedSingleMultiScheduleArray
                    );
                    console.log(
                      "this.resolvedSingleMultiScheduleArray",
                      this.resolvedSingleMultiScheduleArray
                    );
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch((err) => {
                console.log("Error:", err);
              })
              .finally(() => {
                loader.hide();
              });
          }
        });
      }
    },
    onSelectRateCardForDuplicateSchedule(
      rateCard,
      weekPrice,
      weekdaysLoop,
      weekPriceIndex
    ) {
      let obj = {
        rate_card_group_id: rateCard.rc_g_id || null,
        rate_card_id: rateCard.rc_id || null,
        rate_card_name: rateCard.rc_g_name || null,
        screen_seat_type_id: weekPrice.screen_seat_type_id,
        searchRateCard: "",
        selected_rate_card: {
          rc_g_id: rateCard.rate_card_group_id || null,
          rc_id: rateCard.rc_id || null,
          rc_g_name: rateCard.rc_g_name || null,
        },
        sst_seat_type: weekPrice.sst_seat_type,
      };

      if (weekdaysLoop.dayName == "selectAll") {
        this.weekDaysArray.forEach((y) => {
          Object.keys(y.scheduling_price[weekPriceIndex]).map((z) => {
            y.scheduling_price[weekPriceIndex][z] = obj[z] || null;
          });
        });
      } else {
        Object.keys(weekPrice).map((z) => {
          weekPrice[z] = obj[z] || null;
        });
      }

      this.$forceUpdate();
    },
    onChangeRateCardForDuplicateScreen(
      rateCard,
      weekPrice,
      weekdaysLoop,
      weekPriceIndex
    ) {
      let obj = {
        rate_card_group_id: rateCard.rc_g_id || null,
        rate_card_id: rateCard.rc_id || null,
        rate_card_name: rateCard.rc_g_name || null,
        rc_g_name: rateCard.rc_g_name,
        rc_name: rateCard.rc_name,
        screen_seat_type_id: weekPrice.screen_seat_type_id,
        searchRateCard: "",
        selected_rate_card: {
          rc_g_id: rateCard.rate_card_group_id || null,
          rc_id: rateCard.rc_id || null,
          rc_g_name: rateCard.rc_g_name || null,
        },
        sst_seat_type: weekPrice.sst_seat_type,
      };

      if (weekdaysLoop.dayName == "selectAll") {
        this.selectedMovieForEditWeekWiseDay.weekDayArray.forEach((y) => {
          Object.keys(y.scheduling_price[weekPriceIndex]).map((z) => {
            y.scheduling_price[weekPriceIndex][z] = obj[z] || null;
          });
        });
      } else {
        Object.keys(weekPrice).map((z) => {
          weekPrice[z] = obj[z] || null;
        });
      }

      this.$forceUpdate();
    },
    onChangeWeekdays_ds: function (event, keyname) {
      this.weekdayerror = "";
      console.log("event :", event);
      if (keyname !== "selectAll") {
        this.selectedMovieForEditWeekWiseDay.weekDayArray.forEach((x) => {
          if (x.dayName == "selectAll") {
            x["value"] = false;
          }
        });
      } else if (keyname == "selectAll") {
        this.selectedMovieForEditWeekWiseDay.weekDayArray.forEach((x) => {
          if (x.dayName !== "selectAll") {
            x["value"] = event;
          }
        });
      }
    },
    onChangeWeekdays: function (event, keyname) {
      this.weekdayerror = "";
      console.log("event :", event);
      if (keyname !== "selectAll") {
        this.weekDaysArray.forEach((x) => {
          if (x.dayName == "selectAll") {
            x["value"] = false;
          }
        });
      } else if (keyname == "selectAll") {
        this.weekDaysArray.forEach((x) => {
          if (x.dayName !== "selectAll") {
            x["value"] = event;
          }
        });
      }
    },
    onClickDuplicateSingleSchedule(schedule) {
      this.showFooterDetails = false;
      let screen = this.selectedScreen;
      this.selectedMultiShowSchedule = schedule;
      if (schedule.isNewSchedule) {
        this.singleDuplicateDetails.ss_start_date =
          this.scheduleObject.sch_start_date;
        this.singleDuplicateDetails.ss_end_date =
          this.scheduleObject.sch_start_date;
      } else if (
        moment(
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD")
        ).isBefore(momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD"))
      ) {
        this.singleDuplicateDetails.ss_start_date = new Date(
          moment(
            momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD")
          ).format()
        );
        this.singleDuplicateDetails.ss_end_date = new Date(
          moment(
            momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD")
          ).format()
        );
      } else if (this.scheduleObject.sch_start_date) {
        this.singleDuplicateDetails.ss_start_date = new Date(
          moment(this.scheduleObject.sch_start_date).add(1, "d").format()
        );
        this.singleDuplicateDetails.ss_end_date = new Date(
          moment(this.scheduleObject.sch_start_date).add(1, "d").format()
        );
      } else {
        this.singleDuplicateDetails.ss_start_date = new Date(
          moment().add(1, "d").format()
        );
        this.singleDuplicateDetails.ss_end_date = new Date(
          moment().add(1, "d").format()
        );
      }
      let tempArray = [];
      console.log(
        "onClickDuplicateSingleSchedule movieSelected",
        this.movieSelected
      );

      console.log("this.selectedScreenSeatTypes", this.selectedScreenSeatTypes);

      this.selectedScreenSeatTypes.map((x) => {
        let obj = {
          rate_card_group_id: x.rate_card_group_id || null,
          rate_card_id: x.rate_card_id || null,
          rate_card_name: x.rate_card || null,
          screen_seat_type_id: x.sst_id,
          searchRateCard: "",
          selected_rate_card: {
            rc_g_id: x.rate_card_group_id || null,
            rc_id: x.rate_card_id || null,
            rc_g_name: x.rate_card || null,
          },
          sst_seat_type: x.sst_seat_type,
        };
        let newObj = {
          ...obj,
        };
        tempArray.push(newObj);
      });

      this.weekDaysArray.map((y, index) => {
        y["scheduling_price"] = [];
        y["value"] = true;
        //WORK HERE
        let schedule_pricing_array_day_wise = _.cloneDeep(tempArray);
        if (y.day || (y.day == 0 && this.defaultRateCardDuplicate)) {
          let temp_schedule_pricing_array_day_wise =
            this.onAttachRateCardDayWiseScreenDuplicate(
              screen,
              schedule,
              y.day
            );
          console.log(
            "SINGLE schedule_pricing_array_day_wise",
            schedule_pricing_array_day_wise
          );
          // z.scheduling_price = _.cloneDeep(temp_schedule_pricing);
          if (
            temp_schedule_pricing_array_day_wise &&
            temp_schedule_pricing_array_day_wise.length > 0
          ) {
            schedule_pricing_array_day_wise = _.cloneDeep(
              temp_schedule_pricing_array_day_wise
            );
          }
        }
        schedule_pricing_array_day_wise.map((z) => {
          y["scheduling_price"].push({ ...z });
        });
      });
      console.log("this.weekDaysArray", this.weekDaysArray);
      this.$refs.DuplicateSingleSchedule.show();
      this.$forceUpdate();
    },
    onChangeShowStartTimeNewSchedule(event) {
      console.log("event :", event);
      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      if (!this.movieSelected.start_time) {
        this.$toasted.show("Please Select Start Time");
        return false;
      }
      this.movieSelected["selected_time"] = event;

      // let start = this.newGetScreenPositionCalc(this.movieSelected.start_time, this.movieSelected.start_time.split(":")[1]);
      // this.movieSelected.start = start;
      // let end_time = moment(this.movieSelected.selected_time).add(parseInt(this.movieSelected.lengthMinutes), "m").toDate();
      // this.movieSelected.end_time = moment(end_time).format("HH:mm");

      // let overlap = this.checkOverLapMovie(
      //   this.movieSelected,
      //   this.movieSelected.screen
      // );
      // if(overlap && overlap.status) {
      //   this.$toasted.show(
      //     `Movie Overlapped with ${overlap.movie.movie_title} starting at ${overlap.movie.start_time} and ending at  ${overlap.movie.end_time}`,
      //     {
      //       duration: 5000,
      //     }
      //   );
      //   this.movieSelected.start = this.movieSelected.old_start;
      //   this.movieSelected.end_time = this.movieSelected.old_end_time;
      //   this.movieSelected.start_time = this.movieSelected.old_start_time;
      //   this.movieSelected["selected_time"] = moment().format("YYYY-MM-DD") + " " + this.movieSelected.old_start_time;
      // }
      // console.log('overlap', overlap)
      this.$forceUpdate();
    },
    onChangeShowStartTime: function (event) {
      console.log("event :", event);
      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      this.movieSelected["selected_time"] = event;
      this.$forceUpdate();
    },
    onClickViewDeletedScheduleDetails(showDetails) {
      this.deletedScheduleDetails = showDetails;
      this.$refs.deletedScheduleDetailsModal.show();
    },
    handleDuplicateSchedule: async function () {
      let self = this;
      // this.selectedMoviesInScreens.map((screen, screenIndex) => {
      //   this.screen.movie.map((singleMovie, singleMovieIndex) => {
      //     singleMovie.startTime = singleMovie.start;
      //     return singleMovie;
      //   });
      //   //API Call schedule
      // });
      this.$validator.validate().then(async (valid) => {
        if (valid) {
          this.FinalArray = [];
          let dates = getDates(
            moment(this.duplicate.ss_start_date).format("YYYY-MM-DD"),
            moment(this.duplicate.ss_end_date).format("YYYY-MM-DD")
          );
          // let dates = getDates(
          //   moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"),
          //   moment(this.scheduleObject.sch_end_date).format("YYYY-MM-DD")
          // );
          console.log(
            "this.selectedMoviesInScreens :",
            this.selectedMoviesInScreens
          );
          this.FinalScreenAndMovieScheduleList =
            this.selectedMoviesInScreens.filter((x) => {
              return x.movies.length > 0;
            });

          // this.FinalScreenAndMovieScheduleList.map(x => {
          //   x.movies.map(y => {
          //     console.log(y);
          //     dates = getDates(y.ss_start_date, y.ss_end_date);
          //   });
          // });

          function getDates(startDate, stopDate) {
            var dateArray = [];
            var currentDate = moment(startDate);
            var stopDate = moment(stopDate);
            while (currentDate <= stopDate) {
              dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
              currentDate = moment(currentDate).add(1, "days");
            }
            console.log("dateArray :", dateArray);
            return dateArray;
          }

          console.log("dates :", dates);
          let dateCount = 0;

          let finalpromises = self.FinalScreenAndMovieScheduleList.map(
            async (item, itemIndex) => {
              let MainObj = {};
              MainObj["screen_id"] = item.screen_id || null;
              // MainObj["sch_start_date"] = item.ss_start_date || null;
              // MainObj["sch_end_date"] = item.ss_end_date || null;
              MainObj["sch_is_active"] =
                self.scheduleObject.sch_is_active || "Y";

              // Single Screen data
              // MainObj["sch_start_date"] = item.sch_start_date || null;
              // MainObj["sch_end_date"] = item.sch_end_date || null;
              // MainObj["sch_is_active"] = item.sch_is_active || "Y";
              // schedule show according movie // Movie Mapping

              MainObj["scheduleshow"] = [];

              let moviePromises = item.movies.map(async (movie, movieIndex) => {
                MainObj["sch_start_date"] =
                  moment(self.duplicate.ss_start_date).format("YYYY-MM-DD") ||
                  null;
                MainObj["sch_end_date"] =
                  moment(self.duplicate.ss_end_date).format("YYYY-MM-DD") ||
                  null;

                let promises = dates.map(async (date, dateIndex) => {
                  let MovieObj = {};
                  MovieObj["cinema_id"] = self.duplicate.cine_id
                    ? self.duplicate.cine_id
                    : self.scheduleObject.cinema_id;
                  MovieObj["screen_id"] = item.screen_id;
                  MovieObj["movie_details_id"] = movie.movie_details_id;
                  MovieObj["ss_show_status"] = movie.ss_show_status || 16;
                  MovieObj["interval_time_in_mins"] =
                    movie.interval_time_in_mins;
                  MovieObj["cleaning_time_in_mins"] =
                    movie.cleaning_time_in_mins;
                  MovieObj["ads_time_in_mins"] = movie.ads_time_in_mins;
                  MovieObj["isNewSchedule"] = true;

                  let totalMinutes = (movie.start * 10) / 30;
                  let _totalMinutes = totalMinutes + movie.lengthMinutes;
                  let _hours = Math.floor(_totalMinutes / 60);
                  let hours = Math.floor(totalMinutes / 60);
                  let minutes = totalMinutes % 60;
                  let _minutes = _totalMinutes % 60;
                  let ampm = "AM";
                  let _ampm = "AM";
                  if (hours > 12) {
                    ampm = "PM";
                    hours = hours - 12;
                  }

                  if (_hours > 12) {
                    _ampm = "PM";
                    _hours = _hours - 12; // this.tConvert(`${_hours - 12}:00`).digit; //
                  }
                  // _hours = _hours >= 10 ? _hours : "0" + _hours;
                  // hours = hours >= 10 ? hours : "0" + hours;
                  minutes = minutes >= 10 ? minutes : "0" + minutes;
                  _minutes = _minutes >= 10 ? _minutes : "0" + _minutes;
                  // let showtime = hours + ":" + minutes + " " + ampm;
                  // let endShowtime = _hours + ":" + _minutes + " " + _ampm;

                  // let showtime = hours + ":" + minutes;
                  let showtime = format24Hours(date, movie.start_time);
                  let endShowtime = format24Hours(date, movie.end_time);
                  MovieObj["ss_start_show_time"] = showtime;
                  MovieObj["ss_end_show_time"] = endShowtime;
                  MovieObj["ss_start_date"] = moment(date).format("YYYY-MM-DD"); // movie.ss_start_date;
                  // movie.ss_end_date;
                  console.log(
                    "this.movieSelected.start_time :",
                    self.movieSelected.start_time
                  );
                  console.log(
                    "date,movie.start_time :",
                    date,
                    movie.start_time
                  );
                  MovieObj["ss_start_date_time"] = +new Date(
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time;
                  //actual date
                  if (
                    moment(
                      moment().format("YYYY-MM-DD") +
                        " " +
                        self.CinemasSettings.cine_operation_start_time
                    ).isSameOrAfter(
                      moment(
                        moment().format("YYYY-MM-DD") +
                          " " +
                          self.CinemasSettings.cine_operation_end_time
                      )
                    )
                  ) {
                    if (
                      moment(
                        moment().format("YYYY-MM-DD") +
                          " " +
                          self.CinemasSettings.cine_operation_end_time
                      ).isAfter(
                        moment(
                          moment().format("YYYY-MM-DD") + " " + movie.start_time
                        )
                      )
                    ) {
                      MovieObj["ss_actual_start_date"] = moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD");
                      MovieObj["ss_actual_start_date_time"] = +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          showtime +
                          this.timeZone.tz_utc_offset
                      );
                      MovieObj["ss_actual_end_date"] = moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD");
                      MovieObj["ss_actual_end_date_time"] = +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
                      MovieObj["ss_end_date"] = moment(date)
                        .add(1, "days")
                        .format("YYYY-MM-DD");

                      MovieObj["ss_end_date_time"] = +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
                    } else {
                      MovieObj["ss_actual_start_date"] =
                        moment(date).format("YYYY-MM-DD");
                      MovieObj["ss_actual_start_date_time"] = +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          showtime +
                          this.timeZone.tz_utc_offset
                      );
                      MovieObj["ss_actual_end_date"] =
                        movie.start_time.split(" ")[1] == "PM" &&
                        movie.end_time.split(" ")[1] == "AM"
                          ? moment(date).add(1, "days").format("YYYY-MM-DD")
                          : moment(date).format("YYYY-MM-DD");
                      MovieObj["ss_actual_end_date_time"] =
                        movie.start_time.split(" ")[1] == "PM" &&
                        movie.end_time.split(" ")[1] == "AM"
                          ? +new Date(
                              moment(date).add(1, "days").format("YYYY-MM-DD") +
                                "T" +
                                endShowtime +
                                this.timeZone.tz_utc_offset
                            )
                          : +new Date(
                              moment(date).format("YYYY-MM-DD") +
                                "T" +
                                endShowtime +
                                this.timeZone.tz_utc_offset
                            );
                      MovieObj["ss_end_date"] =
                        movie.start_time.split(" ")[1] == "PM" &&
                        movie.end_time.split(" ")[1] == "AM"
                          ? moment(date).add(1, "days").format("YYYY-MM-DD")
                          : moment(date).format("YYYY-MM-DD");

                      MovieObj["ss_end_date_time"] =
                        movie.start_time.split(" ")[1] == "PM" &&
                        movie.end_time.split(" ")[1] == "AM"
                          ? +new Date(
                              moment(date).add(1, "days").format("YYYY-MM-DD") +
                                "T" +
                                endShowtime +
                                this.timeZone.tz_utc_offset
                            )
                          : +new Date(
                              moment(date).format("YYYY-MM-DD") +
                                "T" +
                                endShowtime +
                                this.timeZone.tz_utc_offset
                            );
                    }
                  } else {
                    MovieObj["ss_actual_end_date"] =
                      movie.start_time.split(" ")[1] == "PM" &&
                      movie.end_time.split(" ")[1] == "AM"
                        ? moment(date).add(1, "days").format("YYYY-MM-DD")
                        : moment(date).format("YYYY-MM-DD");
                    MovieObj["ss_actual_start_date"] =
                      moment(date).format("YYYY-MM-DD");
                    MovieObj["ss_actual_end_date_time"] =
                      movie.start_time.split(" ")[1] == "PM" &&
                      movie.end_time.split(" ")[1] == "AM"
                        ? +new Date(
                            moment(date).add(1, "days").format("YYYY-MM-DD") +
                              "T" +
                              endShowtime +
                              this.timeZone.tz_utc_offset
                          )
                        : +new Date(
                            moment(date).format("YYYY-MM-DD") +
                              "T" +
                              endShowtime +
                              this.timeZone.tz_utc_offset
                          );
                    MovieObj["ss_actual_start_date_time"] = +new Date(
                      moment(date).format("YYYY-MM-DD") +
                        "T" +
                        showtime +
                        this.timeZone.tz_utc_offset
                    );
                    MovieObj["ss_end_date"] =
                      movie.start_time.split(" ")[1] == "PM" &&
                      movie.end_time.split(" ")[1] == "AM"
                        ? moment(date).add(1, "days").format("YYYY-MM-DD")
                        : moment(date).format("YYYY-MM-DD");

                    MovieObj["ss_end_date_time"] =
                      movie.start_time.split(" ")[1] == "PM" &&
                      movie.end_time.split(" ")[1] == "AM"
                        ? +new Date(
                            moment(date).add(1, "days").format("YYYY-MM-DD") +
                              "T" +
                              endShowtime +
                              this.timeZone.tz_utc_offset
                          )
                        : +new Date(
                            moment(date).format("YYYY-MM-DD") +
                              "T" +
                              endShowtime +
                              this.timeZone.tz_utc_offset
                          );
                  }

                  //

                  MovieObj["ss_start_date_time"] = +new Date(
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );

                  console.log(
                    'moment(date).format("YYYY-MM-DD") + " " + endShowtime :',
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      showtime +
                      this.timeZone.tz_utc_offset
                  );
                  console.log(
                    ' MovieObj["ss_start_date_time"]',
                    MovieObj["ss_start_date_time"]
                  );

                  console.log("endShowtime :", endShowtime);
                  console.log(
                    'MovieObj["ss_end_date_time"]  :',
                    MovieObj["ss_end_date_time"]
                  );
                  MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time
                  // array scheduleshowprice
                  MovieObj["scheduleshowprice"] = [];
                  let scheduleShowPricePromises = movie.scheduleShowPrice.map(
                    (price, priceIndex) => {
                      let PriceObj = {};

                      dateCount = PriceObj["cinema_id"] =
                        this.scheduleObject.cinema_id;
                      PriceObj["screen_id"] = item.screen_id;
                      PriceObj["md_id"] = movie.movie_details_id;
                      PriceObj["rate_card_id"] = price.rate_card_id;
                      PriceObj["rate_card_group_id"] = price.rate_card_group_id;
                      PriceObj["screen_seat_type_id"] =
                        price.screen_seat_type_id;
                      PriceObj["p_start_date_time"] = price.p_start_date_time; // price.p_start_date_time;
                      PriceObj["p_end_date_time"] = price.p_end_date_time; // price.p_end_date_time;
                      PriceObj["p_is_active"] = price.p_is_active || "Y";

                      // Push Show Price
                      MovieObj["scheduleshowprice"].push(PriceObj);
                    }
                  );
                  await Promise.all(scheduleShowPricePromises);

                  // Push Show and Show Price
                  MainObj["scheduleshow"].push(MovieObj);
                });
                await Promise.all(promises);
              });
              await Promise.all(moviePromises);
              // Final Array Push
              this.FinalArray.push(MainObj);
              console.log("this.FinalArray :", this.FinalArray);
            }
          );

          function format24Hours(date, time) {
            let newVal = date + " " + time;
            let finalVal = moment(newVal).format("HH:mm");
            return finalVal;
          }

          function toUnixTimeStamp(Datestring) {
            console.log("Datestring :", Datestring);
            return new Date(Datestring.toString()).getTime() / 1000;
          }
          // console.log("this.FinalArray :", this.FinalArray);

          this.btenable = true;
          await Promise.all(finalpromises)
            .then((result) => {
              let loader = this.$loading.show();

              console.log("this.FinalArray :", this.FinalArray);
              this.FinalArray.map((x) => {
                scheduleService
                  .AddSchedule(x)
                  .then((resp) => {
                    this.btenable = false;
                    loader.hide();
                    const { data } = resp;
                    if (data && data.status) {
                      this.duplicate.cine_id = null;
                      this.$refs.duplicateModal.hide();
                      this.$toasted.show(
                        "Thank You! Your show has been duplicated"
                      );
                      // this.$toasted.show(data.message);
                    } else {
                      this.$toasted.show(data.message);
                    }
                  })
                  .catch((err) => {
                    this.$toasted.show(err);
                  });
              });
            })
            .catch((err) => {
              this.$toasted.show(err);
            });
          // this.onFinalSubmit();
        }
      });
    },
    clear_ss_start_date() {
      this.duplicate.ss_start_date = "";
    },
    clear_ss_end_date() {
      this.duplicate.ss_end_date = "";
    },
    clear_singleduplicateDates(type) {
      console.log("Clearing dates");
      if (type == "start") {
        this.singleDuplicateDetails.ss_start_date = "";
      } else if (type == "end") {
        this.singleDuplicateDetails.ss_end_date = "";
      }
    },
    duplicateSchedule: function () {
      this.duplicate.ss_start_date = "";
      this.duplicate.ss_end_date = "";
      this.$refs.duplicateModal.show();
    },
    openImageModal: function () {
      this.$refs["preview-modal"].show();
    },
    setModalData() {
      this.showModal = !this.showModal;
    },
    onClickViewSeatLayout({ md_id, screen_id, ss_id }) {
      this.showFooterDetails = false;
      this.getScreenData(screen_id);
      this.GET_SEAT_LAYOUT({ ss_id, md_id, screen_id });
      this.getCurrencyCode();
      this.$refs.viewSeatLayoutModal.show();
    },
    getCurrencyCode() {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getScreenData(screen_id) {
      let payload = {
        tableName: "screens",
        screen_id: screen_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.screenObj = data.Records[0];
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error on getScreenData :", error);
        });
    },
    async GET_SEAT_LAYOUT(payload) {
      console.log("payload :", payload);
      let loader = this.$loading.show();
      let data = {};
      let seats = await PosService.PosGetSeatLayout({
        cinema_id: this.scheduleObject.cinema_id,
        screen_id: payload.screen_id,
        ss_id: payload.ss_id,
        md_id: payload.md_id,
      });
      data.seats = seats.data;
      let seatType = await PosService.getSeatType({
        cinema_id: this.scheduleObject.cinema_id,
        screen_id: payload.screen_id,
        ss_id: payload.ss_id,
        md_id: payload.md_id,
      });

      data.seatType = seatType.data;

      loader.hide();
      if (seats && seats.status) {
        let seatData = [];
        let seatData1 = groupBy(data.seats.Records, "sst_seat_type");
        data.seatType.Records = data.seatType.Records.sort(function (a, b) {
          return a.sst_order - b.sst_order;
        });
        data.seatType.Records.map((type) => {
          for (var key in seatData1) {
            if (seatData1.hasOwnProperty(key)) {
              // console.log(key + " -> " + seatData1[key]);
              if (key == type.sst_seat_type) {
                seatData[key] = seatData1[key];
              }
            }
          }
          // seatData.seat
        });
        let tempArray = [];
        for (let key in seatData) {
          if (seatData.hasOwnProperty(key)) {
            let seat_price = 0;
            let seat_price_obj = seatData[key].filter((x) => {
              return x;
            });

            if (seat_price_obj) {
              seat_price = seat_price_obj[0].seat_price;
            }

            tempArray.push({
              seatType: key,
              seat_price: seat_price,
              seats: seatData[key],
            });
          }
        }
        let finalArray = [];

        for (let i = 0; i < tempArray.length; i++) {
          let singleSeatType = tempArray[i];

          let seatData_1 = groupBy(singleSeatType.seats, "sl_row_num");
          let tempArray_1 = [];
          for (let key in seatData_1) {
            if (seatData_1.hasOwnProperty(key)) {
              let seatData_2 = seatData_1[key].map((singleSeat) => {
                singleSeat.selectStatus = false;
                singleSeat.SelectStatusFlag = false;
                return singleSeat;
              });
              seatData_2 = seatData_2.sort(function (a, b) {
                return a.sl_col_num - b.sl_col_num;
              });

              tempArray_1.push(seatData_2);
            }
          }
          tempArray[i].seatsFinal = tempArray_1;
        }
        this.seatLayoutData = tempArray;
      } else {
        this.$toasted.show(data.message || "Please try later");
      }
    },
    handleEnableDisableSch(sch) {
      let payload = {
        md_id: sch.md_id,
        ss_id: sch.ss_id,
        type: sch.is_sch_disable == "N" ? 1 : 2,
      };

      MasterService.EnableDisableSchedule(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.getSchedule(16);
          } else {
            cosole.log("Error Message", data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.$bvModal.hide("enableDisableSchedule");
        });
    },
    onClickEnableDisableSchedule(schedule) {
      this.showFooterDetails = false;
      let type = schedule.is_sch_disable == "N" ? 1 : 2;
      this.selectedSchedule = schedule;
      this.scheduleStatusType = type;

      if (schedule.booked_seats && schedule.booked_seats > 0 && type == 1) {
        return this.$toasted.show(
          `(${schedule.booked_seats}) transaction(s) found for this show. Please apply for refund module.`
        );
      } else if (
        schedule.unpaid_count &&
        schedule.unpaid_count > 0 &&
        type == 1
      ) {
        return this.$toasted.show(
          `(${schedule.unpaid_count}) Unpaid transaction(s) found, Please Cancel Unpaid Booking.`
        );
      } else {
        this.$refs["enableDisableSchedule"].show();
      }
    },
    onSelectShowType(type) {
      if (type.status_id == 1619) {
        this.getStatusId = 16;
      } else if ([1600, 3, 2].includes(type.status_id)) {
        this.getStatusId = 16;
      } else {
        this.getStatusId = type.status_id;
      }
      this.newStatusId = type.status_id;
      this.getSchedule(this.getStatusId);
    },
    zoomIn(type) {
      if (type == "add") {
        if (this.zoomLevel < 3) {
          this.zoomLevel++;
        }
      } else if (type == "minus") {
        if (this.zoomLevel > 1) {
          this.zoomLevel--;
        }
      }
    },
    toggleSidebar() {
      this.movietoggleOn = !this.movietoggleOn;
    },
    MovieLanguageText: function (movie) {
      let main_text_arr = [];
      let x = movie;
      let temp_arr = [];
      if (x.lang_iso_2) {
        temp_arr.push(x.lang_iso_2);
      }

      if (x.sub_lang_1_iso_2) {
        temp_arr.push(x.sub_lang_1_iso_2);
      }

      if (x.sub_lang_2_iso_2) {
        temp_arr.push(x.sub_lang_2_iso_2);
      }

      if (temp_arr.length > 0) {
        main_text_arr.push(temp_arr.join("/"));
      }

      if (main_text_arr.length > 0) {
        return main_text_arr.toUpperCase();
      } else {
        return "";
      }
    },
    showAdmitModal(show) {
      console.log("show", show);
      this.currentAdmits = 0;
      this.BookingID =
        show.hasOwnProperty("privateShowBookingDetails") &&
        show.privateShowBookingDetails.sb_booking_code
          ? show.privateShowBookingDetails.sb_booking_code
          : null;

      this.remainingAdmits = show.screen_total_seats;
      this.totalAdmits = show.admits;
      this.$refs.admits.show();
    },
    handleInputChange($event) {
      let num = $event.target.value;
      if (num < 0) {
        this.AdmitError = "Cannot have negative values";
        this.checkAdmitValid = false;
      } else if (num > this.remainingAdmits) {
        this.AdmitError = "Exceeded Seat Limit in Audi";
        this.checkAdmitValid = false;
      } else {
        this.checkAdmitValid = true;
      }
    },
    onSubmitAdmits: function () {
      if (!this.checkAdmitValid) {
        return this.$toasted.show(this.AdmitError);
      }
      let payload = {
        seats: "All",
        booking_id: this.BookingID,
        isPrivateShow: true,
        current_admits: parseInt(this.currentAdmits),
      };
      scheduleService
        .updateAdmits(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.$toasted.show(data.message);
            this.getSchedule();
            this.$refs.admits.hide();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show("something went wrong");
        });
    },
    handleAdmitChange: function (type) {
      if (type === "add") {
        if (this.currentAdmits + 1 <= this.remainingAdmits)
          this.currentAdmits += 1;
        else this.$toasted.show("Reached Max Seat Limit In Audi");
      } else if (type === "sub") {
        if (this.currentAdmits - 1 >= 0) this.currentAdmits -= 1;
      }
    },
    dateHandler(type) {
      if (this.scheduleObject.sch_start_date) {
        let date = this.scheduleObject.sch_start_date;
        if (type == "next") {
          this.scheduleObject.sch_start_date = new Date(
            moment(date).add(1, "days")
          );
        } else if (type == "pre") {
          this.scheduleObject.sch_start_date = new Date(
            moment(date).subtract(1, "days")
          );
        }

        this.getSchedule(this.getStatusId);
        if (this.scheduleObject.cinema_id) {
          this.getCinemaSetting(this.scheduleObject.cinema_id);
        }
        this.$forceUpdate();
      }
    },
    onSelectStatus(event, status) {
      this.selectedStatus = status.type;
      this.selectedScheduleStatus = status;
      this.isChanged = true;
      this.movieSelected.ss_show_status = status.status_id;
      this.movieSelected.selectedShowStatus = status;
      // this.getStatusId = status.status_id;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].ss_show_status = status.status_id;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].selectedShowStatus = status;
    },
    getMovieVersionText(movie) {
      // let text = "";
      // text =
      //   (movie.mf_name ? movie.mf_name + "-" : "") +
      //   (movie.lang_name ? movie.lang_name + "-" : "") +
      //   (movie.sound_format_name ? movie.sound_format_name : "");

      // if (text.endsWith("-")) {
      //   text = text.substring(0, text.length - 1);
      // }

      // return text;

      let temp_arr = [];

      if (movie.mf_name) temp_arr.push(movie.mf_name);
      if (movie.lang_iso_2) temp_arr.push(movie.lang_iso_2);
      if (movie.sound_format_name) temp_arr.push(movie.sound_format_name);
      if (movie.resolution_short_code)
        temp_arr.push(movie.resolution_short_code);
      if (movie.aspect_ratio_name) temp_arr.push(movie.aspect_ratio_name);
      if (movie.movie_experience) temp_arr.push(movie.movie_experience);
      if (movie.sub_lang_1_iso_2) temp_arr.push(movie.sub_lang_1_iso_2);
      if (movie.sub_lang_2_iso_2) temp_arr.push(movie.sub_lang_2_iso_2);

      if (temp_arr.length > 0) {
        return temp_arr.join("-").toUpperCase();
      } else {
        return "";
      }

      // if (movie.subtitle_language_name_1 && movie.subtitle_language_name_1.iso_3)
      //   temp_arr.push(movie.subtitle_language_name_1.iso_3);
      // if (movie.subtitle_language_name_2 && movie.subtitle_language_name_2.iso_3)
      //   temp_arr.push(movie.subtitle_language_name_2.iso_3);
      // if (movie.format_name) temp_arr.push(movie.format_name);
    },
    onDeleteMovieModalNew() {
      console.log(this.selectedMoviesInScreens[this.selectedScreenIndex]);
      console.log(this.selectedMoviesInScreens);
      console.log("SCREEN INDEX", this.selectedScreenIndex);
      console.log("SCREEN", this.selectedScreen);

      if (
        this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"][
          this.selectedMovieIndex
        ].isNewSchedule
      ) {
        this.selectedMoviesInScreens[this.selectedScreenIndex]["movies"].splice(
          this.selectedMovieIndex,
          1
        );
        this.isMovieCardSelected = false;
      }
    },
    hideSection() {
      this.selectedScreenTypeIndex = null;
    },
    getActiveMoviesonClear: function (event) {
      console.log("Running Due to this");
      this.getAllActiveMovies();
    },
    away: function () {
      this.togglePopUp("close");
      this.dropLocation.screen = "-1";
      // if (this.selectedScreenIndex != null && this.selectedMovieIndex != null) {
      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].selected = false;
      // }
    },
    mouseDownMovie: function () {
      if (event.button == 2) {
        this.editRightMouseMovieBlock.X = event.screenX;
        this.editRightMouseMovieBlock.Y = event.screenY;
        this.togglePopUp("open");
      }
    },
    togglePopUp: function (type) {
      if (type == "close") {
        this.editRightMouseMovieBlock.show = false;
      }
      if (type == "open") {
        this.editRightMouseMovieBlock.show = true;
      }
    },
    dragEnd: function () {
      console.log("dragend");
      let that = this;
      setTimeout(() => {
        this.dropLocation.screen = -1;
      }, 100);
    },
    compareDateTime: function (ss_actual_end_date_time) {
      return moment(moment.unix(ss_actual_end_date_time)).isAfter(moment());
    },

    scrolfun() {
      this.topValue = event.srcElement.scrollTop;
      this.leftValue = event.srcElement.scrollLeft;
    },
    onSelectScreenType(ScreenTypeIndex) {
      this.selectedScreenTypeIndex = ScreenTypeIndex;
    },
    onDefaultRateCardEmpty(screenIndex, movieIndex, scheduleIndex) {
      if (
        this.selectedMoviesInScreens[screenIndex]["movies"][movieIndex][
          "scheduleShowPrice"
        ][scheduleIndex].rate_card_id == "" &&
        this.selectedMoviesInScreens[screenIndex]["movies"][movieIndex][
          "scheduleShowPrice"
        ][scheduleIndex].rate_card_id == null
      ) {
        this.selectedRateCardObject.rate_card_id = "";
        this.selectedRateCardObject.rate_card_name = "";
        this.selectedRateCardObject.screen_seat_type_id = "";
        this.selectedRateCardObject.SeatTypeIndex = "";
        this.selectedMoviesInScreens[screenIndex]["movies"][movieIndex][
          "scheduleShowPrice"
        ][scheduleIndex] = [
          {
            rate_card_id: null,
            schedule_show_id: null,
            screen_seat_type_id: null,
            sst_seat_type: "",
            p_start_date_time: null,
            p_end_date_time: null,
            p_is_active: "Y",
          },
        ];
      }
    },
    onChangeRateCardSticky(screenTypeIndex, screenType, rate_card) {
      this.isChanged = true;
      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice[screenTypeIndex].defaultRateCard = false;
      if (this.autoSave) {
        console.log("Auto Saving on Change rate Card");
        this.submitSchedule();
      }
    },
    onSelectRateCardFromEdit(event, movie, schPriceindex) {
      this.isChanged = true;
      movie.scheduleShowPrice[schPriceindex].defaultRateCard = false;
      let _Obj = {
        ...movie.scheduleShowPrice[schPriceindex],
        rate_card_id: event.rc_id,
        selectedRateCard: event,
        searchRateCard: "",
        rate_card_name: event.rc_g_name,
        rate_card_group_id: event.rc_g_id,
        cinema_id: this.scheduleObject.cinema_id,
        screen_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].screen_id,
        md_id: movie.movie_details_id,
        schedule_show_id: movie.show_schedule_id,
      };

      movie.scheduleShowPrice[schPriceindex] = _.cloneDeep(_Obj);
      this.$forceUpdate();
    },
    onSelectRateCard(screenTypeIndex, screenType, rate_card) {
      let _Obj = {
        ...this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice[this.selectedScreenTypeIndex],
        rate_card_id: rate_card.rc_id,
        selectedRateCard: rate_card,
        searchRateCard: "",
        rate_card_name: rate_card.rc_g_name,
        rate_card_group_id: rate_card.rc_g_id,
        screen_seat_type_id: screenType.sst_id,
        sst_seat_type: screenType.sst_seat_type,
        cinema_id: this.scheduleObject.cinema_id,
        screen_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].screen_id,
        md_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].movie_details_id,
        schedule_show_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].show_schedule_id,
      };
      VueMain.set(
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice,
        this.selectedScreenTypeIndex,
        _Obj
      );
      this.$forceUpdate();

      let nullValues = true;
      let checkArray =
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice;
      nullValues = checkArray.some(function (e) {
        return e.rate_card_id == null;
      });

      if (!nullValues) {
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].isReady = true;
      } else {
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].isReady = false;
      }
      // this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //   this.selectedMovieIndex
      // ].scheduleShowPrice.map(x => {
      //   if (x.rate_card_id == null) {
      //     this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //       this.selectedMovieIndex
      //     ].isReady = false;
      //   } else {
      //     this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
      //       this.selectedMovieIndex
      //     ].isReady = true;
      //   }
      // });

      console.log("screenType TEST", screenType);

      this.selectedRateCardObject.rate_card_id = rate_card.rc_id;
      this.selectedRateCardObject.rate_card_name = rate_card.rate_card_name;
      this.selectedRateCardObject.screen_seat_type_id = screenType.sst_id;
      this.selectedRateCardObject.sst_seat_type = screenType.sst_seat_type;
      this.selectedRateCardObject.SeatTypeIndex = screenTypeIndex;
      this.selectedRateCardObject.rate_card_group_id = rate_card.rc_g_id;

      this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
        this.selectedMovieIndex
      ].scheduleShowPrice.map((x) => {
        x["searchRateCard"] = "";
      });
      this.RatecardsList = this.RatecardsListCopy;
      this.selectedScreenSeatTypes[this.selectedScreenTypeIndex]["rate_card"] =
        rate_card.rc_g_name;
      this.selectedScreenSeatTypes[this.selectedScreenTypeIndex][
        "rate_card_group_id"
      ] = rate_card.rc_g_id;
      this.selectedScreenSeatTypes[this.selectedScreenTypeIndex][
        "rate_card_id"
      ] = rate_card.rc_id;
      this.selectedScreenTypeIndex = null;
    },
    onSelectSession(type) {
      this.selectedSessionType = type;
    },
    getCinemaList: function (cine_id) {
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;

            if (false && data.Records && data.Records.length === 1) {
              this.cinemasSelected = data.Records[0];
              this.onSelectCinemaFromMultiSelect(data.Records[0]);
              // this.getSchedule(16);
            } else if (
              this.$route.query &&
              this.$route.query.hasOwnProperty("cinema_id") &&
              this.$route.query.cinema_id
            ) {
              let cinemaTemp = data.Records.filter(
                (x) => x.cine_id == this.$route.query.cinema_id
              );
              if (cinemaTemp && cinemaTemp.length > 0) {
                this.cinemasSelected = cinemaTemp[0];
                this.onSelectCinemaFromMultiSelect(cinemaTemp[0]);
              }
            } else if (cine_id && cine_id != 0) {
              this.getAllActiveScreens(cine_id);
              this.getCinemaSetting(cine_id);
              this.getRatecardsList(cine_id);
              this.getAllAddonsCharges();

              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.selected.cinema = x.cine_name;
                  this.cinemasSelected = x;
                  this.scheduleObject.cinema_id = cine_id;
                }
              });
            }

            console.log("this.$route", this.$route);
          } else {
            // Show Error Message
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {});
    },
    onChangeTime: function (event) {
      this.movieSelected.start_time = event.target.value;
    },
    onUpdate: function () {
      this.isChanged = true;
      this.disableBtns["updateMovieBtn"] = true;
      console.log("this.movieSelected UPDATE", this.movieSelected);
      if (!this.movieSelected.start_time) {
        this.$toasted.show("Please Select Start Time!");
        return false;
      }
      this.getScheduleChecker()
        .then((result) => {
          if (!result.status) {
            this.disableBtns["updateMovieBtn"] = false;
            this.$toasted.show(result.message);
          } else if (result.status) {
            let start = 0;
            let newlengthMinutes =
              this.movieSelected.mrrdr_runtime +
              parseInt(this.movieSelected.cleaning_time_in_mins) +
              parseInt(this.movieSelected.ads_time_in_mins) +
              parseInt(this.movieSelected.interval_time_in_mins);
            this.movieSelected.lengthMinutes = newlengthMinutes;
            let old_show_time =
              this.movieSelected.ss_actual_start_date_time || null;
            let movie_name_format = `${this.movieSelected.movie_title} ${this.movieSelected.mf_name} (${this.movieSelected.lang_name})`;

            let ss_actual_start_date_time = null;
            let ss_actual_end_date_time = null;
            let ss_actual_start_date = null;
            let ss_actual_end_date = null;
            let ss_end_date = null;
            let ss_end_date_time = null;

            this.movieSelected.start_time = this.onChangeTimePicker(
              this.movieSelected.selected_time
            );
            start = this.newGetScreenPositionCalc(
              this.movieSelected.start_time,
              this.movieSelected.start_time.split(":")[1]
            );
            this.movieSelected.start = start;
            let end_time = moment(this.movieSelected.selected_time)
              .add(parseInt(this.movieSelected.lengthMinutes), "m")
              .toDate();
            this.movieSelected.end_time = moment(end_time).format("HH:mm");

            let date = moment(this.scheduleObject.sch_start_date).format(
              "YYYY-MM-DD"
            );
            let showtime = format24Hours(date, this.movieSelected.start_time);
            let endShowtime = format24Hours(date, this.movieSelected.end_time);
            let ss_start_date_time = +new Date(
              moment(date).format("YYYY-MM-DD") +
                "T" +
                showtime +
                this.timeZone.tz_utc_offset
            );

            function format24Hours(date, time) {
              let newVal = date + " " + time;
              let finalVal = moment(newVal).format("HH:mm");
              return finalVal;
            }

            if (
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).isSameOrAfter(
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
              )
            ) {
              if (
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                ).isAfter(
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      this.movieSelected.start_time
                  )
                )
              ) {
                ss_actual_start_date = moment(date)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                ss_actual_start_date_time = +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    showtime +
                    this.timeZone.tz_utc_offset
                );
                ss_actual_end_date = moment(date)
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                ss_actual_end_date_time = +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                );
                ss_end_date = moment(date).add(1, "days").format("YYYY-MM-DD");

                ss_end_date_time = +new Date(
                  moment(date).add(1, "days").format("YYYY-MM-DD") +
                    "T" +
                    endShowtime +
                    this.timeZone.tz_utc_offset
                );
              } else {
                ss_actual_start_date = moment(date).format("YYYY-MM-DD");
                ss_actual_start_date_time = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    showtime +
                    this.timeZone.tz_utc_offset
                );

                ss_actual_end_date =
                  moment(this.movieSelected.start_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "PM" &&
                  moment(this.movieSelected.end_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "AM"
                    ? moment(date).add(1, "days").format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_actual_end_date_time =
                  moment(this.movieSelected.start_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "PM" &&
                  moment(this.movieSelected.end_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
                ss_end_date =
                  moment(this.movieSelected.start_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "PM" &&
                  moment(this.movieSelected.end_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "AM"
                    ? moment(date).add(1, "days").format("YYYY-MM-DD")
                    : moment(date).format("YYYY-MM-DD");

                ss_end_date_time =
                  moment(this.movieSelected.start_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "PM" &&
                  moment(this.movieSelected.end_time, ["HH:mm"])
                    .format("h:mm A")
                    .split(" ")[1] == "AM"
                    ? +new Date(
                        moment(date).add(1, "days").format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      )
                    : +new Date(
                        moment(date).format("YYYY-MM-DD") +
                          "T" +
                          endShowtime +
                          this.timeZone.tz_utc_offset
                      );
              }
            } else {
              ss_actual_start_date = moment(date).format("YYYY-MM-DD");
              ss_actual_start_date_time = +new Date(
                moment(date).format("YYYY-MM-DD") +
                  "T" +
                  showtime +
                  this.timeZone.tz_utc_offset
              );
              ss_actual_end_date =
                moment(this.movieSelected.start_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "PM" &&
                moment(this.movieSelected.end_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "AM"
                  ? moment(date).add(1, "days").format("YYYY-MM-DD")
                  : moment(date).format("YYYY-MM-DD");

              ss_actual_end_date_time =
                moment(this.movieSelected.start_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "PM" &&
                moment(this.movieSelected.end_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "AM"
                  ? +new Date(
                      moment(date).add(1, "days").format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    )
                  : +new Date(
                      moment(date).format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    );
              ss_end_date =
                moment(this.movieSelected.start_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "PM" &&
                moment(this.movieSelected.end_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "AM"
                  ? moment(date).add(1, "days").format("YYYY-MM-DD")
                  : moment(date).format("YYYY-MM-DD");

              ss_end_date_time =
                moment(this.movieSelected.start_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "PM" &&
                moment(this.movieSelected.end_time, ["HH:mm"])
                  .format("h:mm A")
                  .split(" ")[1] == "AM"
                  ? +new Date(
                      moment(date).add(1, "days").format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    )
                  : +new Date(
                      moment(date).format("YYYY-MM-DD") +
                        "T" +
                        endShowtime +
                        this.timeZone.tz_utc_offset
                    );
            }
            if (
              this.movieSelected.hasOwnProperty("isNewSchedule") &&
              this.movieSelected.isNewSchedule == false
            ) {
              let payload = {
                cinema_id: this.scheduleObject.cinema_id,
                show_schedule_id:
                  this.movieSelected.scheduleShowPrice[0].schedule_show_id,
                screen_id: this.movieSelected.scheduleShowPrice[0].screen_id,
                interval_time_in_mins:
                  this.movieSelected.interval_time_in_mins || 0,
                cleaning_time_in_mins:
                  this.movieSelected.cleaning_time_in_mins || 0,
                ads_time_in_mins: this.movieSelected.ads_time_in_mins || 0,
                ss_start_show_time: showtime, // this.movieSelected.start_time,
                ss_end_show_time: endShowtime, // this.movieSelected.end_time,
                ss_start_date_time: ss_start_date_time,
                ss_show_status: this.movieSelected.ss_show_status,
                ss_end_date_time: ss_end_date_time,
                ss_actual_end_date: ss_actual_end_date,
                ss_actual_end_date_time: ss_actual_end_date_time,
                ss_actual_start_date: ss_actual_start_date,
                ss_actual_start_date_time: ss_actual_start_date_time,
                old_show_time: old_show_time,
                sch_artwork_url: this.movieSelected.sch_artwork_url,
                movie_format_name: movie_name_format,
                ss_comment: this.movieSelected.ss_comment,
                scheduleShowPrice: this.movieSelected.scheduleShowPrice,
                sales_channel_changes: this.movieSelected.sales_channel_changes,
                AddonsCharges: this.movieSelected.AddonsCharges,
                AddonsName: this.movieSelected.AddonsName,
                version: this.movieSelected.version,
                md_id: this.movieSelected.md_id,
                turnOffMultiSeatSelection: !!this.movieSelected
                  .turnOffMultiSeatSelection
                  ? "Y"
                  : "N",
                is_special_schedule: !!this.movieSelected.is_special_schedule
                  ? "Y"
                  : "N",
              };

              console.log("payload UPDATE", payload);
              scheduleService
                .UpdateCinemaScheduleByShow(payload)
                .then((result) => {
                  const { data } = result;
                  if (data.status) {
                    this.$toasted.show(data.message);
                    this.getSchedule();
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch((err) => {
                  this.$toasted.show(err);
                })
                .finally(() => {
                  this.disableBtns["updateMovieBtn"] = false;
                });
            }
          } else {
            this.$toasted.show(data.message);
            this.disableBtns["updateMovieBtn"] = false;
          }
          this.$refs.updateMovie.hide();
        })
        .catch((err) => {
          this.$refs.updateMovie.hide();
          this.disableBtns["updateMovieBtn"] = false;
          this.$toasted.show(err);
        })
        .finally(() => {
          this.isChanged = false;
        });
    },

    convertToHrs: function (value) {
      let hours = Math.floor(value / 60);
      let minutes = Math.floor(value % 60);
      return hours + " hrs " + minutes + " mins";
    },

    duplicateSchedule: function () {
      this.$refs.duplicateModal.show();
    },

    onEditMovie(screenMovie, screen) {
      this.showFooterDetails = false;
      console.log("OKK");
      // this.selectedMovieRef = screenMovie;
      this.movieSelected = _.cloneDeep(screenMovie);
      // this.movieSelected = screenMovie;
      this.selectedScreen = screen;
      let versionObj = {
        movie_id: screenMovie.movie_id,
        md_id: screenMovie.md_id,
        movie_name: screenMovie.movie_name,
        sound_format_id: screenMovie.sound_format_id,
        mf_id: screenMovie.mf_id,
      };
      let tempObj = {
        version: versionObj,
        startTime2: screenMovie.ss_start_show_time,
        selected_time:
          moment().format("YYYY-MM-DD") + " " + screenMovie.start_time,
      };
      this.movieSelected = { ...this.movieSelected, ...tempObj };
      this.$refs["updateMovie"].show();
    },
    onDeleteMovieModal: function (
      screen,
      screenMovie,
      screenIndex,
      screenMovieIndex
    ) {
      console.log("screen", screen);
      console.log("screenMovie", screenMovie);
      console.log("screenIndex", screenIndex);
      console.log("screenMovieIndex", screenMovieIndex);
      if (
        this.movieSelected.hasOwnProperty("isNewSchedule") &&
        this.movieSelected.isNewSchedule == false
      ) {
        this.selectedScreen = screen;
        this.movieSelected = _.cloneDeep(screenMovie);
        this.selectedScreenIndex = screenIndex;
        this.selectedMovieIndex = screenMovieIndex;
        // let ss_id = screenMovie.scheduleShowPrice.map((x) => {
        //   return x.schedule_show_id;
        // });
        let ss_id = screenMovie.ss_id || screenMovie.show_schedule_id;
        if (!isNaN(ss_id) || !isNaN(show_schedule_id)) {
          RefundService.GetShowTransaction({
            ss_id: ss_id,
            cinema_id: this.scheduleObject.cinema_id,
          })
            .then((response) => {
              const { data } = response;
              if (data.status) {
                if (
                  data.Records.length > 0 &&
                  data.total_seats_booked &&
                  data.total_seats_booked.length > 0
                ) {
                  this.$toasted.show(
                    data.Records.length +
                      " transaction(s) found for this show. Please apply for refund module"
                  );
                } else if (
                  screenMovie.unpaid_count &&
                  screenMovie.unpaid_count > 0
                ) {
                  this.$toasted.show(
                    `(${screenMovie.unpaid_count}) Unpaid transaction(s) found, Please Cancel Unpaid Booking.`
                  );
                } else {
                  this.isMovieCardSelected = false;
                  this.$refs.deleteMovieModal.show();
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("ERROR:", err);
              this.$toasted.show("Something went wrong!");
            });
        } else {
          console.log("Error Else");
          this.$toasted.show("Something went wrong!");
        }
      } else {
        this.selectedScreenIndex = null;
        this.selectedMovieIndex = null;
        this.selectedMoviesInScreens[screenIndex].movies.splice(
          screenMovieIndex,
          1
        );
        this.isMovieCardSelected = false;
      }
    },
    getSchedule: function (status_id = null) {
      this.isMovieCardSelected = false;
      this.isChanged = false;
      let self = this;
      this.getStatusId = status_id;
      let statusArray = [];
      let otherStatusArray = null;

      // if (status_id) {
      //   let status_id_temp = status_id || 16;
      //   let selectedStatus = this.scheduleStatusArray.filter(
      //     (x) => x.status_id == status_id_temp
      //   );
      //   this.selectedStatus = selectedStatus[0].type;
      // }

      if ([1600, 3, 2].includes(this.newStatusId)) {
        otherStatusArray = this.newStatusId;
      }

      if (this.newStatusId == 1619) {
        statusArray.push(16, 19, 13);
      } else if (this.newStatusId == 16) {
        statusArray.push(16, 13);
      } else if (![1600, 3, 2].includes(this.newStatusId)) {
        statusArray.push(this.newStatusId);
      }

      if (
        this.scheduleObject.cinema_id == null ||
        this.scheduleObject.cinema_id.length == 0
      ) {
        this.$toasted.show("Please Select Cinema");
      } else {
        this.selectedStatusId = status_id;
        let payload = {};
        let loader = "";
        // this.$refs.showDeletedModal.hide();
        // this.$refs.showPlannedModal.hide();
        loader = this.$loading.show();
        this.selectedMoviesInScreens = this.selectedMoviesInScreens.map((x) => {
          x.movies = [];
          return x;
        });

        this.btenable = true;
        payload = {
          ss_show_status: status_id || "all",
          cinema_id: this.scheduleObject.cinema_id,
          start_date: moment(this.scheduleObject.sch_start_date).format(
            "YYYY-MM-DD"
          ),
          end_date: moment(this.scheduleObject.sch_start_date).format(
            "YYYY-MM-DD"
          ),
          groupbyssid: "Y",
        };

        scheduleService
          .GetCinemaSchedule(payload)
          .then((result) => {
            this.btenable = false;
            const { data } = result;
            loader.hide();

            if (data.typeList && data.typeList.length > 0) {
              let tempArr = [
                {
                  color: "#ff000026",
                  name: "No Rate Card Attached",
                },
              ];

              this.typeList = data.typeList.concat(tempArr);
            }

            if (data.status) {
              if (data.Records.length > 0) {
                let newRecords = data.Records;
                if (otherStatusArray) {
                  if (otherStatusArray == 1600) {
                    newRecords = newRecords.filter((x) => x.is_event == "Y");
                  } else if (otherStatusArray == 3) {
                    newRecords = newRecords.filter(
                      (x) => x.mycinema_booking_type_id == 3
                    );
                  } else if (otherStatusArray == 2) {
                    newRecords = newRecords.filter(
                      (x) =>
                        x.mycinema_booking_type_id == 2 ||
                        x.mycinema_booking_type_id == 1
                    );
                  }
                  if (newRecords.length == 0) {
                    this.$toasted.show("No Shows Found");
                  }
                } else {
                  newRecords = newRecords.filter((x) =>
                    statusArray.includes(x.ss_show_status)
                  );
                }
                console.log(
                  "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2084 ~ newRecords",
                  newRecords
                );
                let _newRecords = uniqBy(newRecords, "screen_id");
                newRecords.map((y) => {
                  console.log("y :>> ", y);
                  if (y.scheduleShowPrice && y.scheduleShowPrice.length > 0) {
                    y.scheduleShowPrice.forEach((r) => {
                      r["defaultRateCard"] = false;
                      r["searchRateCard"] = "";
                    });
                  }
                  this.selectedMoviesInScreens.map((x) => {
                    if (String(y.screen_id) === String(x.screen_id)) {
                      console.log(
                        "X selectedMoviesInScreens getschedule test",
                        x
                      );
                      let ScreenSeatTypeArrayTemp = x.screen_seat_types;
                      let scheduleShowPrice_temp = [];

                      ScreenSeatTypeArrayTemp.forEach((p, sstindex) => {
                        let _obj = {
                          rate_card_id: null,
                          rate_card_group_id: null,
                          screen_id: y.screen_id,
                          schedule_show_id: y.ss_id,
                          screen_seat_type_id: p.sst_id,
                          sst_seat_type: p.sst_seat_type,
                          p_start_date_time: null,
                          p_end_date_time: null,
                          p_is_active: "Y",
                          rc_name: "",
                          searchRateCard: "",
                          defaultRateCard: true,
                          selectedRateCard: "",
                        };

                        let checkPrice = y.scheduleShowPrice.some(
                          (x) => x.screen_seat_type_id == p.sst_id
                        );
                        if (!checkPrice) {
                          y.scheduleShowPrice.splice(sstindex, 0, _obj);
                        }

                        scheduleShowPrice_temp.push(_obj);
                      });
                      if (y.ss_id == "2039") {
                        console.log(
                          " y.scheduleShowPrice",
                          y.scheduleShowPrice
                        );
                      }

                      let lengthMinutes =
                        parseInt(y.mrrdr_runtime || 0) +
                        parseInt(y.ads_time_in_mins || 0) +
                        parseInt(y.cleaning_time_in_mins || 0) +
                        parseInt(y.interval_time_in_mins || 0);
                      let sign = self.timeZone.tz_utc_offset.charAt(0);
                      let offset = self.timeZone.tz_utc_offset.substring(1);
                      let hours = offset.split(":")[0];
                      let minutes = offset.split(":")[1];
                      console.log(
                        "lengthMinutes",
                        lengthMinutes,
                        y.movie_title
                      );
                      console.log(
                        "y.mrrdr_runtime, ads_time_in_mins, cleaning_time_in_mins,interval_time_in_mins ",
                        y.mrrdr_runtime,
                        y.ads_time_in_mins,
                        y.cleaning_time_in_mins,
                        y.interval_time_in_mins,
                        y.movie_title
                      );
                      let timeZoneFlag =
                        momentT.tz.guess() === self.timeZone.tz_name ||
                        ((momentT.tz.guess() == "Asia/Calcutta" ||
                          momentT.tz.guess() == "Asia/Kolkata") &&
                          (self.timeZone.tz_name == "Asia/Kolkata" ||
                            self.timeZone.tz_name == "Asia/Calcutta"));
                      x.movies.push({
                        lengthMinutes,
                        // length: (lengthMinutes * 30) / 10, //original
                        length: (lengthMinutes * 50) / 60,
                        // length:
                        //   this.getScreenPositionCalc(y.ss_end_show_time) -
                        //   this.getScreenPositionCalc(y.ss_start_show_time),

                        start: self.newGetScreenPositionCalc(
                          y.ss_start_show_time,
                          y.ss_start_show_time.split(":")[1]
                        ),

                        selected_time: !timeZoneFlag
                          ? sign == "+"
                            ? moment(y.ss_start_date_time)
                                .tz(self.timeZone.tz_name)
                                .add("-" + hours, "hours")
                                .add("-" + minutes, "minutes")
                                .format()
                            : moment(y.ss_start_date_time)
                                .tz(self.timeZone.tz_name)
                                .add(hours, "hours")
                                .add(minutes, "minutes")
                                .format()
                          : moment(y.ss_start_date_time).format(),
                        movie_details_id: y.movie_details_id,
                        md_id: y.md_id,
                        ss_id: y.ss_id,
                        screen_id: y.screen_id,
                        lang_name: y.language_name,
                        start_time: y.ss_start_show_time,
                        sales_channel: y.sales_channel,
                        all_sales_channel_length: y.all_sales_channel_length,
                        sales_channel_changes: [],
                        AddonsCharges: y.AddonsCharges,
                        AddonsName: y.AddonsName,
                        //  moment(y.ss_start_show_time, [
                        //   "HH:mm"
                        // ]).format("h:mm A"),
                        end_time: y.ss_end_show_time,
                        // moment(y.ss_end_show_time, ["HH:mm"]).format(
                        //   "h:mm A"
                        // ),
                        interval_time_in_mins:
                          parseInt(y.interval_time_in_mins) >= 0
                            ? y.interval_time_in_mins
                            : y.cine_interval_time_in_mins,
                        cleaning_time_in_mins:
                          parseInt(y.cleaning_time_in_mins) >= 0
                            ? y.cleaning_time_in_mins
                            : y.cine_cleaning_time_in_mins,
                        ads_time_in_mins:
                          parseInt(y.ads_time_in_mins) >= 0
                            ? y.ads_time_in_mins
                            : y.cine_setting_ads_time_in_mins,
                        cine_interval_time_in_mins:
                          y.interval_time_in_mins ||
                          y.cine_interval_time_in_mins,
                        cine_cleaning_time_in_mins:
                          y.cleaning_time_in_mins ||
                          y.cine_cleaning_time_in_mins,
                        cine_setting_ads_time_in_mins:
                          y.ads_time_in_mins || y.cine_setting_ads_time_in_mins,
                        mf_name: y.movie_format,
                        mrrdr_runtime: y.mrrdr_runtime,
                        sound_format_name: y.sound_format_name,
                        movie_resolution_id:
                          y.movie_resolution_id || y.resolution_id,
                        aspect_ratio_id: y.aspect_ratio_id,
                        is_foreign_movie: y.is_foreign_movie || "N",
                        movie_experience_id: y.movie_experience_id,
                        movie_title: y.movie_title,
                        movie: y.movie,
                        movie_name: y.movie,
                        movie_id: y.movie_id,
                        md_thumbnail_url: y.md_thumbnail_url,
                        is_sch_disable: y.is_sch_disable,
                        ss_comment: y.ss_comment,
                        turnOffMultiSeatSelection: y.turnOffMultiSeatSelection,
                        is_special_schedule: y.is_special_schedule,
                        is_event: y.is_event,
                        backgroundColor: y.backgroundColor,
                        isCrowdSource: y.isCrowdSource,
                        booked_seats: y.booked_seats,
                        mycinema_booking_type_id: y.mycinema_booking_type_id,
                        screen_total_seats: y.screen_total_seats,
                        unpaid_count: y.unpaid_count,
                        sch_artwork_url: y.sch_artwork_url || "",
                        ss_start_show_time: y.ss_start_show_time,
                        ss_end_show_time: y.ss_end_show_time,
                        scheduleShowPrice:
                          y.scheduleShowPrice && y.scheduleShowPrice.length > 0
                            ? y.scheduleShowPrice
                            : scheduleShowPrice_temp,
                        ss_start_date: y.ss_start_date,
                        ss_end_date: y.ss_end_date,
                        ss_start_date_time: y.ss_start_date_time,
                        ss_end_date_time: y.ss_end_date_time,
                        ss_is_active: y.ss_is_active,
                        ss_show_status: y.ss_show_status,
                        selectedShowStatus: this.scheduleStatusArray.find(
                          (x) => x.status_id == y.ss_show_status
                        ),
                        ss_actual_end_date_time: y.ss_actual_end_date_time,
                        ss_actual_start_date_time: y.ss_actual_start_date_time,
                        scd_reason: status_id == 17 ? y.scd_reason : "",
                        scd_created_by: status_id == 17 ? y.username : "",
                        show_schedule_id: y.ss_id,
                        isNewSchedule: false,
                        min_seats: y.min_seats,
                        mycinema_booking_type_id: y.mycinema_booking_type_id,
                        ss_actual_start_date: y.ss_actual_start_date,
                        ss_actual_end_date: y.ss_actual_end_date,
                        privateShowBookingDetails:
                          y.hasOwnProperty("privateShowBookingDetails") &&
                          y.privateShowBookingDetails
                            ? y.privateShowBookingDetails
                            : null,
                        admits: y.admits || 0,
                        cust_email: y.cust_email,
                        customer_mobile: y.customer_mobile,
                        is_guest_user: y.is_guest_user,
                        customer_name: y.customer_name,
                        special_request: y.special_request,
                        user: status_id == 17 ? y.user : "",
                        deleted_at: status_id == 17 ? y.deleted_at : "",
                        unpaid_count: y.unpaid_count,
                      });
                      console.log(
                        "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2110 ~ x.movies",
                        x.movies
                      );
                    }
                    return x;
                  });
                });

                this.selectedMoviesInScreensFlag = true;
              } else if (data.Records.length == 0) {
                let date = moment(this.scheduleObject.sch_start_date).format(
                  "DD-MM-YYYY"
                );
                this.$toasted.show(
                  "No Shows Found for the Cinema " +
                    this.selected.cinema +
                    " on Date " +
                    date
                );
              }
            }
          })
          .catch((err) => {});
        function getLength(startTime, ref) {
          let cinema_start = ref.getScreenPositionCalc(
            ref.CinemasSettings.cine_operation_start_time
          );
          // let show_start_time = ref.getScreenPositionCalc(startTime);
          let show_start_time = ""; //ref.getScreenPositionCalc(startTime);
          if (
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                ref.CinemasSettings.cine_operation_end_time
            ).isSameOrBefore(
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  ref.CinemasSettings.cine_operation_start_time
              )
            )
          ) {
            if (
              moment(
                moment().format("YYYY-MM-DD") +
                  " " +
                  ref.CinemasSettings.cine_operation_end_time
              ).isAfter(moment(moment().format("YYYY-MM-DD") + " " + startTime))
            ) {
              show_start_time = 4320 + ref.getScreenPositionCalc(startTime);
            } else {
              show_start_time = ref.getScreenPositionCalc(startTime);
            }
          } else {
            show_start_time = ref.getScreenPositionCalc(startTime);
          }

          let start_delay = ref.getScreenPositionCalc("00:30");
          return show_start_time - cinema_start + start_delay;
        }
      }
    },

    getScheduleChecker: function () {
      //TO DO Check this function
      let currentDate = "";
      let end_time = "";
      if (
        moment(
          moment().format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_start_time
        ).isSameOrAfter(
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          )
        )
      ) {
        if (
          moment(
            moment().format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_end_time
          ).isAfter(
            moment(
              moment().format("YYYY-MM-DD") +
                " " +
                moment(this.movieSelected.selected_time).format("HH:mm")
            )
          )
        ) {
          this.currentDate =
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");
          this.currentDate = moment(this.currentDate).valueOf();

          this.end_time = moment(
            moment(this.movieSelected.ss_start_date)
              .add(1, "days")
              .format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        } else {
          this.currentDate =
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm");

          this.currentDate = moment(this.currentDate).valueOf();

          this.end_time = moment(
            moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
              " " +
              moment(this.movieSelected.selected_time).format("HH:mm")
          )
            .add(parseInt(this.movieSelected.lengthMinutes), "m")
            .toDate();

          this.end_time = moment(this.end_time).valueOf();
        }
      } else {
        this.currentDate =
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
          " " +
          moment(this.movieSelected.selected_time).format("HH:mm");

        this.currentDate = moment(this.currentDate).valueOf();
        this.end_time = moment(
          moment(this.movieSelected.ss_start_date).format("YYYY-MM-DD") +
            " " +
            moment(this.movieSelected.selected_time).format("HH:mm")
        )
          .add(parseInt(this.movieSelected.lengthMinutes), "m")
          .toDate();

        this.end_time = moment(this.end_time).valueOf();
      }

      return new Promise((resolve, reject) => {
        let payload = {
          cinema_id: this.scheduleObject.cinema_id,
          start_date: moment(this.movieSelected.ss_start_date).format(
            "YYYY-MM-DD"
          ),
          end_date: moment(this.movieSelected.ss_end_date).format("YYYY-MM-DD"),
          groupbyssid: "Y",
        };
        scheduleService
          .GetCinemaSchedule(payload)
          .then((result) => {
            const { data } = result;
            if (data && data.status && data.Records.length > 0) {
              let newRecords = data.Records;
              let array = [];

              for (let index = 0; index < newRecords.length; index++) {
                const element = newRecords[index];
                if (
                  element.ss_id !=
                  this.movieSelected.scheduleShowPrice[0].schedule_show_id
                ) {
                  // let old_movie_start_date = moment(
                  //   element.ss_actual_start_date_time
                  // )
                  //   .tz(this.timeZone.tz_name)

                  //   .format("YYYY-MM-DD HH:mm:ss");
                  // let old_movie_end_date = moment(
                  //   element.ss_actual_end_date_time
                  // )
                  //   .tz(this.timeZone.tz_name)

                  //   .format("YYYY-MM-DD HH:mm:ss");
                  let old_movie_start_date = moment(
                    moment(element.ss_actual_start_date).format('YYYY-MM-DD') + ' ' + moment(element.ss_start_show_time, 'HH:mm').format('HH:mm')
                  ).format("YYYY-MM-DD HH:mm:ss");
                  let old_movie_end_date = moment(
                    moment(element.ss_actual_end_date).format('YYYY-MM-DD') + ' ' + moment(element.ss_end_show_time, 'HH:mm').format('HH:mm')
                  ).format("YYYY-MM-DD HH:mm:ss");
                  let new_movie_end_date = moment(this.end_time).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  let new_movie_start_date = moment(this.currentDate).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );

                  let valid = moment(old_movie_end_date).isBetween(
                    new_movie_start_date,
                    new_movie_end_date
                  );
                  let validSame =
                    moment(old_movie_end_date).isSame(new_movie_end_date);
                  let validSame1 =
                    moment(old_movie_start_date).isSame(new_movie_start_date);
                  let valid1 = moment(new_movie_end_date).isBetween(
                    old_movie_start_date,
                    old_movie_end_date
                  );
                  console.log("element :>> ", element);
                  console.log("new_movie_start_date :>> ", new_movie_start_date);
                  console.log("new_movie_end_date :>> ", new_movie_end_date);
                  console.log("old_movie_start_date :>> ", old_movie_start_date);
                  console.log("old_movie_end_date :>> ", old_movie_end_date);
                  console.log("valid :>> ", valid);
                  console.log("validSame :>> ", validSame);
                  console.log("validSame1 :>> ", validSame1);
                  console.log("valid1 :>> ", valid1);
                  console.log(
                    " this.selectedScreen.screen_id :>> ",
                    this.selectedScreen.screen_id
                  );
                  if (
                    element.screen_id == this.selectedScreen.screen_id &&
                    valid1
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.selectedScreen.screen_id &&
                    valid
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.selectedScreen.screen_id &&
                    validSame
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else if (
                    element.screen_id == this.selectedScreen.screen_id &&
                    validSame1
                  ) {
                    resolve({
                      status: false,
                      message:
                        "Movie overlapped, Please select different showtime",
                    });
                    break;
                  } else {
                    array.push(element.ss_start_show_time);
                    if (array.length === newRecords.length) {
                      resolve({ status: true });
                      break;
                    } else {
                      resolve({ status: true });
                    }
                  }
                } else {
                  resolve({ status: true });
                }
              }
            } else {
              resolve({ status: true });
            }
          })
          .catch((err) => {
            resolve({ status: false, message: "overlaps", error: err });
          });
      });
    },
    convertToHrs: function (value) {
      let hours = Math.floor(value / 60);
      let minutes = Math.floor(value % 60);
      return hours + "hrs " + minutes + " mins";
    },
    openShowDeletedMoviesModal: function () {
      this.$refs.showDeletedModal.show();
    },
    openShowPlannedMoviesModal: function () {
      this.$refs.showPlannedModal.show();
    },
    newGetScreenPositionCalc: function (hours, minutes) {
      hours = parseInt(hours.split(":")[0]);
      let hourCal = 0;
      let selected = 0;
      this.intervalsArray.map((intervalHour, index) => {
        if (
          parseInt(intervalHour.split(" ")[1].split(":")[0]) == hours &&
          selected == 0
        ) {
          hourCal = index;
          selected = 1;
        }
      });
      let totalMinutes = parseInt(hourCal * 60) + parseInt(minutes);
      let leftShift = parseInt(totalMinutes * 50) / 60;
      return leftShift;
    },

    getScreenPositionCalc: function (start_time) {
      let cinema_start_time = this.CinemasSettings.cine_operation_start_time;
      let cinema_ampm = cinema_start_time.split(" ")[1];
      let cinema_minutes = parseInt(cinema_start_time.split(":")[1]);
      let cinema_hours = parseInt(cinema_start_time.split(":")[0]);

      let start = 0;
      let cinema_start = 0;
      let hours = 0;
      let minutes = 0;
      let totalMinutes = 0;
      let ampm = start_time.split(" ")[1];
      minutes = parseInt(start_time.split(":")[1]);
      hours = parseInt(start_time.split(":")[0]);

      // NOT BEING USED AS ALWAYS 24 hours
      if (ampm == "PM" && hours === 12) {
        hours = hours;
      } else if (ampm == "PM") {
        hours = hours + 12;
      }
      // if(cinema_hours < hours){
      //   hours =
      // }

      //TO DO Discuss with yogesh on purpose
      // if (ampm == "AM" && hours === 12) {
      //   totalMinutes = minutes;
      //   // cinema_start = parseInt(totalMinutes * 30) / 10; original
      //   cinema_start = parseInt(totalMinutes * 50) / 60;
      //   return cinema_start;
      // } else {
      //   totalMinutes = parseInt(hours * 60) + minutes;
      //   // cinema_start = parseInt(totalMinutes * 30) / 10; original
      //   cinema_start = parseInt(totalMinutes * 50) / 60;
      //   return cinema_start;
      // }

      totalMinutes = parseInt(hours * 60) + minutes;
      // cinema_start = parseInt(totalMinutes * 30) / 10; original
      cinema_start = parseInt(totalMinutes * 50) / 60;

      // Calculate if on the other end, can reuse this function everywhere
      //use intervalsArray
      let hourCal = 0;
      this.intervalsArray.map((intervalHour, index) => {
        // console.log('intervalHour',intervalHour)
        if (parseInt(intervalHour.split(":")[0]) == hours) {
          hourCal = index;
        }
      });
      totalMinutes = parseInt(hourCal * 60) + minutes;
      cinema_start = parseInt(totalMinutes * 50) / 60;

      return cinema_start;
    },
    checkScheduleShowPriceValidation() {
      return new Promise((resolve, reject) => {
        let bool;
        let finalShows = this.selectedMoviesInScreens.filter((x) => {
          return x.movies.length > 0;
        });
        let finalArray = finalShows.filter((singleScreen) => {
          let array1 = singleScreen.movies.filter((singleMovie) => {
            let array = singleMovie.scheduleShowPrice.filter(
              (singleShowPrice) => {
                return (
                  singleShowPrice.rate_card_id == null &&
                  singleMovie.mycinema_booking_type_id !== 3
                );
              }
            );
            return array && array.length > 0;
          });
          return array1 && array1.length > 0;
        });
        return resolve({
          status: finalArray && finalArray.length > 0,
          finalNewArray: finalArray,
        });
      });
    },
    successSubmitSchedule: async function () {
      let self = this;
      this.FinalArray = [];
      let dates = getDates(
        moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"),
        moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD")
      );

      this.FinalScreenAndMovieScheduleList =
        this.selectedMoviesInScreens.filter((x) => {
          return x.movies.length > 0;
        });

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        var stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
      }

      let dateCount = 0;

      console.log(dates, self.FinalScreenAndMovieScheduleList);

      let finalpromises = self.FinalScreenAndMovieScheduleList.map(
        async (item, itemIndex) => {
          let MainObj = {};
          MainObj["screen_id"] = item.screen_id || null;
          MainObj["sch_is_active"] = self.scheduleObject.sch_is_active || "Y";
          MainObj["scheduleshow"] = [];

          let moviePromises = item.movies.map(async (movie, movieIndex) => {
            if (movie.mycinema_booking_type_id != 3) {
              console.log("mobvie", movie);
              // if (movie.isNewSchedule && movie.isNewSchedule == true) {
              MainObj["sch_start_date"] =
                moment(self.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) || null;
              MainObj["sch_end_date"] =
                moment(self.scheduleObject.sch_end_date).format("YYYY-MM-DD") ||
                null;

              let promises = dates.map(async (date, dateIndex) => {
                let MovieObj = {};
                MovieObj["isNewSchedule"] = movie.isNewSchedule;
                MovieObj["sch_artwork_url"] = movie.sch_artwork_url;
                MovieObj["show_schedule_id"] = movie.show_schedule_id;
                MovieObj["cinema_id"] = self.scheduleObject.cinema_id;
                MovieObj["screen_id"] = item.screen_id;
                MovieObj["movie_details_id"] = movie.movie_details_id;
                MovieObj["ss_comment"] = movie.ss_comment;
                MovieObj["version"] = movie.version;
                MovieObj["turnOffMultiSeatSelection"] =
                  movie.turnOffMultiSeatSelection;
                MovieObj["is_special_schedule"] = movie.is_special_schedule;
                MovieObj["sales_channel"] = movie.sales_channel
                  ? movie.sales_channel
                  : [];
                MovieObj["AddonsCharges"] = movie.AddonsCharges
                  ? movie.AddonsCharges
                  : [];
                MovieObj["sales_channel_changes"] = movie.sales_channel_changes
                  ? movie.sales_channel_changes
                  : [];
                // MovieObj["ss_show_status"] = this.getStatusId;
                MovieObj["ss_show_status"] = movie.ss_show_status;
                MovieObj["interval_time_in_mins"] =
                  movie.cine_interval_time_in_mins;
                MovieObj["cleaning_time_in_mins"] =
                  movie.cine_cleaning_time_in_mins;
                MovieObj["ads_time_in_mins"] =
                  movie.cine_setting_ads_time_in_mins;
                MovieObj["ss_start_show_time"] = movie.start_time;
                MovieObj["ss_end_show_time"] = movie.end_time;
                MovieObj["ss_start_date"] = moment(date).format("YYYY-MM-DD"); // movie.ss_start_date;

                MovieObj["ss_start_date_time"] = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    movie.start_time +
                    self.timeZone.tz_utc_offset
                );
                MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time;
                //actual date
                if (
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      self.CinemasSettings.cine_operation_start_time
                  ).isSameOrAfter(
                    moment(
                      moment().format("YYYY-MM-DD") +
                        " " +
                        self.CinemasSettings.cine_operation_end_time
                    )
                  )
                ) {
                  if (
                    moment(
                      moment().format("YYYY-MM-DD") +
                        " " +
                        self.CinemasSettings.cine_operation_end_time
                    ).isAfter(
                      moment(
                        moment().format("YYYY-MM-DD") + " " + movie.start_time
                      )
                    )
                  ) {
                    MovieObj["ss_actual_start_date"] = moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD");
                    MovieObj["ss_actual_start_date_time"] = +new Date(
                      moment(date).add(1, "days").format("YYYY-MM-DD") +
                        "T" +
                        movie.start_time +
                        self.timeZone.tz_utc_offset
                    );
                    MovieObj["ss_actual_end_date"] = moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD");
                    MovieObj["ss_actual_end_date_time"] = +new Date(
                      moment(date).add(1, "days").format("YYYY-MM-DD") +
                        "T" +
                        movie.end_time +
                        self.timeZone.tz_utc_offset
                    );
                    MovieObj["ss_end_date"] = moment(date)
                      .add(1, "days")
                      .format("YYYY-MM-DD");

                    MovieObj["ss_end_date_time"] = +new Date(
                      moment(date).add(1, "days").format("YYYY-MM-DD") +
                        "T" +
                        movie.end_time +
                        self.timeZone.tz_utc_offset
                    );
                  } else {
                    MovieObj["ss_actual_start_date"] =
                      moment(date).format("YYYY-MM-DD");
                    MovieObj["ss_actual_start_date_time"] = +new Date(
                      moment(date).format("YYYY-MM-DD") +
                        "T" +
                        movie.start_time +
                        self.timeZone.tz_utc_offset
                    );
                    MovieObj["ss_actual_end_date"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? moment(date).add(1, "days").format("YYYY-MM-DD")
                        : moment(date).format("YYYY-MM-DD");
                    MovieObj["ss_actual_end_date_time"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? +new Date(
                            moment(date).add(1, "days").format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          )
                        : +new Date(
                            moment(date).format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          );
                    MovieObj["ss_end_date"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? moment(date).add(1, "days").format("YYYY-MM-DD")
                        : moment(date).format("YYYY-MM-DD");

                    MovieObj["ss_end_date_time"] =
                      moment(movie.start_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "PM" &&
                      moment(movie.end_time, ["HH:mm"])
                        .format("h:mm A")
                        .split(" ")[1] == "AM"
                        ? +new Date(
                            moment(date).add(1, "days").format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          )
                        : +new Date(
                            moment(date).format("YYYY-MM-DD") +
                              "T" +
                              movie.end_time +
                              self.timeZone.tz_utc_offset
                          );
                  }
                } else {
                  MovieObj["ss_actual_end_date"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? moment(date).add(1, "days").format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");
                  MovieObj["ss_actual_start_date"] =
                    moment(date).format("YYYY-MM-DD");
                  MovieObj["ss_actual_end_date_time"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date).add(1, "days").format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        );
                  MovieObj["ss_actual_start_date_time"] = +new Date(
                    moment(date).format("YYYY-MM-DD") +
                      "T" +
                      movie.start_time +
                      self.timeZone.tz_utc_offset
                  );
                  MovieObj["ss_end_date"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? moment(date).add(1, "days").format("YYYY-MM-DD")
                      : moment(date).format("YYYY-MM-DD");

                  MovieObj["ss_end_date_time"] =
                    moment(movie.start_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "PM" &&
                    moment(movie.end_time, ["HH:mm"])
                      .format("h:mm A")
                      .split(" ")[1] == "AM"
                      ? +new Date(
                          moment(date).add(1, "days").format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        )
                      : +new Date(
                          moment(date).format("YYYY-MM-DD") +
                            "T" +
                            movie.end_time +
                            self.timeZone.tz_utc_offset
                        );
                }

                MovieObj["ss_start_date_time"] = +new Date(
                  moment(date).format("YYYY-MM-DD") +
                    "T" +
                    movie.start_time +
                    self.timeZone.tz_utc_offset
                );
                MovieObj["ss_is_active"] = movie.ss_is_active || "Y"; // movie.ss_end_date_time
                MovieObj["scheduleshowprice"] = [];
                let scheduleShowPricePromises = movie.scheduleShowPrice.map(
                  (price, priceIndex) => {
                    let PriceObj = {};

                    dateCount = PriceObj["cinema_id"] =
                      this.scheduleObject.cinema_id;
                    PriceObj["screen_id"] = item.screen_id;
                    PriceObj["md_id"] = movie.movie_details_id;
                    PriceObj["rate_card_id"] = price.rate_card_id;
                    PriceObj["rate_card_group_id"] = price.rate_card_group_id;
                    PriceObj["screen_seat_type_id"] = price.screen_seat_type_id;
                    PriceObj["p_start_date_time"] = date; // price.p_start_date_time;
                    PriceObj["p_end_date_time"] = date; // price.p_end_date_time;
                    PriceObj["p_is_active"] = price.p_is_active || "Y";

                    // Push Show Price
                    MovieObj["scheduleshowprice"].push(PriceObj);
                  }
                );
                await Promise.all(scheduleShowPricePromises);

                // Push Show and Show Price
                MainObj["scheduleshow"].push(MovieObj);
              });
              await Promise.all(promises);
              // }
            }
          });
          await Promise.all(moviePromises);
          // Final Array Push
          this.FinalArray.push(MainObj);
        }
      );

      function format24Hours(date, time) {
        let newVal = date + " " + time;
        let finalVal = moment(newVal).format("HH:mm");
        return finalVal;
      }

      this.btenable = true;
      await Promise.all(finalpromises)
        .then((result) => {
          let loader = this.$loading.show();
          // console.log(this.FinalArray, "fsdfdsfsdfsd");
          // return;
          return scheduleService
            .AddMultiScheduleDD({
              AllSchedules: this.FinalArray,
              cinema_id: self.scheduleObject.cinema_id,
            })
            .then((resp) => {
              this.btenable = false;
              this.isChanged = false;
              loader.hide();
              const { data } = resp;
              if (data && data.status) {
                this.$toasted.show(data.message);
              } else {
                if (data.error && data.error.message) {
                  this.$toasted.show(data.error.message);
                } else {
                  this.$toasted.show(data.message);
                }
              }
            })
            .catch((err) => {
              this.disableBtns["updateMovieBtn"] = false;
              this.$toasted.show(err);
            })
            .finally(() => {
              this.disableBtns["updateMovieBtn"] = false;
            });

          // this.FinalArray.map((x) => {
          //   scheduleService
          //     .AddSchedule(x)
          //     .then((resp) => {
          //       this.btenable = false;
          //       loader.hide();
          //       const { data } = resp;
          //       if (data && data.status) {
          //         this.$toasted.show(data.message);
          //       } else {
          //         if (data.error && data.error.message) {
          //           this.$toasted.show(data.error.message);
          //         } else {
          //           this.$toasted.show(data.message);
          //         }
          //       }
          //     })
          //     .catch((err) => {
          //       this.$toasted.show(err);
          //     });
          // });
        })
        .catch((err) => {
          loader.hide();
          this.disableBtns["updateMovieBtn"] = false;
          this.$toasted.show(err);
        })
        .finally(() => {
          this.disableBtns["updateMovieBtn"] = false;
          this.getSchedule(this.getStatusId);
          this.$forceUpdate();
        });
    },
    validateAutoSaveDrag() {
      let count = 0;
      this.selectedMoviesInScreens.map((x) => {
        if (x.movies.length > 0) {
          x.movies.map((y) => {
            y.scheduleShowPrice.map((z) => {
              if (z.rate_card_id == null) {
                this.autoSaveObj.rateCardissueMovie = y.movie_title;
                this.autoSaveObj.rateCardissueScreen = x.screen_name;
                this.autoSaveObj.rateCardissueShow = y.start_time;
                this.autoSaveObj.rateCardWarningData = `Please attach Rate Card for ${y.movie_title} on ${x.screen_name} at ${y.start_time}`;
                count++;
              }
            });
          });
        }
      });

      if (count > 0) {
        // this.$toasted.show(this.autoSave.rateCardWarningData);
        return false;
      } else {
        return true;
      }
    },
    checkNoRateCard(movieObj) {
      let count = 0;
      if (
        movieObj.hasOwnProperty("scheduleShowPrice") &&
        movieObj.mycinema_booking_type_id !== 3
      ) {
        movieObj.scheduleShowPrice.map((x) => {
          if (x.rate_card_id == null) {
            count++;
          }
        });
      }

      if (count > 0) {
        this.$root.$emit(
          "bv::show::popover",
          `Popover-${movieObj.start_time}${movieObj.screen}`
        );
        console.log("Returning False for CheckRateCard");
        return false;
      } else {
        this.$root.$emit(
          "bv::hide::popover",
          `Popover-${movieObj.start_time}${movieObj.screen}`
        );
        return true;
      }
    },
    submitSchedule: async function () {
      if (
        !this.scheduleObject.sch_start_date &&
        !this.scheduleObject.sch_end_date
      ) {
        this.$toasted.show("Please Select Start & End Date");
        return;
      }
      this.checkScheduleShowPriceValidation().then((result) => {
        let arrayNew = [];
        if (result && result.status) {
          console.log(result.finalNewArray);
          let error = result.finalNewArray[0];

          result.finalNewArray[0].movies.map((newMovies) => {
            let filterNew = newMovies.scheduleShowPrice.filter((x) => {
              return x.rate_card_id == null || x.rate_card_id == "";
            });
            if (filterNew.length > 0) {
              arrayNew.push(newMovies);
            }
          });
          this.$toasted.show(
            `Please attach Rate Card for screen ${error.screen_name}  and movie ${arrayNew[0].movie_title} for show ${arrayNew[0].start_time}`
          );
        } else {
          this.successSubmitSchedule();
        }
      });
    },
    submitScheduleAndGoBack() {
      this.submitSchedule();
      this.$router.go(-1);
    },
    getDateTime(date, time) {
      return moment(new Date(date)).format("DD-MM-YYYY");
    },
    // Cinema List
    getAllActiveCinemas: function () {
      scheduleService
        .GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
        });
    },

    getCinemaSetting: function (cinema_id) {
      //TODO Relook at cinema settings function here
      scheduleService
        .GetCinemaSetting({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasSettings = {
              ...this.CinemasSettings,
              ...data.Records[0],
            };
            this.timeZone = {
              ...this.timeZone,
              ...data.timeZone,
            };

            let startString = "";
            if (
              this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                "AM" ||
              this.CinemasSettings.cine_operation_start_time.split(" ")[1] ==
                "PM"
            ) {
              startString = moment(
                moment(this.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).format("YYYY-MM-DD h:mm A");
            } else {
              startString = moment(
                moment(this.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).format("YYYY-MM-DD H:mm");
            }

            let endString = "";
            if (
              this.CinemasSettings.cine_operation_end_time.split(" ")[1] ==
                "AM" ||
              this.CinemasSettings.cine_operation_end_time.split(" ")[1] == "PM"
            ) {
              endString = moment(
                moment(this.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              ).format("YYYY-MM-DD h:mm A");
            } else if (
              moment(
                moment(this.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) +
                  " " +
                  this.CinemasSettings.cine_operation_start_time
              ).isSameOrAfter(
                moment(
                  moment(this.scheduleObject.sch_start_date).format(
                    "YYYY-MM-DD"
                  ) +
                    " " +
                    this.CinemasSettings.cine_operation_end_time
                )
              )
            ) {
              endString = moment(
                moment(this.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              )
                .add(1, "d")
                .format("YYYY-MM-DD H:mm");
            } else if (
              this.CinemasSettings.cine_operation_end_time.split(":")[0] < 12
            ) {
              endString = moment(
                moment(this.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              )
                .add(1, "d")
                .format("YYYY-MM-DD H:mm");
            } else {
              endString = moment(
                moment(this.scheduleObject.sch_start_date).format(
                  "YYYY-MM-DD"
                ) +
                  " " +
                  this.CinemasSettings.cine_operation_end_time
              ).format("YYYY-MM-DD H:mm");
            }

            // let endString = moment(
            //   moment().format("YYYY-MM-DD") +
            //     " " +
            //     this.CinemasSettings.cine_operation_end_time
            // ).format("YYYY-MM-DD h:mm A");
            console.log(
              "this.scheduleObject.sch_start_date checkDATE",
              this.scheduleObject.sch_start_date
            );
            this.intervalsArray = intervals(startString, endString);

            function intervals(startString, endString) {
              console.log("startString ###", startString);
              console.log("endString ###", endString);

              var start = moment(startString, "YYYY-MM-DD hh:mm a");
              var end = moment(endString, "YYYY-MM-DD hh:mm a");

              // round starting minutes up to nearest 15 (12 --> 15, 17 --> 30)
              // note that 59 will round up to 60, and moment.js handles that correctly
              start.minutes(Math.ceil(start.minutes() / 15) * 15);

              var result = [];

              var current = moment(start);
              end = moment(end);
              end.add(4 * 60, "minutes");
              while (current <= end) {
                // let time = current.format("HH:mm");
                // if (time == "24:00"){

                // }
                result.push(current.format("YYYY-MM-DD HH:mm"));
                current.add(60, "minutes");
              }

              return result;
            }
            this.changeTab("Recent");
            // this.getAllActiveMovies();
          } else {
            // Show Message Here:
          }
        })
        .catch((error) => {
          // Catch Error:
        });
    },
    onSearchRateCard: function (RatecardIndex) {
      if (
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ].scheduleShowPrice[RatecardIndex]["searchRateCard"].length > 0
      ) {
        this.RatecardsList = this.RatecardsListCopy.filter((x) => {
          if (
            x.rc_g_name
              .toLowerCase()
              .includes(
                this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
                  this.selectedMovieIndex
                ].scheduleShowPrice[RatecardIndex][
                  "searchRateCard"
                ].toLowerCase()
              )
          )
            return x;
        });
      } else {
        this.RatecardsList = this.RatecardsListCopy;
      }
    },
    //
    getRatecardsList: function (cinema_id) {
      scheduleService
        .GetRatecardGroupByCinemaId({ cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.RatecardsList = data.Records;
            this.RatecardsListCopy = data.Records;
            // this.getSchedule();
          } else {
            // Show Message Here:
          }
        })
        .catch((error) => {
          // Catch Error:
        });
    },
    changeTab: function (name) {
      this.tab = name;
      this.getAllActiveMovies();
    },
    onSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllActiveMovies();
      }, 1500);
    },
    searchScreenFilter() {
      let loader = this.$loading.show();
      let search = String(this.searchScreen).toLowerCase();

      console.log({ "this.searchScreen": this.searchScreen });

      if (search) {
        this.ScreenList.forEach((s) => {
          s.view = String(s.screen_name || "")
            .toLowerCase()
            .includes(search);
        });
      } else {
        this.ScreenList.forEach((s) => {
          s.view = true;
        });
      }
      loader.hide();
      this.$forceUpdate();
    },
    onSearchScreen() {
      clearTimeout(this.screenSearchDebounce);
      this.screenSearchDebounce = setTimeout(() => {
        this.searchScreenFilter();
      }, 200);
    },
    getAllActiveMovies: function () {
      let loader = this.$loading.show();
      let cinema_id = this.scheduleObject.cinema_id;
      scheduleService
        .GetMoviesDD({
          title: this.filmTitle,
          tab: this.tab,
          cinema_id,
          currentPage: this.movieListObj.currentPage || 1,
          limit: this.movieListObj.perPage || 50,
        })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            if (data.totalRows >= 10) {
              this.movieListObj.rows = data.totalRows;
            } else {
              this.movieListObj.rows = data.totalRows;
            }
            this.MoviesList = data.MovieListResult.map((movie, movieIndex) => {
              movie.lengthMinutes =
                movie.mrrdr_runtime +
                parseInt(this.CinemasSettings.cine_cleaning_time_in_mins) +
                parseInt(this.CinemasSettings.cine_setting_ads_time_in_mins) +
                parseInt(this.CinemasSettings.cine_interval_time_in_mins);
              movie.length = (movie.lengthMinutes * 50) / 60;
              movie.selected = false;
              movie.cine_cleaning_time_in_mins = parseInt(
                this.CinemasSettings.cine_cleaning_time_in_mins
              );
              movie.cine_setting_ads_time_in_mins = parseInt(
                this.CinemasSettings.cine_setting_ads_time_in_mins
              );
              movie.cine_interval_time_in_mins = parseInt(
                this.CinemasSettings.cine_interval_time_in_mins
              );
              movie.isNewSchedule = true;
              movie.movie_details_id = movie.md_id;
              movie.md_sales_channel = _.cloneDeep(movie.md_sales_channel);
              movie.rateCard = [];
              movie.scheduleShowPrice = [];
              return movie;
            });
            console.log(
              "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2947 ~ this.MoviesList=data.MovieListResult.map ~ this.CinemasSettings",
              this.CinemasSettings
            );
            console.log(
              "🚀 ~ file: ViewScheduleDD-1.vue ~ line 2953 ~ this.MoviesList=data.MovieListResult.map ~  this.MoviesList",
              this.MoviesList
            );
            this.showScheduleCard = true;
            // this.lists.movies = movieList;
          } else {
            this.MoviesList = [];
            // Show Message Here:
            // console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    getAllActiveScreens: function (cinema_id) {
      // scheduleService.GetScreens()
      //   .then(response => {
      //     const { data } = response;
      //     if (data && data.status && data.Records.length > 0) {
      //       // this.lists.screens = data.Records;
      //       this.ScreenList = data.Records.filter(
      //         x => x.screen_seat_types.length > 0
      //       );
      //       this.ScreenList.map(x => {
      //         this.selectedMoviesInScreens.push({
      //           ...x,
      //           movies: []
      //         });
      //       });
      //     } else {
      //       // Show Message Here:
      //       console.log("data.message :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     // Catch Error:
      //     this.$toasted.show(Error(error));
      //     console.log("Catch Error on getAllActiveScreens :", error);
      //   });
      this.ScreenList = [];
      let payload = {
        cinema_id: cinema_id,
      };
      this.selectedMoviesInScreens = [];

      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.lists.screens = data.Records;
            this.ScreenList = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            let arrayNew = [];
            let haveNotScreen = [];
            let haveSeatArrayScreen = [];
            this.ScreenList.map((x) => {
              if (x.totalSeatLayout > 0) {
                haveSeatArrayScreen.push(x);
                this.selectedMoviesInScreens.push({
                  ...x,
                  movies: [],
                });
              } else {
                haveNotScreen.push(x);
                arrayNew.push({
                  ...x,
                  movies: [],
                });
              }
            });
            this.ScreenList = [...haveSeatArrayScreen, ...haveNotScreen];
            this.ScreenList.forEach((s) => {
              s.view = true;
            });
            this.selectedMoviesInScreens = [
              ...this.selectedMoviesInScreens,
              ...arrayNew,
            ];

            console.log(this.selectedMoviesInScreens);
            this.getSchedule(this.getStatusId);
          } else {
            // Show Message Here:
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
        });
    },
    getSeatTypesListByScreenId: function (screen_id) {
      scheduleService
        .GetSeatTypesByScreenId({ screen_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
          } else {
            // Show Message Here:
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
        });
    },
    onEditStartTime: function (event) {
      this.movieSelected["selected_time"] = event;
      this.$forceUpdate();
    },
    onChangeTimePicker: function (date) {
      date = new Date(date);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return strTime;
    },
    onOpenAddPriceModal: function (
      screen,
      screenMovie,
      screenIndex,
      screenMovieIndex
    ) {
      this.movieSelected = screenMovie;
      this.selectedScreenSeatTypes = screen.screen_seat_types;
      this.selectedMovieIndex = screenMovieIndex;
      this.selectedScreenIndex = screenIndex;
      this.$refs.ratecardmodal.show();
    },
    onDeleteMovie: function (
      screen,
      screenMovie,
      screenIndex,
      screenMovieIndex
    ) {
      let movie_name_format = `${screenMovie.movie_title} ${screenMovie.mf_name} (${screenMovie.lang_name})`;
      this.isChanged = true;
      this.deleteSubmit = true;
      this.$validator
        .validate()
        .then((valid) => {
          if (valid) {
            this.selectedMoviesInScreens[screenIndex].movies[
              screenMovieIndex
            ].ss_show_status = 17;
            this.selectedMoviesInScreens[screenIndex].movies.splice(
              screenMovieIndex,
              1
            );
            let ss_id = [];
            ss_id = screenMovie.scheduleShowPrice.map((x) => {
              return x.schedule_show_id;
            });

            if (ss_id.length == 0) {
              ss_id.push(screenMovie.ss_id);
            }

            if (ss_id && ss_id.length > 0) {
              let payload = {
                cinema_id: this.scheduleObject.cinema_id,
                ss_id: ss_id[0],
                delete_reason: screenMovie.delete_reason,
                movie_name_format: movie_name_format,
                ss_actual_start_date_time:
                  screenMovie.ss_actual_start_date_time,
                ss_start_date: screenMovie.ss_start_date,
              };
              scheduleService
                .UpdateShowStatus(payload)
                .then((response) => {
                  const { data } = response;
                  if (data && data.status) {
                    this.isChanged = false;
                    this.$toasted.show(data.message);
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch((err) => {
                  this.$toasted.show(err);
                })
                .finally(() => {
                  this.$refs.deleteMovieModal.hide();
                });
            }
          } else {
            console.log("ERROR VALID", valid);
          }
        })
        .catch(this._CatchError);
    },
    onClickupdateRateCard: function () {
      if (
        (this.selectedRateCardObject &&
          Object.keys(this.selectedRateCardObject).length == 0) ||
        String(this.selectedRateCardObject.SeatTypeIndex).length == 0
      ) {
        this.$toasted.show("Please Select Rate Card Group");
        return;
      }
      console.log(
        this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
          this.selectedMovieIndex
        ]
      );

      let payload = {
        show_schedule_id:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].show_schedule_id,
        scheduleshowprice:
          this.selectedMoviesInScreens[this.selectedScreenIndex].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice,
      };
      console.log("payload :>> ", payload);
      scheduleService
        .UpdateCinemaScheduleByPrice(payload)
        .then((result) => {
          const { data } = result;
          if (data.status) {
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(this._CatchError);
        });
      this.searchRateCard = "";
    },

    onSelectCinemaFromMultiSelect: async function (event) {
      this.selected.cinema = event.cine_name;
      this.cinemasSelected = event;
      this.selectedDuplicateCinema = event.cine_name;
      this.scheduleObject.cinema_id = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
      this.$router.replace({
        query: {
          ...this.$route.query,
          cinema_id: event.cine_id,
        },
      });
      console.log("COMING HERE AFTER onSelectCinemaFromMultiSelect");

      await Promise.all([
        this.getAllActiveScreens(event.cine_id),
        this.getPosAggregatorUsers(event.cine_id),
        this.getCinemaSetting(event.cine_id),
        this.getRatecardsList(event.cine_id),
        this.getAllAddonsCharges(),
      ]);
      this.isMovieCardSelected = false;
    },
    onSelectCinema: function (event, cinema) {
      this.selected.cinema = cinema.cine_name;
      this.selectedDuplicateCinema = cinema.cine_name;

      this.scheduleObject.cinema_id = cinema.cine_id;
      this.getAllActiveScreens(cinema.cine_id);
      this.getCinemaSetting(cinema.cine_id);
      this.getRatecardsList(cinema.cine_id);
    },

    //

    selectCinema: function (cinema) {
      this.lists.cinemas.selectedCinema = cinema;
    },
    doSomethingInParentComponentFunction: function () {
      setTimeout(() => {
        this.getSchedule(this.getStatusId);
        if (this.scheduleObject.cinema_id) {
          this.getCinemaSetting(this.scheduleObject.cinema_id);
        }
      }, 500);
      // debounce(() => {
      //   if (this.scheduleObject.cinema_id) {
      //     this.getAllActiveScreens(this.scheduleObject.cinema_id);
      //     this.getCinemaSetting(this.scheduleObject.cinema_id);
      //     this.getRatecardsList(this.scheduleObject.cinema_id);
      //   }
      //   // this.startTour("myScheduleDragAndDropTour3");
      // }, 1000);
    },
    changeCinema: function (params) {
      this.initialSelectedScreen = params;
    },
    startDrag: function (screen, movie) {
      console.log(screen, ":fdsfds");
      // console.log(this.selectedMoviesInScreens[screen].movies[movie]);
      this.dropLocationClone = this.dropLocation;
      this.draggedObject.screen = screen;
      this.draggedObject.movie = movie;
      this.draggedObject.oldStart =
        this.selectedMoviesInScreens[screen].movies[movie].start;
      this.draggedObject.length =
        this.selectedMoviesInScreens[screen].movies[movie].length;
      this.draggedObject.md_thumbnail_url =
        this.selectedMoviesInScreens[screen].movies[movie].md_thumbnail_url;
      // md_thumbnail_url: y.md_thumbnail_url,
      this.draggedObject.lengthMinutes =
        this.selectedMoviesInScreens[screen].movies[movie].lengthMinutes;
      this.selectedMovieIndex = movie;

      //check if the drop is overlapping with something else
      //if no overlap,delete old object, else
      //add object to new place
      // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 0;
    },
    endDrag: function (data) {
      // this.selectedMoviesInScreens[screen].movies[movie].zIndex = 99;
    },

    checkOverLapMovie: function (movie, screen) {
      let overlap = {
        status: false,
        screen: screen,
        movie: {},
      };
      if (screen != null || screen != -1) {
        console.log("screen111", screen);
        this.selectedMoviesInScreens[screen].movies.map((otherMovie, index) => {
          console.log(otherMovie);
          if (otherMovie.isNewSchedule) {
            console.log("screen111222", otherMovie);

            let scheduleShowPriceObj = {
              rate_card_id: null,
              schedule_show_id: null,
              screen_seat_type_id: null,
              sst_seat_type: "",
              p_start_date_time: null,
              p_end_date_time: null,
              p_is_active: "Y",
            };

            otherMovie[0] = { scheduleShowPrice: scheduleShowPriceObj };
          }

          let startCheck = this.newGetScreenPositionCalc(
            this.dropLocation.hour,
            this.dropLocation.minute
          );
          // let startCheck =
          //   (this.dropLocation.hour - 1) * 180 +
          //   (this.dropLocation.minute - 1) * 30;
          if (
            movie.start < otherMovie.start &&
            !(movie.start + movie.length < otherMovie.start)
          ) {
            console.log("overlap new movie2");
            // this.$toasted.show("Movie Overlapped 1");
            overlap.status = true;
            overlap.movie = otherMovie;
          }

          if (
            movie.start > otherMovie.start &&
            movie.start < otherMovie.start + otherMovie.length &&
            movie.start != otherMovie.start + otherMovie.length
          ) {
            // this.$toasted.show("Movie Overlapped 2");
            console.log("overlap new movie1");
            overlap.status = true;
            overlap.movie = otherMovie;
          }
          // if (otherMovie.movie_details_id == data.movie.md_id) {
          //   let scheduleShowPriceObj = {
          //     rate_card_id: 1,
          //     schedule_show_id: "1",
          //     screen_seat_type_id: "18",
          //     p_start_date_time: 1,
          //     p_end_date_time: 1,
          //     p_is_active: "Y"
          //   };
          //   otherMovie.push({ scheduleShowPrice: scheduleShowPriceObj });
          // }
        });

        // if (
        //     this.draggedObject.newStart < otherMovie.start &&
        //     !(
        //       this.draggedObject.newStart + draggedMovie.length <
        //       otherMovie.start
        //     )
        //   ){

        //   }
        return overlap;
      } else {
        return overlap;
      }
      return overlap;
    },
    endTimeCalcutor: function (startTime, minutes) {
      let hoursMain = startTime.split(":")[0];
      let minutesMain = startTime.split(":")[1];
      let hMinutes = Math.floor(minutes / 60);
      hoursMain = parseInt(hoursMain) + parseInt(hMinutes);
      minutesMain = parseInt(minutes % 60) + parseInt(minutesMain);
      if (minutesMain >= 60) {
        minutesMain = minutesMain - 60;
        hoursMain++;
      }
      if (minutesMain < 10) {
        minutesMain = "0" + minutesMain.toString();
      }
      if (hoursMain > 23) {
        hoursMain = hoursMain - 24;
      }
      if (hoursMain < 10) {
        hoursMain = "0" + hoursMain.toString();
      }
      return `${hoursMain}:${minutesMain}`;
    },
    createMovie: function (movie, screen) {
      console.log("🚀 ~ file: ViewScheduleDD-1.vue ~ line 3339 ~ movie", movie);
      if (screen != -1) {
        this.selectedScreenIndex = screen;

        this.selectedScreenSeatTypes =
          this.selectedMoviesInScreens[
            this.dropLocation.screen
          ].screen_seat_types;
        let seat_type_length = this.selectedScreenSeatTypes.length;
        let obj = undefined;

        let scheduleShowPriceObj = {
          rate_card_id: null,
          schedule_show_id: null,
          screen_seat_type_id: null,
          sst_seat_type: "",
          p_start_date_time: null,
          p_end_date_time: null,
          p_is_active: "Y",
          rc_name: "",
          searchRateCard: "",
          defaultRateCard: true,
          selectedRateCard: "",
        };

        let scheduleShowPriceArray = [];
        // for (var i = 0; i < seat_type_length; i++) {
        //   scheduleShowPriceArray.push(_.cloneDeep(scheduleShowPriceObj));
        // }

        this.selectedScreenSeatTypes.forEach((x) => {
          scheduleShowPriceObj.sst_seat_type = x.sst_seat_type;
          scheduleShowPriceObj.screen_seat_type_id = x.sst_id;
          scheduleShowPriceArray.push(_.cloneDeep(scheduleShowPriceObj));
        });

        let MovieNewObj = {
          length: movie.length,
          lengthMinutes: movie.lengthMinutes,
          mrrdr_runtime: movie.mrrdr_runtime,
          movie_id: movie.movie_id,
          lang_iso_2: movie.lang_iso_2,
          sub_lang_1_iso_2: movie.sub_lang_1_iso_2,
          sub_lang_2_iso_2: movie.sub_lang_2_iso_2,
          sub_lang_1_iso_3: movie.sub_lang_1_iso_3,
          sub_lang_2_iso_3: movie.sub_lang_2_iso_3,
          movie_details_id: movie.md_id || movie.movie_details_id,
          md_id: movie.md_id || movie.movie_details_id,
          start: movie.start,
          end_time: this.endTimeCalcutor(
            this.dropLocation.time,
            movie.lengthMinutes
          ),
          ss_end_show_time: this.endTimeCalcutor(
            this.dropLocation.time,
            movie.lengthMinutes
          ),
          ads_time_in_mins: this.CinemasSettings.cine_setting_ads_time_in_mins,
          cleaning_time_in_mins:
            this.CinemasSettings.cine_cleaning_time_in_mins,
          interval_time_in_mins:
            this.CinemasSettings.cine_interval_time_in_mins,
          screen: this.dropLocation.screen,
          cine_cleaning_time_in_mins:
            this.CinemasSettings.cine_cleaning_time_in_mins,
          cine_setting_ads_time_in_mins:
            this.CinemasSettings.cine_setting_ads_time_in_mins,
          cine_interval_time_in_mins:
            this.CinemasSettings.cine_interval_time_in_mins,
          // start: this.getScreenPositionCalc(this.dropLocation.hour),
          // start:
          //   (this.dropLocation.hour - 1) * 180 +
          //   (this.dropLocation.minute - 1) * 30,
          zIndex: 99,
          mf_name: movie.mf_name,
          mf_id: movie.mf_id,
          sound_format_name: movie.sound_format_name,
          sound_format_id: movie.sound_format_id,
          movie_resolution_id: movie.movie_resolution_id || movie.resolution_id,
          aspect_ratio_id: movie.aspect_ratio_id,
          is_foreign_movie: movie.is_foreign_movie || "N",
          movie_experience_id: movie.movie_experience_id,
          md_thumbnail_url: movie.md_thumbnail_url,
          lang_name: movie.lang_name,
          movie_title: movie.movie_title,
          movie_name: movie.movie_name || movie.movie,
          movie: movie.movie_name || movie.movie,
          old_start_time: this.dropLocation.time,
          startTime2: this.dropLocation.time,
          old_end_time: this.endTimeCalcutor(
            this.dropLocation.time,
            movie.lengthMinutes
          ),
          old_start: movie.start,
          start_time: this.dropLocation.time,
          isNewSchedule: movie.isNewSchedule == false ? false : true,
          show_schedule_id: movie.show_schedule_id || null,
          scheduleShowPrice: scheduleShowPriceArray,
          sch_artwork_url: "",
          sales_channel:
            movie.sales_channel || _.cloneDeep(this.aggregatorUsersList),
          sales_channel_changes: movie.sales_channel_changes || [],
          AddonsCharges: [],
          all_sales_channel_length: this.aggregatorUsersList.length,
          ss_show_status: 16,
          selectedShowStatus: "",
          mycinema_booking_type_id: movie.mycinema_booking_type_id,
        };

        console.log("OUTSIDE Addon check 8645", movie);

        if (
          movie.hasOwnProperty("isNewSchedule") &&
          movie.isNewSchedule &&
          movie.hasOwnProperty("md_sales_channel") &&
          movie.md_sales_channel
        ) {
          MovieNewObj.sales_channel = [];
          this.aggregatorUsersList.map((u) => {
            if (!movie.md_sales_channel.some((el) => el.user_id == u.user_id)) {
              let obj = {
                ...u,
                is_changed: true,
                value: "N",
                ss_id: undefined,
                md_id: undefined,
              };
              MovieNewObj.sales_channel_changes.push(obj);
            } else {
              MovieNewObj.sales_channel.push(u);
            }
          });
        }

        if (movie.hasOwnProperty("isNewSchedule") && !movie.isNewSchedule) {
          MovieNewObj.movie = movie.movie;
          MovieNewObj.screen_total_seats = movie.screen_total_seats || 0;
          MovieNewObj.unpaid_count = movie.unpaid_count || 0;
          MovieNewObj.booked_seats = movie.booked_seats || 0;
          MovieNewObj.sales_channel =
            movie.sales_channel || _.cloneDeep(this.aggregatorUsersList);
          MovieNewObj.sales_channel_changes = movie.sales_channel_changes || [];
          MovieNewObj.all_sales_channel_length =
            movie.all_sales_channel_length || this.aggregatorUsersList.length;
          MovieNewObj.AddonsCharges = movie.AddonsCharges || [];
        } else {
          if (movie.mf_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 1 &&
                z.main_id == movie.mf_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            console.log("tempArray TEST 223435 mf_id", tempArray);
            MovieNewObj["AddonsCharges"].push(...tempArray);
          }
          if (movie.movie_experience_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 2 &&
                z.main_id == movie.movie_experience_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            console.log("tempArray TEST 223435 movie_experience_id", tempArray);
            MovieNewObj["AddonsCharges"].push(...tempArray);
          }
          if (movie.sound_format_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 3 &&
                z.main_id == movie.sound_format_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            console.log("tempArray TEST 223435 sound_format_id", tempArray);
            MovieNewObj["AddonsCharges"].push(...tempArray);
          }
          if (movie.movie_resolution_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 4 &&
                z.main_id == movie.movie_resolution_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            console.log("tempArray TEST 223435 movie_resolution_id", tempArray);
            MovieNewObj["AddonsCharges"].push(...tempArray);
          }
          if (movie.aspect_ratio_id) {
            let tempArray = [];
            tempArray = this.AddonChargesArray.filter(
              (z) =>
                z.type_id == 5 &&
                z.main_id == movie.aspect_ratio_id &&
                z.add_ons_price > 0 &&
                z.is_compulsory_add_ons == "Y"
            );
            console.log("tempArray TEST 223435 aspect_ratio_id", tempArray);
            MovieNewObj["AddonsCharges"].push(...tempArray);
          }
          let tempArray = [];
          tempArray = this.AddonChargesArray.filter(
            (z) =>
              z.type_id == 0 &&
              z.add_ons_price > 0 &&
              z.is_compulsory_add_ons == "Y"
          );
          console.log("tempArray TEST 223435", tempArray);
          MovieNewObj["AddonsCharges"].push(...tempArray);
        }

        console.log(
          "MovieNewObj['AddonsCharges'] TEST",
          MovieNewObj["AddonsCharges"]
        );

        if (this.DefaultScheduleTypeonDrop) {
          MovieNewObj.ss_show_status = parseInt(this.DefaultScheduleTypeonDrop);
        }

        let selectedShowStatus = this.scheduleStatusArray.find(
          (x) => MovieNewObj.ss_show_status == x.status_id
        );
        if (selectedShowStatus) {
          MovieNewObj.selectedShowStatus = selectedShowStatus;
        }

        this.selectedMoviesInScreens[screen].movies.push(MovieNewObj);

        console.log(
          "this.selectedMoviesInScreens[screen].movies after latest push =>>>>",
          _.cloneDeep(this.selectedMoviesInScreens[screen].movies)
        );

        console.log("this.selectedMovieIndex", this.selectedMovieIndex);

        let movies_length_for_this_screen =
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.length;

        if (
          this.selectedMovieIndex != null &&
          this.dropLocation.screen == this.selectedScreenIndex &&
          this.selectedMoviesInScreens[this.dropLocation.screen].movies.length >
            0 &&
          this.selectedMoviesInScreens[this.dropLocation.screen].movies[
            this.selectedMovieIndex
          ] &&
          this.selectedMoviesInScreens[this.dropLocation.screen].movies[
            this.selectedMovieIndex
          ].hasOwnProperty("scheduleShowPrice") &&
          this.selectedMoviesInScreens[this.dropLocation.screen].movies[
            this.selectedMovieIndex
          ].scheduleShowPrice.length > 0
        ) {
          let prev_obj =
            this.selectedMoviesInScreens[this.dropLocation.screen].movies[
              this.selectedMovieIndex
            ];
          obj = prev_obj.scheduleShowPrice;

          let prev_show_status = prev_obj.ss_show_status;

          this.selectedMoviesInScreens[this.dropLocation.screen].movies[
            movies_length_for_this_screen - 1
          ] = {
            ...this.selectedMoviesInScreens[this.dropLocation.screen].movies[
              movies_length_for_this_screen - 1
            ],
            scheduleShowPrice: _.cloneDeep(obj),
            isReady:
              this.selectedMoviesInScreens[this.dropLocation.screen].movies[
                this.selectedMovieIndex
              ].isReady,
            ss_show_status: prev_show_status,
          };
        }

        this.selectedMovieIndex = movies_length_for_this_screen - 1;

        // this.selectedMoviesInScreens[this.dropLocation.screen].movies.map(
        //   (x, index) => {
        //     if (x.isNewSchedule) {
        //       this.selectedMovieIndex = index;
        //       let scheduleShowPriceObj = {
        //         rate_card_id: null,
        //         schedule_show_id: null,
        //         screen_seat_type_id: null,
        //         p_start_date_time: null,
        //         p_end_date_time: null,
        //         p_is_active: "Y",
        //         rc_name: "",
        //         searchRateCard: ""
        //       };
        //       let scheduleShowPriceArray = [];
        //       for (var i = 0; i < seat_type_length; i++) {
        //         scheduleShowPriceArray.push(scheduleShowPriceObj);
        //       }
        //       Object.assign(x, {
        //         scheduleShowPrice: obj ? [...obj] : scheduleShowPriceArray
        //       });
        //     }
        //     //  x = { ...x,{scheduleShowPrice: scheduleShowPriceObj} };
        //   }
        // );
        this.onSelectMovie(null, screen, this.selectedMovieIndex);
      }
      this.dropLocation.screen = "-1";
    },
    dragEnter: debounce(function (
      screen,
      hour,
      minute,
      hourIndex,
      drop_date_time,
      movieData
    ) {
      console.log("dragEnter function is called 3763", drop_date_time);
      this.dropLocation.screen = screen;
      this.dropLocation.hour = hour;
      this.dropLocation.hourIndex = hourIndex;
      this.dropLocation.minute = minute - 1;
      this.dropLocation.drop_date_time = drop_date_time;
      // console.log(hour.split(":")[0])

      if (movieData && movieData.type === "newMovie") {
        this.selectedMovieIndex = null;
      }

      // done positionLeft = based on the distance from left considering the cinema open time and the time after 12AM
      let cinemaStartReduce =
        parseInt(this.CinemasSettings.cine_operation_start_time.split(":")[0]) *
        60;
      // this.dropLocation.positionLeft = parseInt(hourIndex)*50 + (this.dropLocation.minute)*50/6- (cinemaStartReduce/60)*50;
      this.dropLocation.positionLeft =
        parseInt(hour.split(":")[0]) * 50 +
        (this.dropLocation.minute * 50) / 6 -
        (cinemaStartReduce / 60) * 50;
      // this.dropLocation.positionLeft = parseInt(hour.split(":")[0])*60 + (this.dropLocation.minute-cinemaStartReduce)*50/6;
      // this.dropLocation.time = hour.split(":")[0] + ":";

      this.dropLocation.positionLeft = this.newGetScreenPositionCalc(
        hour,
        this.dropLocation.minute * 5
      );
      //TODO add end time in hours
      this.dropLocation.positionLeftEndTime = this.newGetScreenPositionCalc(
        hour,
        this.dropLocation.minute * 5
      );
      // console.log("droplocation", this.dropLocation.positionLeft);
      if (this.dropLocation.minute > 0) {
        this.dropLocation.time =
          hour.split(":")[0] +
          ":" +
          String(this.dropLocation.minute * 5).padStart(2, "0");
      } else {
        this.dropLocation.time = hour.split(":")[0] + ":00";
      }
      // console.log("time", this.dropLocation.time);

      // this.dropLocation.minute = minute;
    },
    20),
    openEditPopUp: function () {
      alert("popup");
    },
    onSelectMovie: function (event, screenIndex, movieIndex) {
      console.log(
        "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3814 ~ movieIndex",
        movieIndex
      );
      console.log(
        "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3814 ~ screenIndex",
        screenIndex
      );
      // check if past show.
      if (
        this.selectedMoviesInScreens[screenIndex] &&
        this.selectedMoviesInScreens[screenIndex].movies[movieIndex] &&
        this.selectedMoviesInScreens[screenIndex].movies[movieIndex].ss_id
      ) {
        const currentDateTime = momentT().tz(this.timeZone.tz_name);
        const selectedShowDate = moment(
          this.selectedMoviesInScreens[screenIndex].movies[movieIndex]
            .ss_actual_start_date
        ).format("YYYY-MM-DD");
        const selectedShowTime = moment(
          this.selectedMoviesInScreens[screenIndex].movies[movieIndex]
            .ss_start_show_time,
          "HH:mm"
        ).format("HH:mm");

        const selectedShowDateTime = moment(
          `${selectedShowDate} ${selectedShowTime}`,
          "YYYY-MM-DD HH:mm"
        );

        const isPastShow =
          moment(selectedShowDateTime).isBefore(currentDateTime);
        this.isPastShow = isPastShow;
        if (isPastShow) {
          // this.showFooterDetails = false;
          // // return this.$toasted.show("Past shows cannot be edited or deleted.");
          // return;
          this.showFooterDetails = true;
          this.isMovieCardSelected = true;
        }
      }
      this.showFooterDetails = true;
      this.clickSelectedMovies = [];
      this.selectedScreenIndex = screenIndex;
      this.selectedMovieIndex = movieIndex;
      this.selectedScreen = this.selectedMoviesInScreens[screenIndex];
      this.selectedScreenSeatTypes =
        this.selectedMoviesInScreens[screenIndex].screen_seat_types;
      this.movieSelected =
        this.selectedMoviesInScreens[screenIndex].movies[movieIndex];
      this.movieSelected =
        this.selectedMoviesInScreens[screenIndex].movies[movieIndex];
      console.log("this.movieSelected", this.movieSelected);
      let tempMoviesObject = this.selectedMoviesInScreens[screenIndex];
      if (!tempMoviesObject.movies[movieIndex].selected) {
        tempMoviesObject.movies[movieIndex].selected = true;
        this.isMovieCardSelected = true;
      } else {
        tempMoviesObject.movies[movieIndex].selected =
          !tempMoviesObject.movies[movieIndex].selected;
        this.isMovieCardSelected = !this.isMovieCardSelected;
      }
      if (tempMoviesObject.movies[movieIndex].selected == true) {
        this.clickSelectedMovies.push({
          screenIndex: screenIndex,
          movieIndex: movieIndex,
        });
      }

      console.log(
        "this.selectedMoviesInScreens :>> ",
        this.selectedMoviesInScreens
      );

      VueMain.set(this.selectedMoviesInScreens, screenIndex, tempMoviesObject);
      console.log(
        "this.selectedMoviesInScreens :>> ",
        this.selectedMoviesInScreens
      );

      setTimeout((x) => {
        this.selectedMoviesInScreens.map((x, index1) => {
          if (x.movies.length > 0) {
            x.movies.map((y, index2) => {
              // console.log(y,index2==movieIndex,index2,movieIndex,index1==screenIndex,index1,screenIndex)
              if (index1 == screenIndex && index2 == movieIndex) {
                let selectedStatus = this.scheduleStatusArray.filter(
                  (x) => x.status_id == y.ss_show_status
                );
                if (selectedStatus.length > 0) {
                  this.selectedStatus = selectedStatus[0].type;
                  this.selectedScheduleStatus = selectedStatus[0];
                }

                if (y.isNewSchedule) {
                  // alert(y.movie_title);
                  y.selected = true;
                  y.movie_title = y.movie_title + " ";
                  let arrayMap =
                    this.selectedMoviesInScreens[screenIndex][
                      "screen_seat_card_mapping"
                    ];

                  console.log("arrayMap", arrayMap);

                  let mapping_array = [];
                  arrayMap.map((z) => {
                    let rateCardStartTime = moment(
                      z.start_time,
                      "HH:mm"
                    ).format("DD-MM-YYYY HH:mm");

                    let rateCardEndTime = "";
                    if (
                      moment(z.end_time, "HH:mm").isBefore(
                        moment(z.start_time, "HH:mm")
                      )
                    ) {
                      rateCardEndTime = moment(z.end_time, "HH:mm")
                        .add(1, "days")
                        .format("DD-MM-YYYY HH:mm");
                    } else {
                      rateCardEndTime = moment(z.end_time, "HH:mm").format(
                        "DD-MM-YYYY HH:mm"
                      );
                    }
                    let startMovieTime = moment(y.start_time, "HH:mm").format(
                      "DD-MM-YYYY HH:mm"
                    );
                    let startMovieTime_temp = moment(
                      y.start_time,
                      "HH:mm"
                    ).format("DD-MM-YYYY HH:mm");

                    let cinemaStartDateTime = moment(
                      this.CinemasSettings.cine_operation_start_time,
                      "HH:mm"
                    ).format("DD-MM-YYYY HH:mm");

                    if (
                      moment(
                        moment(startMovieTime_temp, "DD-MM-YYYY HH:mm").format(
                          "YYYY-MM-DD HH:mm"
                        )
                      ).isSameOrAfter(
                        moment(moment().format("YYYY-MM-DD 00:00"))
                      ) &&
                      moment(
                        moment(startMovieTime_temp, "DD-MM-YYYY HH:mm").format(
                          "YYYY-MM-DD HH:mm"
                        )
                      ).isSameOrBefore(
                        moment(
                          moment(
                            cinemaStartDateTime,
                            "DD-MM-YYYY HH:mm"
                          ).format("YYYY-MM-DD HH:mm")
                        )
                      )
                    ) {
                      console.log("ADDING ONE DAY");
                      startMovieTime_temp = moment(
                        startMovieTime_temp,
                        "DD-MM-YYYY HH:mm"
                      )
                        .add(1, "d")
                        .format("DD-MM-YYYY HH:mm");
                    }

                    startMovieTime_temp = moment(
                      startMovieTime_temp,
                      "DD-MM-YYYY HH:mm"
                    ).format("YYYY-MM-DD HH:mm");
                    rateCardStartTime = moment(
                      rateCardStartTime,
                      "DD-MM-YYYY HH:mm"
                    ).format("YYYY-MM-DD HH:mm");
                    rateCardEndTime = moment(
                      rateCardEndTime,
                      "DD-MM-YYYY HH:mm"
                    ).format("YYYY-MM-DD HH:mm");

                    if (
                      moment(startMovieTime_temp).isBetween(
                        rateCardStartTime,
                        rateCardEndTime
                      )
                    ) {
                      mapping_array.push(z);
                    } else {
                    }
                  });

                  let isForeignMovie = "N";
                  if (
                    this.movieSelected &&
                    this.movieSelected.hasOwnProperty("is_foreign_movie") &&
                    this.movieSelected["is_foreign_movie"] &&
                    !this.authorizeClient(CLIENT_NAMES_OBJ.cinepolis_combo)
                  ) {
                    isForeignMovie =
                      this.movieSelected["is_foreign_movie"] || "N";
                  }

                  console.log("mapping_array OLD", [...mapping_array]);

                  mapping_array = mapping_array.filter(
                    (_ma) => _ma["is_foreign_rc"] == isForeignMovie
                  );

                  console.log(
                    "mapping_array NEW",
                    isForeignMovie,
                    mapping_array
                  );

                  if (mapping_array.length > 0) {
                    let newDate = new Date(
                      this.scheduleObject.sch_start_date
                    ).getDay();

                    let arrayDays = [
                      {
                        day: "is_sunday",
                        checkDay: 0,
                      },
                      {
                        day: "is_monday",
                        checkDay: 1,
                      },
                      {
                        day: "is_tuesday",
                        checkDay: 2,
                      },
                      {
                        day: "is_wednesday",
                        checkDay: 3,
                      },
                      {
                        day: "is_thursday",
                        checkDay: 4,
                      },
                      {
                        day: "is_friday",
                        checkDay: 5,
                      },
                      {
                        day: "is_saturday",
                        checkDay: 6,
                      },
                    ];

                    let checkInd = arrayDays.findIndex((days) => {
                      return days.checkDay == newDate;
                    });
                    // console.log(newDate,"date",arrayDays[checkInd].day)
                    x.screen_seat_types.map((seat_types, screenTypeIndex) => {
                      let arrayMapping = mapping_array.filter((st) => {
                        return (
                          st.screen_seat_type_id == seat_types.sst_id &&
                          st[arrayDays[checkInd].day] == "Y"
                        );
                      });
                      console.log(
                        "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3589 ~ x.screen_seat_types.map ~ arrayMapping",
                        arrayMapping
                      );

                      console.log(
                        "🚀 ~ file: ViewScheduleDD-1.vue ~ line 3597 ~ x.screen_seat_types.map ~ this.RatecardsList",
                        this.RatecardsList
                      );
                      if (arrayMapping.length > 0) {
                        arrayMapping.map((card) => {
                          let findIndexNew = this.RatecardsList.findIndex(
                            (r_c) => {
                              console.log(card, r_c, "sdfsdf", r_c.rc_g_id);
                              return card.rate_card_id == r_c.rc_g_id;
                            }
                          );
                          console.log(findIndexNew, card, card.rate_card_id);
                          if (
                            findIndexNew >= 0 &&
                            (this.selectedMoviesInScreens[screenIndex][
                              "movies"
                            ][movieIndex]["scheduleShowPrice"][screenTypeIndex]
                              .rate_card_id == "" ||
                              this.selectedMoviesInScreens[screenIndex][
                                "movies"
                              ][movieIndex]["scheduleShowPrice"][
                                screenTypeIndex
                              ].rate_card_id == null)
                          ) {
                            console.log("fdsfsdfsdfsdfsd");
                            this.onSelectScreenType(screenTypeIndex);
                            this.onSelectRateCard(
                              screenTypeIndex,
                              seat_types,
                              this.RatecardsList[findIndexNew]
                            );
                          } else {
                            console.log("2");
                            this.onDefaultRateCardEmpty(
                              screenIndex,
                              movieIndex,
                              screenTypeIndex
                            );
                          }
                        });
                      } else {
                        console.log("1");
                        this.onDefaultRateCardEmpty(
                          screenIndex,
                          movieIndex,
                          screenTypeIndex
                        );
                      }
                    });
                  }

                  if (this.autoSave) {
                    console.log("Auto Saving");
                    this.submitSchedule();
                  }
                } else {
                  x.screen_seat_types.map((seat_types, screenTypeIndex) => {
                    console.log(seat_types);
                    let filterArrr = y.scheduleShowPrice.filter((kk) => {
                      return seat_types.sst_id == kk.screen_seat_type_id;
                    });
                    console.log(filterArrr);
                    if (filterArrr.length > 0) {
                      let RateCardCheckInd = this.RatecardsList.findIndex(
                        (rc_card) => {
                          return (
                            filterArrr[0].rate_card_group_id == rc_card.rc_g_id
                          );
                        }
                      );

                      console.log(RateCardCheckInd);
                      if (RateCardCheckInd >= 0) {
                        this.onSelectScreenType(screenTypeIndex);
                        this.onSelectRateCard(
                          screenTypeIndex,
                          seat_types,
                          this.RatecardsList[RateCardCheckInd]
                        );
                      }
                    }
                  });
                }
              } else {
                y.selected = false;
                y.movie_title = y.movie_title.trim();
                this.$forceUpdate();
              }
            });
          }
        });

        if (!this.checkNoRateCard(this.movieSelected)) {
          console.log("WANT TO OPEN POPOVER");
          this.$root.$emit(
            "bv::show::popover",
            `Popover-${this.movieSelected.start_time}${this.movieSelected.screen}`
          );
        } else {
          console.log("WANT TO CLOSE POPOVER");
          this.$root.$emit(
            "bv::hide::popover",
            `Popover-${this.movieSelected.start_time}${this.movieSelected.screen}`
          );
        }
      }, 200);
    },
    getShowDateTimeWithOnlyShowtime: function (showtime) {
      let final_show_time = moment(showtime, "HH:mm");

      if (
        final_show_time.isSameOrAfter(
          moment(moment().format("YYYY-MM-DD 00:00"))
        ) &&
        final_show_time.isSameOrBefore(
          moment(this.CinemasSettings.cine_operation_start_time, "HH:mm")
        )
      ) {
        final_show_time.add(1, "d");
      }

      return final_show_time;
    },
    checkOverlapUsingShowtimes: function (
      new_start_date_time,
      new_end_date_time,
      movieIndex,
      screenIndex
    ) {
      let screen = this.selectedMoviesInScreens[screenIndex];
      let doesOverlap = false;
      for (let [mIndex, movie] of screen.movies.entries()) {
        if (mIndex != movieIndex) {
          let movie_start_date_time = moment(
            this.getShowDateTimeWithOnlyShowtime(movie.start_time).format(
              "YYYY-MM-DD"
            ) +
              " " +
              movie.start_time,
            "YYYY-MM-DD HH:mm"
          );

          let movie_end_date_time = moment(
            this.getShowDateTimeWithOnlyShowtime(movie.end_time).format(
              "YYYY-MM-DD"
            ) +
              " " +
              movie.end_time,
            "YYYY-MM-DD HH:mm"
          );

          if (
            new_start_date_time.isSameOrAfter(movie_start_date_time) &&
            new_start_date_time.isSameOrBefore(movie_end_date_time)
          ) {
            doesOverlap = true;
          } else if (
            new_end_date_time.isSameOrAfter(movie_start_date_time) &&
            new_end_date_time.isSameOrBefore(movie_end_date_time)
          ) {
            doesOverlap = true;
          }
        }
      }

      return doesOverlap;
    },
    arrowLeftRight: function () {
      event.preventDefault();

      if (
        (event.keyCode == 37 || event.keyCode == 39) &&
        this.checkStartTimeChageAllowed(this.movieSelected)
      ) {
        this.dropLocation.screen = -1;
        return false;
      }

      if (event.keyCode == 37 || event.keyCode == 39) {
        this.isChanged = true;
      }

      this.clickSelectedMovies.map((movieIndexes, index) => {
        let start_time = moment(this.movieSelected.start_time, "HH:mm");
        let end_time = moment(this.movieSelected.end_time, "HH:mm");

        let start_date_time = moment(start_time);
        let end_date_time = moment(end_time);

        if (event.keyCode == 37) {
          start_date_time.subtract(1, "minutes");
          end_date_time.subtract(1, "minutes");
        } else if (event.keyCode == 39) {
          start_date_time.add(1, "minutes");
          end_date_time.add(1, "minutes");
        }

        if (
          start_time.isSameOrAfter(
            moment(moment().format("YYYY-MM-DD 00:00"))
          ) &&
          start_time.isSameOrBefore(
            moment(this.CinemasSettings.cine_operation_end_time, "HH:mm")
          )
        ) {
          start_date_time.add(1, "d");
        }

        if (
          end_date_time.isSameOrAfter(
            moment(moment().format("YYYY-MM-DD 00:00"))
          ) &&
          end_date_time.isSameOrBefore(
            moment(this.CinemasSettings.cine_operation_start_time, "HH:mm")
          )
        ) {
          end_date_time.add(1, "d");
        }

        //======== CHECKING CINEMA OPERATION TIME ========

        let cinema_closing_date_time = this.getCinemaEndDateTime();

        let movie_schedule_time = moment(start_date_time, "HH:mm").format(
          "YYYY-MM-DD HH:mm"
        );

        //   let movie_schedule_time = moment(
        //   moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
        //     " " +
        //     moment(start_date_time).format("HH:mm"),
        //   "YYYY-MM-DD HH:mm"
        // );

        if (
          moment(movie_schedule_time).isSameOrAfter(
            moment(cinema_closing_date_time).format("YYYY-MM-DD HH:mm")
          ) &&
          (event.keyCode == 37 || event.keyCode == 39)
        ) {
          this.$toasted.show(
            "Cannot schedule a movie after cinema closing time. Cinema closing time is: " +
              this.CinemasSettings.cine_operation_end_time
          );
          this.dropLocation.screen = -1;
          return false;
        }

        let currTime = this.timeZone.tz_name
          ? momentT().tz(this.timeZone.tz_name)
          : moment();

        //ADDED KEYCODE 37 TO CHECK PAST TIME ONLY IF WE ARE MOVING TOWARDS LEFT

        if (
          event.keyCode == 37 &&
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") ==
            currTime.format("YYYY-MM-DD") &&
          moment(start_date_time.format("YYYY-MM-DD HH:mm")).isBefore(
            currTime.format("YYYY-MM-DD HH:mm")
          )
        ) {
          console.table({
            "event.keyCode ": event.keyCode,
            'currTime.format("YYYY-MM-DD")': currTime.format("YYYY-MM-DD"),
            'moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD")':
              moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"),
            'moment(start_date_time.format("YYYY-MM-DD HH:mm"))': moment(
              start_date_time.format("YYYY-MM-DD HH:mm")
            ),
          });

          this.$toasted.show("Cannot schedule movie in past time");
          this.dropLocation.screen = -1;
          return false;
        }

        //======== CHECKING CINEMA OPERATION TIME END ==========

        if (event.keyCode == 37) {
          let doesOverlap = this.checkOverlapUsingShowtimes(
            start_date_time,
            end_date_time,
            movieIndexes.movieIndex,
            movieIndexes.screenIndex
          );

          if (!doesOverlap) {
            this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
              movieIndexes.movieIndex
            ].start =
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start -
              50 / 60; // 50/12
            let new_start_time = start_time
              .subtract(1, "minutes")
              .format("HH:mm");
            let new_end_time = end_time.subtract(1, "minutes").format("HH:mm");
            this.movieSelected.start_time = new_start_time;
            this.movieSelected.end_time = new_end_time;
            this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
              movieIndexes.movieIndex
            ].start_time = new_start_time;
            this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
              movieIndexes.movieIndex
            ].end_time = new_end_time;

            if (
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start < 0
            ) {
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start = 0;
              this.movieSelected.start_time =
                this.CinemasSettings.cine_operation_start_time;
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start_time = this.CinemasSettings.cine_operation_start_time;
            }
          } else {
            this.$toasted.show("Overlap");
          }
        } else if (event.keyCode == 39) {
          let doesOverlap = this.checkOverlapUsingShowtimes(
            start_date_time,
            end_date_time,
            movieIndexes.movieIndex,
            movieIndexes.screenIndex
          );

          if (!doesOverlap) {
            this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
              movieIndexes.movieIndex
            ].start =
              this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
                movieIndexes.movieIndex
              ].start +
              50 / 60;
            let new_start_time = start_time.add(1, "minutes").format("HH:mm");
            let new_end_time = end_time.add(1, "minutes").format("HH:mm");
            this.movieSelected.start_time = new_start_time;
            this.movieSelected.end_time = new_end_time;
            this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
              movieIndexes.movieIndex
            ].start_time = new_start_time;
            this.selectedMoviesInScreens[movieIndexes.screenIndex].movies[
              movieIndexes.movieIndex
            ].end_time = new_end_time;
          } else {
            this.$toasted.show("Overlap");
          }
        }
      });
    },
    getCinemaEndDateTime: function () {
      let cinema_closing_date_time = moment(
        moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
          " " +
          this.CinemasSettings.cine_operation_end_time,
        "YYYY-MM-DD HH:mm"
      );

      if (
        moment(
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_end_time
        ).isSameOrBefore(
          moment(
            moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
              " " +
              this.CinemasSettings.cine_operation_start_time
          )
        )
      ) {
        cinema_closing_date_time = moment(
          moment(this.scheduleObject.sch_start_date)
            .add(1, "d")
            .format("YYYY-MM-DD") +
            " " +
            this.CinemasSettings.cine_operation_end_time,
          "YYYY-MM-DD HH:mm"
        );
      }

      return cinema_closing_date_time;
    },
    handleDrop: function (data, event) {
      let targetScreenIndex = this.dropLocation.screen;

      if (
        moment(
          moment(this.dropLocation.drop_date_time).format("YYYY-MM-DD")
        ).isBefore(momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD"))
      ) {
        console.table({
          'moment(moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"))':
            moment(
              moment(this.dropLocation.drop_date_time).format("YYYY-MM-DD")
            ),
          'momentT().tz(this.timeZone.tz_name).format("YYYY-MM-DD")': momentT()
            .tz(this.timeZone.tz_name)
            .format("YYYY-MM-DD"),
        });

        this.$toasted.show("Cannot Schedule for Past Date");
        this.dropLocation.screen = -1;
        return;
      }

      if (this.checkStartTimeChageAllowed(data.movie)) {
        this.dropLocation.screen = -1;
        return false;
      }

      if (data && data.isNoRuntime) {
        this.$toasted.show("Cannot schedule a movie without a Runtime");
        this.dropLocation.screen = -1;
        return;
      }

      if (this.autoSave && !this.validateAutoSaveDrag()) {
        this.dropLocation.screen = -1;
        this.$refs.warningNoRateCard.show();
        return false;
      }

      let cinema_closing_date_time = this.getCinemaEndDateTime();

      let movie_schedule_time = moment(
        this.dropLocation.drop_date_time,
        "YYYY-MM-DD HH:mm"
      );

      //  let movie_schedule_time = moment(
      //     moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") +
      //       " " +
      //       moment(this.dropLocation.drop_date_time).format("HH:mm"),
      //     "YYYY-MM-DD HH:mm"
      //   );

      if (movie_schedule_time.isSameOrAfter(cinema_closing_date_time)) {
        this.$toasted.show(
          "Cannot schedule a movie after cinema closing time. Cinema closing time is: " +
            this.CinemasSettings.cine_operation_end_time
        );
        this.dropLocation.screen = -1;
        return;
      }

      console.log(
        moment(movie_schedule_time).format("YYYY-MM-DD HH:mm"),
        "movie_schedule_time %^$%^"
      );
      console.log(
        moment(cinema_closing_date_time).format("YYYY-MM-DD HH:mm"),
        "cinema_closing_date_time"
      );

      let movieTime = moment(
        `${this.dropLocation.hour.split(":")[0]}:${
          this.dropLocation.minute * 5
        }`,
        "HH:mm"
      );

      if (movieTime.isValid()) {
        let currTime = this.timeZone.tz_name
          ? momentT().tz(this.timeZone.tz_name)
          : moment();

        let movieDateTime = moment(
          `${moment(this.dropLocation.drop_date_time).format(
            "YYYY-MM-DD"
          )}:${moment(this.dropLocation.time, "HH:mm").format("HH:mm")}`
        );

        if (
          moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD") ==
            currTime.format("YYYY-MM-DD") &&
          moment(movieDateTime.format("YYYY-MM-DD HH:mm")).isBefore(
            currTime.format("YYYY-MM-DD HH:mm")
          )
        ) {
          console.table({
            'moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD")':
              moment(this.scheduleObject.sch_start_date).format("YYYY-MM-DD"),
            'currTime.format("YYYY-MM-DD")': currTime.format("YYYY-MM-DD"),
            'moment(movieDateTime.format("YYYY-MM-DD HH:mm"))': moment(
              movieDateTime.format("YYYY-MM-DD HH:mm")
            ),
          });

          this.$toasted.show("Cannot schedule movie in past time");
          this.dropLocation.screen = "-1";
          return false;
        }

        this.isChanged = true;
        let draggedMovie = data.movie;
        draggedMovie.start = this.dropLocation.positionLeft;

        // If yes, then remove old position of movie, if 1 do nothing, else copy/move
        let createMovie = 0;

        if (this.dropLocation.screen >= 0) {
          let screen_id = parseInt(this.dropLocation.screen);

          if (this.selectedMoviesInScreens[screen_id].totalSeatLayout <= 0) {
            this.$toasted.show(
              `No Seat Layout for screen ${this.selectedMoviesInScreens[screen_id]["screen_name"]}`
            );
            return false;
          }
        }
        if (this.dropLocation.screen >= 0) {
          let movie = data.movie;
          let movieType = data.type;
          let screen_id_index = parseInt(this.dropLocation.screen);
          let screen = this.selectedMoviesInScreens[screen_id_index];

          if (screen.videoFormats && movie.mf_id) {
            let videoFormats = screen.videoFormats.map((vf) => vf.mf_id);

            if (!videoFormats.includes(movie.mf_id)) {
              this.$toasted.show(
                `${
                  this.selectedMoviesInScreens[screen_id_index]["screen_name"]
                } ${this.$t("videoFormatErrorPopup")}`
              );
              this.dropLocation.screen = "-1";
              return false;
            }
          }
        }
        if (this.dropLocation.screen >= 0) {
          let movie = data.movie;
          let movieType = data.type;
          let screen_id_index = parseInt(this.dropLocation.screen);
          let screen = this.selectedMoviesInScreens[screen_id_index];

          if (
            screen.soundFormats &&
            screen.soundFormats.length &&
            movie.sound_format_id
          ) {
            let soundFormats = screen.soundFormats.map(
              (sf) => sf.sound_format_id
            );
            console.log({
              soundFormats,
              sound_format_id: movie.sound_format_id,
            });

            if (!soundFormats.includes(movie.sound_format_id)) {
              this.$toasted.show(
                `${
                  this.selectedMoviesInScreens[screen_id_index]["screen_name"]
                } ${this.$t("soundFormatErrorPopup")}`
              );
              this.dropLocation.screen = "-1";
              return false;
            }
          }
        }
        if (this.dropLocation.screen >= 0) {
          let movie = data.movie;
          let movieType = data.type;
          let screen_id_index = parseInt(this.dropLocation.screen);
          let screen = this.selectedMoviesInScreens[screen_id_index];

          if (
            movie.hasOwnProperty("mss_ss_start_date") &&
            movie.hasOwnProperty("mss_ss_end_date")
          ) {
            if (!movie.mss_ss_start_date || !movie.mss_ss_end_date) {
              this.$toasted.show(`${this.$t("licenseDateErrorPopup")}`);
              // this.dropLocation.screen = "-1";
              // return false;
            }

            if (!!this.scheduleObject.sch_start_date) {
              let schStartDate = moment(this.scheduleObject.sch_start_date);
              let licStartDate = moment(movie.mss_ss_start_date);
              let licEndDate = moment(movie.mss_ss_end_date);

              if (
                !schStartDate.isBetween(licStartDate, licEndDate, "days", "[]") // all inclusive
              ) {
                this.$toasted.show(`${this.$t("licenseDateErrorPopup")}`);
                // this.dropLocation.screen = "-1";
                // return false;
              }
            }
          }
        }

        let overlap = this.checkOverLapMovie(
          draggedMovie,
          this.dropLocation.screen
        );

        if (overlap.status) {
          let indexNew = parseInt(overlap.screen);
          if (indexNew >= 0) {
            let findIndexMovies = this.selectedMoviesInScreens[
              indexNew
            ].movies.findIndex((xMovies) => {
              return (
                xMovies.movie_details_id == data.movie.movie_details_id &&
                xMovies.start_time == data.movie.start_time
              );
            });
            if (findIndexMovies >= 0) {
              this.selectedMoviesInScreens[indexNew]["movies"][findIndexMovies][
                "start"
              ] = this.draggedObject.oldStart;

              // this.selectedMoviesInScreens[indexNew]["movies"].splice(
              //   findIndexMovies,
              //   1
              // );
            }
          }

          this.dropLocation = this.dropLocationClone;
          this.$toasted.show(
            `Movie Overlapped with ${overlap.movie.movie_title} starting at ${overlap.movie.start_time} and ending at  ${overlap.movie.end_time}`,
            {
              duration: 5000,
            }
          );
          this.dropLocation.screen = -1;

          return;
          //TO DO show toast message
          // alert('overlap new'+ this.dropLocation.screen+JSON.stringify(draggedMovie))
        } else {
          this.createMovie(draggedMovie, this.dropLocation.screen);
          if (data.type == "presentMovie") {
            //Delete original Movie

            let tempMoviesObject =
              this.selectedMoviesInScreens[this.draggedObject.screen];

            tempMoviesObject.movies.splice(this.draggedObject.movie, 1);

            this.selectedMovieIndex =
              this.selectedMoviesInScreens[targetScreenIndex].movies.length - 1;

            this.onSelectMovie(
              null,
              targetScreenIndex,
              this.selectedMovieIndex
            );

            VueMain.set(
              this.selectedMoviesInScreens,
              this.draggedObject.screen,
              tempMoviesObject
            );
            this.$forceUpdate();
          }
        }
      } else {
        console.log("========= NO VALID TIME ======", this.dropLocation);
      }

      console.log("return");
      this.dropLocation.screen = -1;
      return;
    },
    closeModalSection: function () {},
    generateMovieListDuplicateDay() {
      const moviesToSchedule = [];
      const movieScreens = {};
      this.validScreenList.forEach((screen) => {
        if (!movieScreens[screen.screen_id]) {
          movieScreens[screen.screen_id] = { ...screen };
        }
      });
      console.log(this.selectedMoviesInScreens, "selectedMoviesInScreens");
      this.selectedMoviesInScreens.forEach((selectedMovie) => {
        const filteredMovies = selectedMovie.movies.filter((movie) => {
          return !movie.mycinema_booking_type_id && !movie.isNewSchedule;
        });
        console.log({ filteredMovies });
        moviesToSchedule.push(...filteredMovies);
      });

      moviesToSchedule.forEach((movie) => {
        movie["sales_channel_changes"] = [];
        this.aggregatorUsersList.map((user) => {
          const salesChannelExist = movie["sales_channel"].find(
            (salesChannel) => {
              return salesChannel.user_id == user.user_id;
            }
          );

          if (!salesChannelExist) {
            movie["sales_channel_changes"].push({
              ...user,
              is_changed: true,
              value: "N",
            });
          }
        });

        const scheduleShowPricing = [];
        movie.scheduleShowPrice.forEach((showPrice) => {
          scheduleShowPricing.push({
            ...showPrice,
            rc_g_name: showPrice.rc_name,
            selected_rate_card: {
              rc_g_id: showPrice.rate_card_group_id || null,
              rc_id: showPrice.rc_id || null,
              rc_g_name: showPrice.rc_name || null,
            },
          });
        });

        // week-days generation
        movie["weekDayArray"] = _.cloneDeep(this.weekDaysArray);
        movie["weekDayArray"].forEach((weekDay) => {
          weekDay["scheduling_price"] = _.cloneDeep(scheduleShowPricing);
          if (
            (weekDay.day || weekDay.day == 0) &&
            this.defaultRateCardDuplicate
          ) {
            const updatedSchedulePricing =
              this.onAttachRateCardDayWiseScreenDuplicate(
                movieScreens[movie.screen_id],
                movie,
                weekDay.day
              );
            if (updatedSchedulePricing && updatedSchedulePricing.length) {
              weekDay["scheduling_price"] = _.cloneDeep(updatedSchedulePricing);
            }
          }
        });
        movie["rateCardCollapse"] = false;
        movie["screen_name"] =
          movieScreens[movie.screen_id]["screen_name"] || "-";
        // movie["screen_seat_types"]=movieScreens[movie.screen_id]["screen_seat_types"] || []
        movie["screen_data"] = movieScreens[movie.screen_id];
      });

      console.log({ moviesToSchedule });

      this.duplicateDayMovieList = moviesToSchedule;
      console.log(
        this.selectedMultiShowSchedule,
        "this.selectedMultiShowSchedule"
      );
    },
    handleDuplicateDayUpdation() {
      this.$refs.duplicateDay.hide();
    },
  },
};
</script>

<style>
.zoom9 {
  zoom: 0.9;
}

.left-nav {
  width: 280px;
  min-width: 280px;
}

.defaultRateCardSelect .multiselect__single {
  color: #f3ba12 !important;
}

.defaultRateCardSelecttext {
  color: #f3ba12 !important;
}

.placeholder-red .multiselect__placeholder {
  color: red !important;
}

.nav-underline .nav-link {
  padding: 5px;
  color: grey;
  position: relative;
  border-width: 0 !important;
  border-color: transparent !important;
}

.nav-underline .nav-link.active {
  color: var(--blue);
  font-weight: 500;
}

.nav-underline .nav-link.active:after {
  left: 0;
  bottom: 0;
  content: "";
  width: 100%;
  height: 2px;
  display: block;
  position: absolute;
  background-color: var(--blue);
}

.schedule-info-sticky {
  position: fixed;
  left: 51%;
  min-width: 890px;
  bottom: 15px;
  font-size: 14px;
  z-index: 9991;
  padding: 15px 15px 15px 15px;
  /* padding: 25px 15px 25px 15px; */
  border-radius: 5px;
  background-color: white;
  transform: translateX(-50%);
  box-shadow: 0px 2.5px 5px 5px #80808021;
  /* height: 94px; */
  color: black;
}

.custom-caret::after {
  top: 47.5%;
  right: 0px;
  width: 7px;
  content: "";
  height: 7px;
  display: block;
  position: absolute;
  transform: rotate(-45deg);
  border-left: 1.5px solid grey;
  border-bottom: 1.5px solid grey;
}

.no_rc_popover {
  z-index: 98 !important;
}

.schedule-price-dropdown {
  left: 0;
  width: 100%;
  position: absolute;
  border-radius: 5px;
  max-height: 70vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  bottom: calc(100% + 5px);
  z-index: 99;
  border: 1px solid #d3d3d3;
}

.cursor-pointer {
  cursor: pointer;
}

.hover-card-list:hover,
.hover-card-list:active,
.hover-card-list.active,
.hover-card-list:focus {
  background-color: var(--blue);
  color: #fff;
}

.date-arrow {
  padding-top: 8px;
  z-index: 100;
}

.date-arrow-left {
  margin-right: -10px;
}

.date-arrow-right {
  margin-left: -15px;
}

.h-50 {
  height: 50px !important;
}

.w-60 {
  width: 60px !important;
}

.plus-minus-btn {
  color: #fff;
  border: none;
  display: block;
  font-size: 35px;
  padding: 0 10px;
  margin: 0 15px;
  border-radius: 8px;
  background-color: var(--primary);
}

.outerWrapperToogle {
  position: absolute;
}

.movie-sidebar-toggler {
  width: 45px;
  height: 45px;
  border: none;
  user-select: none;
  /* border-radius: 50%; */
  position: relative;
  transform: translateY(-50%);
  /* background-color: transparent; */
  background: white;
}

.movie-sidebar-toggler.outer {
  /* top: 20px; */
  top: 9px;
  left: 60%;
}

.movie-sidebar-toggler.inner {
  top: 20px;
  position: absolute;
  left: 15%;
  height: 40px;
  line-height: 34px;
  border-radius: 0px 0px 0px 0px;
  margin-right: 20px;
  z-index: 65;
  width: 75px;
  background: white;
}

.movie-sidebar-toggler:hover {
  /* background-color: #ffffff1c; */
}

.movie-sidebar-toggler span {
  font-size: 40px;
  font-weight: 500;
  color: var(--primary);
}

/* .movie-sidebar-toggler span {
  height: 2px;
  width: 70%;
  margin: 0 auto;
  display: block;
  background-color: #000000;
} */

/* .movie-sidebar-toggler span:nth-child(2) {
  margin-top: 5px;
  margin-bottom: 5px;
} */

.movietoggleOff {
  width: 0px !important;
  min-width: 0px !important;
  position: relative;
  -webkit-transition: width 0.4s ease;
  transition: width 0.4s ease;
}

.movietoggleOn {
  -webkit-transition: width 0.4s ease;
  transition: width 0.4s ease;
}

.zoomInBtn {
  cursor: pointer;
  display: inline-block;
  vertical-align: top;
  color: black;
  margin-right: 9px;
  margin-bottom: 13px;
  width: 30px;
  height: 30px;
  line-height: 26px;
  font-size: 30px;
  font-family: monospace;
  text-align: center;
  border-radius: 50%;
  background: #c9c9c9;
}

.zoomInBtn.disable {
  opacity: 0.5;
  cursor: not-allowed;
}

.grid-seat-buttons {
  display: grid;
  grid-template-columns: repeat(10, 10%);
  /* justify-content: center; */
  justify-items: center;
  align-items: baseline;
}

.grid-seat-buttons .pos-seat {
  width: 30px;
}

.grid-seat-buttons p {
  text-align: center;
  margin-bottom: 0;
  font-size: 10px;
  padding-top: 5px;
  line-height: 14px;
}

.status-red-2 {
  /* border-left: 4px solid red; */
  background: #ff000026;
}

.status-yellow-2 {
  /* border-left: 4px solid gold; */
  background: #ffd70042;
}

.status-green-2 {
  /* border-left: 4px solid green; */
  background: #00800054;
}

.status-private {
  /* border-left: 4px solid green; */
  background: #add8e6;
}

.status-lightgreen-2 {
  background: #88f58842;
}

.status-grey-2 {
  background: #b5b6b742;
}

.movieTitle {
  font-weight: bold;
  white-space: nowrap;
}

.screenName span {
  width: 72px !important;
  top: 43% !important;
}

.w-90 {
  width: 90% !important;
}

.conflictTable {
  table-layout: auto !important;
  white-space: nowrap;
  border-radius: 10px;
  margin-bottom: 50px;
  background-color: #fff;
}

.listviewtable {
  table-layout: fixed !important;
  width: 100%;
}

.listviewtable th,
.listviewtable td {
  padding: 5px 10px 5px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.w-60 {
  width: 60px;
}

.w-11p {
  width: 11%;
}

.conflictTable .cell {
  border-collapse: collapse;
  border: 1px solid lightgrey;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 5px 10px;
}

.noPadding {
  padding: 0 0px 0 17px !important;
}

.h-45 {
  height: 45px;
}

.popheader {
  background-color: #00adff29;
}

.my-popover-class .popover-header {
  background-color: #00adff29;
}

.my-popover-class {
  max-width: 360px !important;
}

.fs-13 {
  font-size: 13px;
}

.vue__time-picker-dropdown {
  z-index: 5000;
}

.table_wrapper {
  overflow-x: auto;
}

.table_wrapper .swc-report {
  overflow: visible;
  overflow-x: unset !important;
}

.tablePadding th,
.tablePadding td {
  padding: 5px 10px 5px 10px;
}

.table_wrapper .vue__time-picker .dropdown,
.table_wrapper .vue__time-picker .dropdown .select-list {
  height: 8rem !important;
}

.bg-lightbg {
  background: #dfdfdf63;
}

.fixedWidth-10 {
  width: 7%;
  max-width: 7%;
}

.rateCardCollapse-table {
  zoom: 0.9;
  width: 95%;
  margin: auto;
}

.collaplsePlusMinusBtn {
  font-size: 28px;
  line-height: 0px;
  font-weight: 500;
  color: #3876d2;
}

.collaplsePlusMinusBtn::after {
  transition: 0.3s ease;
  transform: translateY(-50%) rotate(180deg);
}

.rotate-btn {
  transform: rotate(180deg);
}

.indicator-border-sch {
  border-bottom: 4px solid orange;
}

.customerDetailsTable td {
  padding: 5px !important;
}

.scrollTable {
  width: 100%;
  overflow-x: auto !important;
  table-layout: auto !important;
}

.tableRc {
  width: 100%;
  table-layout: auto !important;
  zoom: 0.9;
}

.w-230 {
  width: 240px !important;
}

.w-230 .multiselect__single,
.dropDownElipsis .multiselect__single {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selectCinemaDandD .multiselect__content-wrapper {
  z-index: 70 !important;
}

.selectCinemaDandD .multiselect--active {
  z-index: 70 !important;
}

.copy_list_wrapper {
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 75%;
}

.disBtnStyle {
  opacity: 0.5;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ScheduleComponents/viewScheduleDD-2.vue